// Scripts level Theme customisation goes here// Scripts level Theme customisation goes here
function extractCollectionNameFromURL(url) {
    const collectionPart = url.split("/collections/")[1];
    if (collectionPart) {
        const collectionName = collectionPart.split("?")[0];
        return collectionName;
    }
    return null;
}
function checkWizzyfiltersApplied(url) {
  const hasCollections = url.includes('/collections');
  const hasLimit20 = url.includes('attributeFacetValuesLimit');

  console.log(hasCollections,hasLimit20,">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
  return hasCollections && hasLimit20;
}
window.onWizzyScriptLoaded = function() {

    var flagForAutocomplete = false;
  
    changeTemplate("wizzy-search-results-product");
    changeTemplate("wizzy-search-results");
    changeTemplate("wizzy-autocomplete-topproducts");
    changeTemplate("wizzy-search-wrapper");
    changeTemplate("wizzy-facet-block");
    changeTemplate("wizzy-search-sort");

    ////////////////////////Default collecton + wizzy collection//////////////////////////////////////////


window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
        function(data) {
          
          if(checkWizzyfiltersApplied(window.location.href))
          {
            console.log("<<<<loaction href",$(".CollectionMain"))
            let collectionItems = $(".CollectionMain")
            if(collectionItems.length > 0) {
              console.log("collectionItems", collectionItems);
              collectionItems.html("");
              collectionItems.css("display", "none");
            }
          }
          return data;
        })

  
    $("body").on("click", ".wizzy-common-select-option", function() {
        let collectionItems = $(".CollectionMain")
        if(collectionItems) {
          collectionItems.html("");
          collectionItems.css("display", "none");
        }
    });

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_FILTER_ITEM_CLICKED,
        function(data) {
          console.log("<===AFTER_FILTER_ITEM_CLICKED");
            let collectionItems = $(".CollectionMain");
            if(collectionItems) {
              collectionItems.html("");
              collectionItems.css("display", "none");
            }

            return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
        function(data) {
          flagForAutocomplete = true;
          return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
        function(data) {
            let collectionItems = $(".CollectionMain");
            if (collectionItems) {
              collectionItems.html("");
              collectionItems.css("display", "none");
            }
            return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function(data) {

          let id = setInterval(function() {
            if(window._swat) {
              window._swat.initializeActionButtons(".wizzy-search-results");       
            }
            clearInterval(id);
          }, 1000)
          
          if(window.wizzyConfig.common.isOnCategoryPage && !flagForAutocomplete) {
            if (window.location.search.length < 100) {
              data = [];
            }else {
              let collectionItems = $(".CollectionMain");
              if(collectionItems) {
                collectionItems.html("");
                collectionItems.css("display", "none");
              }
            }
          }else {
            flagForAutocomplete = false;
          }
            
            return data;
        }
    );


    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
        function(data) {
          console.log(data, "<===AFTER_WIZZY_API_RESPONDED")  
          return data;
        }
    );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED, function(data) {

      let id = setInterval(function() {
        if(window._swat) {
          window._swat.initializeActionButtons(".wizzy-search-results");       
        }
        clearInterval(id);
      }, 1000)
      
      
      return data;
    });

    //////////////////////////////////////////////////////end////////////////////////////////////////////

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
        function(payload) {

          window.theme.searchMode = "product";

            payload.common.lazyDOMConfig.identifiersToHideOnSearch.push(".template-collection .PageHeader");
            
            payload.autocomplete.searchBar.hasAnimatedPlaceholders = false;
            payload.common.lazyDOMConfig.searchInputIdentifiers[0] = {
                dom: "input.Search__Input.Heading",
                type: "search",
            };

            if (typeof payload.search?.configs?.facets?.configs !== "undefined") {
                payload.search.configs.facets.configs.push({
                    label: "Colors",
                    key: "product_main_wz_color",
                    position: "top",
                    order: 12,
                });
            }
            payload["search"]["configs"]["pagination"]["infiniteScrollOffset"] = {
                desktop: 3500,
                mobile: 3700,
            };

            if (document.documentElement.clientWidth < 768) {
                window.wizzyConfig.filters.configs.displayAsDrawer = true;
                let totalFacet = payload.search.configs.facets.configs.length;

                for (let i = 0; i < totalFacet; i++) {
                    payload.search.configs.facets.configs[i].position = "left";
                }
            }
            let colTitle = extractCollectionNameFromURL(window.location.href);
            if (colTitle) {
                payload.common.lazyDOMConfig.contentDOMIdentifiers[0] =
                    ".wizzy-collection-dom";
            } else {
                payload.common.lazyDOMConfig.contentDOMIdentifiers[0] =
                    "#main";

            }
            return payload;
        }
    );

  //////////////////////wizzy-advance-collection////////////////////////////////////////////////////
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      if( extractCollectionNameFromURL(window.location.href)=='advanced-search')
      {
      let totalFacet = payload.search.configs.facets.configs.length;
      for (let i = 0; i < totalFacet; i++) {
        payload.search.configs.facets.configs[i].position = "left";
      }
    }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if( extractCollectionNameFromURL(window.location.href)=='advanced-search')
      {
        $("body").attr("id", "wizzy-advance-search-col");
      }
      return payload;
    })
   window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
        function(data) {
    $('body').removeAttr('id', 'wizzy-advance-search-col');
          
          let totalFacet = data.facets.length;
      for (let i = 0; i < totalFacet; i++) {
        data.facets[i].position = "top";
      }
            console.log(data,"before--search")
          return data;
        }
    );
 /////////////////////////////end-advanced-collection///////////////////////////////////////////////
  
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
        function(data) {
          data.suggestions.forEach((data)=>{
                data.label = data.label.replace(/2023/g, "2024");
          })
          return data;
        })

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function(payload) {
          
            payload.response.payload.facets.forEach((facet) => {
                if (Array.isArray(facet.data)) {
                    const myMap = new Map();

                    facet.data.forEach((data) => {
                        if (myMap.get(filterKeyData[data.key])) {
                            let value = myMap.get(filterKeyData[data.key]);
                            value.count = parseInt(value.count) + parseInt(data.count);
                            myMap.set(filterKeyData[data.key], value);
                        } else {
                            if (filterKeyData[data.key])
                                myMap.set(filterKeyData[data.key], data);
                            else myMap.set(data.key, data);
                        }
                        const valuesArray = Array.from(myMap.values());
                        facet.data = valuesArray;
                    });
                }
            });

            return payload;
        }
    );
    let filterKeyData = {
        "Short Sleeve": "Short-Sleeve",
        "Short-Sleeve": "Short-Sleeve",
        "Ball Gown": "Ball Gown",
        "Ball Gowns": "Ball Gown",
    };
    let filtersToAppend = {
        "Short-Sleeve": ["Short Sleeve", "Short-Sleeve"],
        "Ball Gown": ["Ball Gown", "Ball Gowns"],
    };
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
        function(payload) {

          document.querySelectorAll('.ProductItem').forEach(productItem => {
    if (!productItem.dataset.hiddenSwatchCount) {
        const swatchGroup = productItem.querySelector('.product-item-swatch-group');
        if (swatchGroup) {
            const swatchItems = swatchGroup.querySelectorAll('.product-item-swatch-item');
            if (swatchItems.length > 4) {
                swatchItems.forEach((swatchItem, index) => {
                    if (index >= 4) {
                        swatchItem.classList.add('hidden-swatch');
                    }
                });

                const hiddenSwatchCount = swatchItems.length - 4;

                const hiddenSwatchCountElement = document.createElement('div');
                hiddenSwatchCountElement.textContent = `+${hiddenSwatchCount}`;
                hiddenSwatchCountElement.classList.add('hidden-swatch-count');
                hiddenSwatchCountElement.classList.add('product-item-swatch-item');

                swatchGroup.appendChild(hiddenSwatchCountElement);

                productItem.dataset.hiddenSwatchCount = true;
            }
        }
    }
});


            // console.log(payload, "<===BEFORE_FILTERS_EXECUTED");
          
            if (payload.filters && typeof payload.filters.attributes === "object") {
                for (const [key, value] of Object.entries(payload.filters.attributes)) {
                    let data = [];

                    value.forEach((item) => {
                        if (filtersToAppend[item]) {
                            filtersToAppend[item].forEach((element) => {
                                data.push(element);
                            });
                        } else {
                            data.push(item);
                        }
                        let filterKeys =
                            JSON.parse(sessionStorage.getItem("filterKeys")) || [];

                        // Push the current key into the array if it's not already present
                        if (!filterKeys.includes(item)) {
                            filterKeys.push(item);
                        }
                        sessionStorage.setItem("filterKeys", JSON.stringify(filterKeys));
                    });

                    let filterKeys =
                        JSON.parse(sessionStorage.getItem("filterKeys")) || [];

                    const newData = filterKeys.filter((filterKey) => {
                        if (!data.includes(filterKey)) {
                            if (filtersToAppend[filterKey]) {
                                const foundArray = filtersToAppend[filterKey];
                                data = data.filter((item) => !foundArray.includes(item));
                            }
                            return false;
                        }
                        return true;
                    });

                    sessionStorage.setItem("filterKeys", JSON.stringify(newData));

                    payload.filters.attributes[key] = data;
                }
            }
            return payload;
        }
    );

   window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function(payload) {
          if (window.innerWidth > 768) {
            payload.forEach((product) => {
              if(product.mainImage&&product.mainImage.length)
              product.mainImage = product.mainImage.replaceAll('_340x', '_840x');
              if(product.hoverImage&&product.hoverImage.length)
              product.hoverImage = product.hoverImage.replaceAll('_340x', '_840x');

              // product.hoverImage.replaceAll('_340x','_840x');
            })
            console.log(payload,"<<<========after products transform")
          }

            return payload;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function(payload) {
            payload.forEach((product) => {
                if (product.swatches && product.swatches.length) {
                    product.swatches[0]?.values?.forEach((swatchData) => {
                        swatchData.isSwatch = true;
                        swatchData.swatch = {
                            type: "text",
                            value: swatchData.value,
                        };
                        swatchData.swatchValue = colorData[swatchData.value];
                    });
                }
            });

            return payload;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function(payload) {
            payload.response.payload.facets.forEach((facet) => {
                if (facet.key == "product_main_wz_color") {
                    facet.data.sort((a, b) => {
                        if (a.key < b.key) {
                            return -1;
                        }
                        if (a.key > b.key) {
                            return 1;
                        }
                        return 0;
                    });
                }

                if (!(facet.key == "sellingPrice" || facet.key == "sizes")) {
                    facet.data.sort((a, b) => {
                        if (a.key < b.key) {
                            return -1;
                        }
                        if (a.key > b.key) {
                            return 1;
                        }
                        return 0;
                    });
                }
            });

            return payload;
        }
    );

    $("body").on(
        "click",
        ".wizzy-filters-facet-block.facet-block-top",
        function(e) {
            let {
                left,
                top
            } = $(this).position();
            $(".wizzy-filter-wrapper").css({
                left: left - 50,
                top: top - 284, // Adjust the top position as needed
            });
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
        function(data) {

    //        $('.autocomplete-link em').click(function() {
    //          $(this).closest('.autocomplete-item').click();
    
    // });
// $('.autocomplete-link').click(function() {
//         alert("Link clicked!");
//         // Add your existing click logic for the entire link here
//     });

            let colTitle = extractCollectionNameFromURL(window.location.href);
            if (colTitle) {
                colTitle = colTitle.replace(/-/g, " ").toUpperCase();
                $(".wizzy-collection-title").text(colTitle);
            }
            return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function(data) {
            data.response.payload.facets.forEach((data) => {
                if (data.label == "Colors") {
                    data.order = 1;
                } else if (data.label == "SIZE") {
                    data.order = 2;
                } else if (data.label == "DESIGNER") {
                    data.order = 3;
                } else if (data.label == "PRICE") {
                    data.order = 4;
                } else if (data.label == "OCCASION") {
                    data.order = 5;
                } else if (data.label == "LENGTH") {
                    data.order = 6;
                } else if (data.label == "SILHOUETTE") {
                    data.order = 7;
                } else if (data.label == "NECKLINE") {
                    data.order = 8;
                } else if (data.label == "SLEEVE") {
                    data.order = 9;
                } else if (data.label == "WAISTLINE") {
                    data.order = 10;
                } else if (data.label == "EMBELLISHMENT TYPE") {
                    data.order = 11;
                } else if (data.label == "SLIT") {
                    data.order = 12;
                }
            });
            return data;
        }
    );
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function(data) {
            let facets = data.response.payload.facets;
            for (let i = 0; i < facets.length; i++) {
                if (facets[i].key == "sizes") {
                    let sizes = facets[i].data;
                    let numbers = [];
                    let letters = [];

                    let newArray = new Array();
                    let temp = [
                        "000",
                        "00",
                        "0",
                        "2",
                        "4",
                        "6",
                        "8",
                        "10",
                        "12",
                        "14",
                        "16",
                        "18",
                        "20",
                        "22",
                        "24",
                        "26",
                        "28",
                        "30",
                        "32",
                        "34",
                        "36",
                        "XXS",
                        "XS",
                        "S",
                        "M",
                        "L",
                        "XL",
                        "XXL",
                        "2XL",
                        "3XL",
                        "4XL",
                        "5XL",
                        "6XL",
                    ];
                    for (let j = 0; j < temp.length; j++) {
                        for (let k = 0; k < sizes.length; k++) {
                            if (sizes[k].key == temp[j]) newArray.push(sizes[k]);
                        }
                    }

                    // for (let index = 0; index < numbers.length; index++) {
                    //   newArray.push(numbers[index]);
                    // }

                    facets[i].data = newArray;
                }
            }

            return data;
        }
    );

    document.body.addEventListener("click", function(event) {
        const targetClass = event.target.classList;

        if (targetClass.contains("wizzy-2-products-in-a-row")) {
            handleRangeInputValueChange(2);
            $(".wizzy-4-products-in-a-row").css("opacity", 0.5);
            $(".wizzy-2-products-in-a-row").css("opacity", 1);
        } else if (targetClass.contains("wizzy-4-products-in-a-row")) {
            $(".wizzy-4-products-in-a-row").css("opacity", 1);
            $(".wizzy-2-products-in-a-row").css("opacity", 0.5);
            handleRangeInputValueChange(4);
        }
    });

    function handleRangeInputValueChange(value) {
        let x = document.querySelector(".wizzy-search-results");
        if (typeof x != "undefined") {
            if (x.classList.contains("wizzy-2-products-in-a-row")) {
                x.classList.remove("wizzy-2-products-in-a-row");
            }

            if (x.classList.contains("wizzy-4-products-in-a-row")) {
                x.classList.remove("wizzy-4-products-in-a-row");
            }

            sessionStorage.setItem("wizzy-2-products-in-a-row", false);
            sessionStorage.setItem("wizzy-4-products-in-a-row", false);
            x.classList.add("wizzy-" + value + "-products-in-a-row");
            sessionStorage.setItem("wizzy-" + value + "-products-in-a-row", true);
        }
    }

    function toHandleComingBackFromProductPage() {
        let waitForInputToLoad = setInterval(function() {
            let CBrangeInputForGrid = document.querySelector(".wizzy-search-results");
            if (CBrangeInputForGrid != null && CBrangeInputForGrid != undefined) {
                if (sessionStorage.getItem("wizzy-2-products-in-a-row") === "true") {
                    handleRangeInputValueChange(2);
                    $(".wizzy-4-products-in-a-row").css("opacity", 0.5);
                    $(".wizzy-2-products-in-a-row").css("opacity", 1);
                } else if (
                    sessionStorage.getItem("wizzy-4-products-in-a-row") === "true"
                ) {
                    $(".wizzy-4-products-in-a-row").css("opacity", 1);
                    $(".wizzy-2-products-in-a-row").css("opacity", 0.5);
                    handleRangeInputValueChange(4);
                }
                clearInterval(waitForInputToLoad);
            }
        }, 1000);

        setTimeout(function() {
            clearInterval(waitForInputToLoad);
        }, 10000);
    }

    toHandleComingBackFromProductPage();
};
const changeTemplate = function(div) {
    const oldDiv = document.getElementById(div);
    const newDiv = document.getElementById(div + "-new").text;

    oldDiv.text = newDiv;
};

var colorData = {
  ".Hotpinkombre": "#FF69B4",
  ".Ice Pink/Pink": "#EBBECC",
  ".Rasberry": "#E30B5C",
  ".Silverombre": "#aaa9ad",
  ".Vintage Floral": "#b57edc",
  "A-Red": "#FF0000",
  "Ab-Ivory": "#FFFFF0",
  "Ab-Nude": "#eeece7",
  "AB-Silver": "#c0c0c0",
  "Absinthe": "#929447",
  "Acid-Green": "#b0bf1a",
  "Acid-Green-Ombre": "#b0bf1a",
  "Aegean-Teal": "#71898B",
  "Alabaster": "#F2F0E6",
  "Alabaster-Ivory": "#EDEADE",
  "Almandine": "#fedebc",
  "Almond": "#EADDCA",
  "Almond Brown": "#EADDCA",
  "Almond-Champagne": "#EADDCA",
  "Almond-Milk": "#EADDCA",
  "Almond-Nude": "#EADDCA",
  "Almond-Ombre": "#EADDCA",
  "Almond-Shimmer": "#EADDCA",
  "Almondine": "#fedebc",
  "Almondine-Smoke-Blue": "#52798d",
  "Amber": "#FFBF00",
  "Amber-Rose": "#D7946D",
  "Amethyst": "#9966CC",
  "Amethyst-Lilac": "#9966CC",
  "Animal-Black": "#000000",
  "Animal-Print-Black": "#000000",
  "Animal/Black": "#000000",
  "Anthracite": "#353C40",
  "Antique": "#986335",
  "Antique Blue": "#6985",
  "Antique Blush": "#C38690",
  "Antique Bronze": "#665d1e",
  "Antique Gold": "#986335",
  "Antique Gold Multi": "#986335",
  "Antique Pink": "#cb7375",
  "Antique Rose": "#da8890",
  "Antique Silver": "#bdc5ce",
  "Antique-Blush": "#da8890",
  "Antique-Bronze": "#87756a",
  "Antique-Copper": "#9c6448",
  "Antique-Gold-Rose": "#b76e79",
  "Antique-Grey-Rose": "#a78f8d",
  "Antique-Pink": "#cb7375",
  "Antique-Rose": "#da8890",
  "Antique-Silver": "#bdc5ce",
  "Antrachite": "#383E42",
  "Antrasit": "#383E42",
  "Apple": "#66b447",
  "Apple Green": "#76CD26",
  "Apple Red": "#ff0800",
  "Apple-Green": "#76CD26",
  "Apple-Mint": "#BBE5C6",
  "Apple-Multi": "#66b447",
  "Apple-Red": "#ff0800",
  "Apricot": "#FBCEB1",
  "Apricot-Cocoa": "#FBCEB1",
  "Apricot-Nude": "#FBCEB1",
  "Apricot-Silver": "#FBCEB1",
  "Aqua": "#00ffff",
  "Aqua Blue": "#86aba5",
  "Aqua Green": "#03bb85",
  "Aqua Iridescent": "#00ffff",
  "Aqua Mint": "#87baa8",
  "Aqua Multi": "#00ffff",
  "Aqua Ombre": "#00ffff",
  "Aqua Periwinkle": "#c3cde6",
  "Aqua Print": "#00ffff",
  "Aqua-Aqua": "#00ffff",
  "Aqua-Black": "#002f38",
  "Aqua-Blue": "#86aba5",
  "Aqua-Blue-Multi": "#86aba5",
  "Aqua-Blue-Pink": "#86aba5",
  "Aqua-Blush": "#3aa6a1",
  "Aqua-Breeze": "#d8e8e4",
  "Aqua-Coral": "#AFDCEC",
  "Aqua-Gold": "#ccba97",
  "Aqua-Ice": "#d2eada",
  "Aqua-Jade": "#45817F",
  "Aqua-Magenta": "#00ffff",
  "Aqua-Mint-Nude": "#87baa8",
  "Aqua-Multi": "#00ffff",
  "Aqua-Peach": "#ffe5b4",
  "Aqua-Pink": "#00ffff",
  "Aqua-Pink-Multi": "#00ffff",
  "Aqua-Print": "#00ffff",
  "Aqua-Royal": "#006a86",
  "Aqua-Shimmer": "#155553",
  "Aqua-Silver": "#C6D6CB",
  "Aqua-Silver-Nude": "#C6D6CB",
  "Aqua-Silver-Ombre": "#C6D6CB",
  "Aqua-Turquoise": "#40e0d0",
  "Aqua/Black": "#002f38",
  "Aqua/Blush": "#3aa6a1",
  "Aqua/Coral": "#AFDCEC",
  "Aqua/Gold": "#ccba97",
  "Aqua/Lime": "#b8e2dc",
  "Aqua/Mint": "#87baa8",
  "Aqua/Nude": "#00ffff",
  "Aqua/Peach": "#ffe5b4",
  "Aqua/Pink": "#00ffff",
  "Aqua/Pink/Silver": "#00ffff",
  "Aqua/Purple": "#5f99a6",
  "Aqua/Royal": "#006a86",
  "Aqua/Silver": "#C6D6CB",
  "Aqua/White": "#dff2e9",
  "Aquamarine": "#7fffd4",
  "Arctic": "#648589",
  "Arctic Blue": "#5ea3b3",
  "Ariel-Blue": "#c6e2ad",
  "Aruba Blue": "#81d7d3",
  "Ash-Blue": "#c4cecc",
  "Ash-Green": "#a0ddad",
  "Asian-Forest": "#c2cdb3",
  "Asian-Jade": "#33814e",
  "Asparagus": "#87a96b",
  "Astro-Dust": "#e5ccc9",
  "Astro-Dust-Bijou-Blue": "#4e5e7f",
  "Atlantic Honor": "#6480a4",
  "Atlantic-Blue": "#28293b",
  "Atlantic-Honor": "#6480a4",
  "Atlantic-Teal": "#3a698d",
  "Atlantis": "#6480a4",
  "Atomic Orange": "#ff8a28",
  "Aubergine": "#5e4052",
  "Aubergine Iridescent": "#5e4052",
  "Aubergine-Gold": "#693b58",
  "Aubergine/Bisque": "#5e4052",
  "Aubergine/Latte": "#693b58",
  "Aurora": "#a3d7da",
  "Australian-Black": "#2a2a2b",
  "Autumn-Multi": "#b35d18",
  "Avocado": "#568203",
  "Azalea": "#c53d56",
  "Azalea Pink": "#c6557f",
  "Azalea-Pink": "#c6557f",
  "Aztec Blue": "#6baba7",
  "Azul": "#0000ff",
  "Azure": "#007FFF",
  "Azure Blue": "#007FFF",
  "Azure-Blue": "#007FFF",
  "Azure-Blue-Diamond-White": "#007FFF",
  "Azure-Diamond-White": "#007FFF",
  "Azure/Multi": "#007FFF",
  "B.Blue": "#2e5894",
  "Baby Blue": "#89cff0",
  "Baby Doll Pink": "#e0218a",
  "Baby Peach": "#fbe3cd",
  "Baby Pink": "#f4c2c2",
  "Baby-Blue-Floral": "#1d697c",
  "Baby-Blue-Multi": "#89cff0",
  "Bahama": "#00a7a2",
  "Bahama Breeze Blue": "#a8d0d5",
  "Bahama-Blue": "#2265ae",
  "Bahama-Breeze": "#a8d0d5",
  "Ballet Pink": "#f5c4ca",
  "Baltic": "#279d9f",
  "Banana": "#ffe135",
  "Banana Multi": "#ffe135",
  "Banana-Multi": "#ffe135",
  "Banana-Silver": "#ffe135",
  "Banana-Yellow": "#ffe135",
  "Bananna": "#ffe135",
  "Barbie": "#e94196",
  "Barbie-Pink": "#e94196",
  "Baroque Red": "#7B4F5D",
  "Bashful-Pink": "#deaac5",
  "Basil-Green": "#bcbc73",
  "Beaded": "#ef9a93",
  "Beige": "#f5f5dc",
  "Beige Multi": "#f5f5dc",
  "Beige-Black": "#f5f5dc",
  "Beige-Blush": "#e5cbc7",
  "Beige-Gold": "#a9a083",
  "Beige-Ochre": "#f5f5dc",
  "Beige-Red": "#C6866E",
  "Beige-Silver": "#929083",
  "Beige-White": "#dccfb9",
  "Beige-Wine": "#f5f5dc",
  "Beige/Black": "#f5f5dc",
  "Beige/Yellow": "#a9a083",
  "Bellini": "#f4c9b1",
  "Bellini-Pink": "#f4c9b1",
  "Bermuda-Sand": "#ebdac6",
  "Berry": "#8d4e85",
  "Berry-Gold": "#963436",
  "Berry-Multi": "#8d4e85",
  "Berry-Nude": "#8d4e85",
  "Berry-Orange": "#c56f39",
  "Berry-Red": "#990000",
  "Berry-Wine": "#852f59",
  "Bijou-Blue": "#4e5e7f",
  "Birch-Ivory": "#fdfdda",
  "Biscotti": "#dac7ab",
  "Bisque": "#ffe4c4",
  "Bisque Beige": "#e2d4c6",
  "Bisque-Black": "#ffe4c4",
  "Bisque/Black": "#ffe4c4",
  "Black": "#000000",
  "BlackÂ ": "#000000",
  "Black & Gold": "#000000",
  "Black & White Print": "#000000",
  "Black A-B": "#000000",
  "Black Bisque": "#ffe4c4",
  "Black Bubblegum": "#ffc1cc",
  "Black Champagne Pink": "#f1ddcf",
  "Black Cherry Iridescent": "#52253a",
  "Black Crystal": "#a7d8de",
  "Black Diamond": "#b9f2ff",
  "Black Diamond White": "#b9f2ff",
  "Black Floral": "#b57edc",
  "Black Fuchsia Print": "#c74375",
  "Black Fushcia": "#c74375",
  "Black Green-Print": "#008001",
  "Black Jade": "#09363c",
  "Black Leapord": "#dfe2de",
  "Black Lilac": "#9955bb",
  "Black Magic Opal": "#91b660",
  "Black Marine Blue": "#1d3e59",
  "Black Marsala": "#975a59",
  "Black Multi": "#000000",
  "Black Navy Pearl": "#4a4743",
  "Black Navy/Gold": "#000080",
  "Black Ombre": "#000000",
  "Black Pearl": "#4a4743",
  "Black Plum/Burgundy": "#800020",
  "Black Polka Dots": "#000000",
  "Black Print": "#000000",
  "Black Rainbow": "#000000",
  "Black Red Multi": "#3e2022",
  "Black Rose": "#88474e",
  "Black Rose Gold": "#88474e",
  "Black Sand": "#3c3e40",
  "Black Sapphire": "#08070d",
  "Black Solid": "#000000",
  "Black Valentine": "#c72b50",
  "Black Wine": "#6c5857",
  "Black-Ab": "#000000",
  "Black-Animal": "#000000",
  "Black-Anthracite": "#383e42",
  "Black-Antique": "#986335",
  "Black-As": "#000000",
  "Black-Australian": "#2a2a2b",
  "Black-Beige": "#f5f5dc",
  "Black-Berry": "#3a3b3f",
  "Black-Birch": "#f8dfa1",
  "Black-Black-Floral": "#b57edc",
  "Black-Black-Gunmetal": "#000000",
  "Black-Blue": "#191e28",
  "Black-Blue-Aqua": "#191e28",
  "Black-Blush-Pink": "#ffc0cb",
  "Black-Bright-Blue": "#0096FF",
  "Black-Bright-Royal": "#010203",
  "Black-Bright-Royal-Bright-Blue": "#0096FF",
  "Black-Butterfly": "#000000",
  "Black-Capri-Blue": "#0096FF",
  "Black-Chalk": "#31343a",
  "Black-Champagne": "#f7e7ce",
  "Black-Charcoal": "#36454f",
  "Black-Check-Red": "#ff0000",
  "Black-Cheetah": "#cf9c76",
  "Black-Cherry": "#52253a",
  "Black-Cherry-Blush": "#790604",
  "Black-Clear": "#000000",
  "Black-Copper": "#5d2d24",
  "Black-Copper-Gold": "#b87333",
  "Black-Cream": "#fffdd0",
  "Black-Crystal": "#a7d8de",
  "Black-Dark-Rose": "#88474e",
  "Black-Deep-Green": "#008001",
  "Black-Diamond White": "#b9f2ff",
  "Black-Diamond-White": "#b9f2ff",
  "Black-Dragon-Scale": "#0f1f15",
  "Black-Dusty-Rose": "#88474e",
  "Black-Ecru": "#c2b280",
  "Black-Emerald": "#12221d",
  "Black-French Vanilla": "#fdead9",
  "Black-French-Vanilla": "#fdead9",
  "Black-Fuchsia-Print": "#c74375",
  "Black-Fuchsia-Rose-gold": "#c74375",
  "Black-Galaxy": "#343c40",
  "Black-Glitter": "#4a646c",
  "Black-Gold": "#1e1e1a",
  "Black-Gold-Copper": "#b87333",
  "Black-Gold-Gunmetal-Silver": "#d4af37",
  "Black-Gold-Navy": "#000080",
  "Black-Gold-Silver": "#d4af37",
  "Black-Golden": "#d4af37",
  "Black-Graphite": "#27292b",
  "Black-Green-Multi": "#008001",
  "Black-Grey": "#808080",
  "Black-Grey-White": "#808080",
  "Black-Gunmetal-Silver": "#1f262a",
  "Black-Hot Pink": "#ffc0cb",
  "Black-Hot-Pink": "#ffc0cb",
  "Black-Hot-Red": "#3e2022",
  "Black-Hunter": "#354c46",
  "Black-Ice-Mint": "#edf5eb",
  "Black-Iridescent-Nude": "#18335e",
  "Black-Ivory-Blue": "#0096FF",
  "Black-Ivory-Gold": "#d4af37",
  "Black-Ivory-Pearl": "#426384",
  "Black-Ivory-Silver": "#fffff0",
  "Black-Jet": "#000000",
  "Black-Lacquer": "#991c20",
  "Black-Leopard": "#dfe2de",
  "Black-Light-Blue": "#0096FF",
  "Black-Light-Gold": "#d4af37",
  "Black-Lilac": "#9955bb",
  "Black-Lt-Blue-Ivory": "#0096FF",
  "Black-Malibu": "#008cc1",
  "Black-Marsala": "#975a59",
  "Black-Mauve": "#e0b0ff",
  "Black-Metallic": "#323334",
  "Black-Midnight": "#702670",
  "Black-Mocha": "#4b4844",
  "Black-Mulberry": "#8d4e85",
  "Black-Multi": "#000000",
  "Black-Multi-Black": "#000000",
  "Black-Multi-Nude": "#000000",
  "Black-Multicolor": "#000000",
  "Black-Navy-Blue": "#000080",
  "Black-Navy-Gold": "#000080",
  "Black-Navy-Muli": "#000080",
  "Black-Navy-Multi": "#000080",
  "Black-Navy-Nude": "#000080",
  "Black-Navy-Silver": "#000080",
  "Black-Nebula": "#2e62a3",
  "Black-Nile-Green": "#008001",
  "Black-Nude": "#000000",
  "Black-Nude-Multi": "#000000",
  "Black-Off-White": "#000000",
  "Black-Olive": "#3b3c36",
  "Black-Only": "#000000",
  "Black-Opal": "#91b660",
  "Black-Orange": "#ff8c00",
  "Black-Orchid": "#9932cc",
  "Black-Pewter": "#4b5756",
  "Black-Pink": "#ffc0cb",
  "Black-Pink-Multi": "#ffc0cb",
  "Black-Pink-Print": "#ffc0cb",
  "Black-Plum": "#3e3844",
  "Black-Plum-Charcoal": "#3e3844",
  "Black-Polka-Dot": "#739dad",
  "Black-Polka-Dots": "#739dad",
  "Black-Port-Blush": "#dbc0b4",
  "Black-Print": "#000000",
  "Black-Prints": "#000000",
  "Black-Quartz": "#000000",
  "Black-Red Rose": "#3e2022",
  "Black-Red-Floral": "#b57edc",
  "Black-Red-Fuchsia": "#c74375",
  "Black-Red-Print": "#3e2022",
  "Black-Rose": "#88474e",
  "Black-Rose Gold": "#88474e",
  "Black-Rose-Gold": "#88474e",
  "Black-Rose-Multi": "#88474e",
  "Black-Rose-Print": "#88474e",
  "Black-Rosewater": "#88474e",
  "Black-Rosewood": "#88474e",
  "Black-Royal Blue": "#002366",
  "Black-Royal-Blue": "#002366",
  "Black-Royal-Multi": "#002366",
  "Black-Ruby": "#841b2d",
  "Black-Sand": "#3c3e40",
  "Black-Sax": "#000000",
  "Black-Sequins": "#e1c28d",
  "Black-Shimmer": "#e3c9ab",
  "Black-Silver": "#71706e",
  "Black-Silver-Gold": "#d4af37",
  "Black-Silver-Nude": "#71706e",
  "Black-Sky": "#000000",
  "Black-Sliver": "#71706e",
  "Black-Soft-White": "#000000",
  "Black-Solid": "#000000",
  "Black-Steel": "#000000",
  "Black-Stone": "#000000",
  "Black-Sunburst": "#9c7c38",
  "Black-Super-Pink": "#ffc0cb",
  "Black-Sweet-Pink": "#ffc0cb",
  "Black-Taffy-Pink": "#ffc0cb",
  "Black-Tiffany": "#0abab5",
  "Black-Topaz": "#ffc87c",
  "Black-Violet": "#9400d3",
  "Black-White": "#000000",
  "Black-White-Emerald": "#50c878",
  "Black-White-Gunmetal": "#2a3439",
  "Black-White-Multi": "#000000",
  "Black-White-Nude": "#000000",
  "Black-White-Red": "#3e2022",
  "Black-White-Rose": "#88474e",
  "Black-White-Silver": "#c0c0c0",
  "Black-Wine": "#6c5857",
  "Black-Yellow": "#9b870c",
  "Black-Yellow-Multi": "#9b870c",
  "Black-Yellow-Print": "#9b870c",
  "Black-Zebra": "#4b6753",
  "Black.-White": "#000000",
  "Black'": "#000000",
  "Black/Almond": "#efdecd",
  "Black/Antique Gold": "#986335",
  "Black/Aqua": "#002f38",
  "Black/Beige": "#f5f5dc",
  "Black/Berry": "#8d4e85",
  "Black/Black": "#000000",
  "Black/Black/Red": "#3e2022",
  "Black/Blue": "#191e28",
  "Black/Blush": "#de5d83",
  "Black/Boysenberry": "#8d4e85",
  "Black/Bronze": "#804a00",
  "Black/Brown": "#1a1718",
  "Black/Burgundy": "#800020",
  "Black/Champagne": "#f7e7ce",
  "Black/Charcoal": "#36454f",
  "Black/Cherry": "#790604",
  "Black/Cherry Red": "#D2042D",
  "Black/Copper": "#5d2d24",
  "Black/Cranberry": "#8d4e85",
  "Black/Cream": "#fffdd0",
  "Black/Crystal": "#a7d8de",
  "Black/Diamond White": "#b9f2ff",
  "Black/Embroidered": "#b9dba7",
  "Black/Emerald": "#50c878",
  "Black/Fuchsia": "#c74375",
  "Black/Fuchsia Print": "#c74375",
  "Black/Fushcia": "#c74375",
  "Black/Gold": "#d4af37",
  "Black/Gold/Nude": "#d4af37",
  "Black/Gold/Silver": "#d4af37",
  "Black/Green": "#008001",
  "Black/Grey": "#808080",
  "Black/Gunmetal": "#2a3439",
  "Black/Hot Coral": "#f0605c",
  "Black/Hot Pink": "#ffc0cb",
  "Black/Iridescent": "#18335e",
  "Black/Ivory": "#fffff0",
  "Black/Ivory/White": "#fffff0",
  "Black/Jade": "#09363c",
  "Black/Lavender": "#b57edc",
  "Black/Light Pink": "#ffc0cb",
  "Black/Lilac": "#9955bb",
  "Black/Lime": "#00ff00",
  "Black/Magenta": "#ff0090",
  "Black/Mint": "#98ff98",
  "Black/Mocha": "#4b4844",
  "Black/Multi Print": "#000000",
  "Black/Mustard": "#e1ad01",
  "Black/Navy": "#000080",
  "Black/Navy/Multi": "#000080",
  "Black/Neon Green": "#39ff14",
  "Black/Neon Pink": "#ffc0cb",
  "Black/Nude": "#000000",
  "Black/Nude Ombre": "#000000",
  "Black/Nude/Gold": "#d4af37",
  "Black/Nude/Silver": "#c0c0c0",
  "Black/Ocean": "#48bf91",
  "Black/Off White": "#000000",
  "Black/Olive": "#3b3c36",
  "Black/Opal Grey": "#91b660",
  "Black/Orchid": "#9932cc",
  "Black/Peacock": "#008381",
  "Black/Pearl": "#426384",
  "Black/Periwinkle": "#c3cde6",
  "Black/Pewter": "#4b5756",
  "Black/Pink": "#ffc0cb",
  "Black/Pink Print": "#ffc0cb",
  "Black/Pink/Aqua": "#ffc0cb",
  "Black/Platinum": "#e5e4e2",
  "Black/Plum": "#3e3844",
  "Black/Polkadot": "#739dad",
  "Black/Purple": "#6a0dad",
  "Black/Raspberry": "#8d4e85",
  "Black/Red": "#ff0000",
  "Black/Red Print": "#ff0000",
  "Black/Rose": "#88474e",
  "Black/Rose Gold": "#88474e",
  "Black/Rose Print": "#88474e",
  "Black/Rosewater": "#88474e",
  "Black/Royal": "#4169e1",
  "BLACK/ROYAL BLUE": "#191e28",
  "Black/Ruby": "#9b111e",
  "BLACK/RUBY RED": "#9b111e",
  "Black/Sapphire": "#08070d",
  "Black/Silver": "#c0c0c0",
  "Black/Silver/Gold": "#d4af37",
  "Black/Sky Blue": "#8cbed6",
  "Black/Slate": "#708090",
  "Black/Smoke": "#738276",
  "Black/Taupe": "#baa68e",
  "Black/Teal": "#008080",
  "Black/Turquoise": "#40e0d0",
  "Black/Violet": "#9400d3",
  "Black/White": "#ffffff",
  "Black/White Ombre": "#ffffff",
  "Black/Wildberry": "#8d4e85",
  "Black/Wine": "#6c5857",
  "Black/Yellow": "#9b870c",
  "Blackberry": "#8d4e85",
  "Blackberry-Gold": "#8d4e85",
  "Blank-Pink": "#ffc0cb",
  "Blaze": "#6b0000",
  "Blood-Red": "#880808",
  "Blossom": "#ffb7c5",
  "Blossom Pink": "#ffc0cb",
  "Blossom-Pink": "#ffc0cb",
  "Blue": "#0000ff",
  "Blue Charchol": "#3d4450",
  "Blue Denim": "#48505d",
  "Blue Gold": "#0000ff",
  "Blue Iris": "#5A4FCF",
  "Blue Iris Diamond White": "#b9f2ff",
  "Blue Iris Ombre": "#5A4FCF",
  "Blue Iris Pink": "#5A4FCF",
  "Blue Ivory": "#fffff0",
  "Blue Jay": "#0000ff",
  "Blue Leopard Print": "#0000ff",
  "Blue Mist": "#0000ff",
  "Blue Multi": "#0000ff",
  "Blue Ombre": "#0000ff",
  "Blue Opal": "#91b660",
  "Blue Orchid": "#0000ff",
  "Blue Pearl": "#426384",
  "Blue Print": "#0000ff",
  "Blue Radiance": "#0000ff",
  "Blue Rose": "#88474e",
  "Blue Smoke": "#0000ff",
  "Blue Sparkle": "#0000ff",
  "Blue Willow": "#0000ff",
  "Blue-Attitude": "#0000ff",
  "Blue-Beige": "#f5f5dc",
  "Blue-Black-Green": "#008001",
  "Blue-Blitz": "#0000ff",
  "Blue-Bronze": "#0000ff",
  "Blue-China": "#0000ff",
  "Blue-Copper": "#0000ff",
  "Blue-Coral": "#0000ff",
  "Blue-Coral-Champagne": "#0000ff",
  "Blue-Coral-Nude": "#0000ff",
  "Blue-Cream": "#0000ff",
  "Blue-Degrade": "#0000ff",
  "Blue-Floral": "#b57edc",
  "Blue-Fog": "#0000ff",
  "Blue-Fox": "#0000ff",
  "Blue-Fuchsia": "#c74375",
  "Blue-Gold": "#0000ff",
  "Blue-Granite": "#0000ff",
  "Blue-Green": "#064e40",
  "Blue-Grey": "#0000ff",
  "Blue-Haze": "#0000ff",
  "Blue-Iris-Silver": "#0000ff",
  "Blue-Irridescent-Silver": "#0000ff",
  "Blue-Ivory": "#0000ff",
  "Blue-Ivory-Print": "#0000ff",
  "Blue-jay": "#0000ff",
  "Blue-Lagoon": "#0000ff",
  "Blue-Lame": "#0000ff",
  "Blue-Lilac": "#c8a2c8",
  "Blue-Magenta": "#0000ff",
  "Blue-Marine": "#0000ff",
  "Blue-Mercury": "#0000ff",
  "Blue-Metallica": "#0000ff",
  "Blue-Mix": "#0000ff",
  "Blue-Multi": "#0000ff",
  "Blue-Navy": "#000080",
  "Blue-Navy-Blue": "#000080",
  "Blue-Nude": "#0000ff",
  "Blue-Opal": "#91b660",
  "Blue-Orchid": "#0000ff",
  "Blue-Pastel-Ivory": "#0000ff",
  "Blue-Pink": "#0000ff",
  "Blue-Prints": "#0000ff",
  "Blue-Purple-Print": "#0000ff",
  "Blue-Radiance": "#0000ff",
  "Blue-Radiance-Multi": "#0000ff",
  "Blue-Radiance-Silver": "#0000ff",
  "Blue-Raspberry": "#8d4e85",
  "Blue-Red": "#ff0000",
  "Blue-Rose": "#88474e",
  "Blue-Royal": "#0000ff",
  "Blue-Salmon": "#0000ff",
  "Blue-Satin": "#0000ff",
  "Blue-Shimmer": "#0000ff",
  "Blue-Silver": "#0000ff",
  "Blue-Sky": "#0000ff",
  "Blue-Slate": "#0000ff",
  "Blue-Turquoise": "#0000ff",
  "Blue-White": "#0000ff",
  "Blue-Willow": "#0000ff",
  "Blue-Yellow": "#0000ff",
  "Blue/Black": "#000000",
  "Blue/Coral": "#0000ff",
  "Blue/Floral": "#b57edc",
  "Blue/Grey": "#0000ff",
  "Blue/Ivory": "#0000ff",
  "Blue/Ivory Print": "#0000ff",
  "Blue/Lavender": "#0000ff",
  "Blue/Multi Print": "#0000ff",
  "Blue/Nude": "#0000ff",
  "Blue/Pink": "#0000ff",
  "Blue/Print": "#0000ff",
  "Blue/Purple": "#0000ff",
  "Blue/Red": "#ff0000",
  "Blue/Silver": "#0000ff",
  "Blue/Turquoise": "#0000ff",
  "Blue/Violet": "#0000ff",
  "Blue/White": "#0000ff",
  "Blue/Yellow/Multi": "#0000ff",
  "Bluebell": "#0000ff",
  "Blueberry": "#8d4e85",
  "Blueberry-Leopard": "#8d4e85",
  "Blueblossom": "#0000ff",
  "Blush": "#de5d83",
  "Blush Crystal": "#a7d8de",
  "Blush Fuchsia": "#c74375",
  "Blush Gunmetal": "#2a3439",
  "Blush Iridescent": "#de5d83",
  "Blush Ivory": "#fffff0",
  "Blush Mauve": "#e0b0ff",
  "Blush Multi": "#de5d83",
  "Blush Pearl": "#426384",
  "Blush Pink": "#ffc0cb",
  "Blush Print": "#de5d83",
  "Blush Sage": "#de5d83",
  "Blush Shimmer": "#de5d83",
  "Blush-AB": "#de5d83",
  "Blush-Aqua": "#de5d83",
  "Blush-Aqua-Print": "#de5d83",
  "Blush-Berry": "#8d4e85",
  "Blush-Black": "#000000",
  "Blush-Blush": "#de5d83",
  "Blush-Burgundy": "#800020",
  "Blush-Champagne": "#de5d83",
  "Blush-Charcoal": "#de5d83",
  "Blush-D-White": "#de5d83",
  "Blush-Floral": "#b57edc",
  "Blush-Fuchsia": "#c74375",
  "Blush-Gold": "#d4af37",
  "Blush-Green": "#008001",
  "Blush-Grey": "#808080",
  "Blush-Light-Blue": "#0000ff",
  "Blush-Light-Gold": "#d4af37",
  "Blush-Mauve": "#e0b0ff",
  "Blush-Metallic": "#323334",
  "Blush-Mint": "#98ff98",
  "Blush-Navy": "#000080",
  "Blush-Nude": "#de5d83",
  "Blush-Olive": "#808000",
  "Blush-Ombre": "#de5d83",
  "Blush-Pearl": "#426384",
  "Blush-Pink-Silver": "#ffc0cb",
  "Blush-Print": "#de5d83",
  "Blush-Rose": "#88474e",
  "Blush-Rose-Gold": "#88474e",
  "Blush-Rose-Ivory": "#88474e",
  "Blush-White": "#de5d83",
  "Blush/ AB": "#de5d83",
  "Blush/Black": "#000000",
  "Blush/Blush": "#de5d83",
  "Blush/Crystal": "#a7d8de",
  "Blush/Eggplant": "#de5d83",
  "Blush/Fuchsia": "#c74375",
  "Blush/Gold": "#d4af37",
  "Blush/Ivory": "#fffff0",
  "Blush/Mocha": "#4b4844",
  "Blush/Nude": "#de5d83",
  "Blush/Pink": "#ffc0cb",
  "Blush/Rose": "#88474e",
  "Blush/Silver": "#de5d83",
  "Blush/White": "#de5d83",
  "Bodice": "#e1d4c5",
  "Bone": "#e3dac9",
  "Bone White": "#ffffff",
  "Bordeaus-Rose": "#88474e",
  "Bordeaux": "#53292a",
  "Bordeaux-Black": "#594548",
  "Bordeaux-Nude": "#53292a",
  "Bordo": "#53292a",
  "Bottle Green": "#092E20",
  "Bottle-Green": "#092E20",
  "Boujie Pink": "#ffc0cb",
  "Boujie-White": "#ffffff",
  "Boysenberry": "#8d4e85",
  "Boysenberry/Black": "#000000",
  "Brandy": "#87413f",
  "Brick": "#8b4f39",
  "Bright Blue": "#0096FF",
  "Bright Coral": "#FF7F50",
  "Bright Emerald": "#50c878",
  "Bright Fuchsia": "#c74375",
  "Bright Fuchsia/Light Pink Ombre": "#c74375",
  "Bright Orange": "#e24c00",
  "Bright Pink": "#ffc0cb",
  "Bright Purple": "#6a0dad",
  "Bright Royal": "#4169e1",
  "Bright Royal/Light Blue Ombre": "#0096FF",
  "Bright Turquoise": "#40e0d0",
  "Bright Yellow": "#ffff00",
  "Bright-Fuchsia-Gold": "#c74375",
  "Bright-Fuchsia-Multi": "#c74375",
  "Bright-Green": "#66ff00",
  "Bright-Orange": "#e24c00",
  "Bright-Orchid": "#da70d6",
  "Bright-Pink": "#ffc0cb",
  "Bright-Pink-Multi": "#ffc0cb",
  "Bright-Pink-Print": "#ffc0cb",
  "Bright-Pink-Silver": "#ffc0cb",
  "Bright-Purple": "#6a0dad",
  "Bright-Red": "#ff0000",
  "Bright-Royal-Blue": "#0096FF",
  "Bright-Royal-Gold": "#d4af37",
  "Bright-Sky": "#87ceeb",
  "Bright-Teal": "#008080",
  "Bright-Turquoise": "#40e0d0",
  "Bright-Turquoise-Lime-Green": "#66ff00",
  "Bright-White": "#ffffff",
  "Bright-White-Gold": "#d4af37",
  "Bright-White-Grey": "#808080",
  "Bright-White-Jet-Black": "#000000",
  "Bright-White-Rosewater": "#88474e",
  "Bright-Yellow": "#ffff00",
  "Brique": "#842e1b",
  "Bronaze": "#b08d57",
  "Bronze": "#b08d57",
  "Bronze-Brown": "#b08d57",
  "Bronze-Gold": "#d4af37",
  "Bronze-Lame": "#b08d57",
  "Bronze-Multi": "#b08d57",
  "Bronze-Shimmer": "#e3c9ab",
  "Bronze-Silver": "#c0c0c0",
  "Bronze/Animal": "#b08d57",
  "Bronze/Aqua": "#b08d57",
  "Bronze/Black": "#000000",
  "Bronze/Champagne": "#b08d57",
  "Bronze/Gold": "#d4af37",
  "Bronze/Nude": "#b08d57",
  "Brown": "#964b00",
  "Brown Multi": "#964b00",
  "Brown Ombre": "#964b00",
  "Brown-Copper": "#b87333",
  "Brown-Gold": "#d4af37",
  "Brown-Multi": "#964b00",
  "Brown/Gold": "#d4af37",
  "Brown/Leopard": "#dfe2de",
  "Brown/Red": "#ff0000",
  "Brulee": "#a48465",
  "Bubble Gum": "#ffc1cc",
  "Bubble Gum Pink": "#ffc0cb",
  "Bubble-Pink": "#ffc0cb",
  "Bubblegum-Pink": "#ffc0cb",
  "Bubblegum/Nude": "#ffc1cc",
  "Buff": "#f0dc82",
  "Buff-Pearl": "#426384",
  "Buff-Pink": "#ffc0cb",
  "Burgandy": "#800020",
  "Burgundy": "#800020",
  "Burgundy Burgundy": "#800020",
  "Burgundy Multi": "#800020",
  "Burgundy Ombre": "#800020",
  "Burgundy Pink": "#800020",
  "Burgundy Red": "#800020",
  "Burgundy-AB": "#800020",
  "Burgundy-Blush": "#800020",
  "Burgundy-Burgundy": "#800020",
  "Burgundy-Fawn": "#800020",
  "Burgundy-Gold": "#800020",
  "Burgundy-Gunmetal": "#800020",
  "Burgundy-Multi": "#800020",
  "Burgundy-Off-White": "#800020",
  "Burgundy-Red": "#800020",
  "Burgundy-Silver": "#800020",
  "Burgundy-White": "#800020",
  "Burgundy/Black": "#000000",
  "Burgundy/Fuchsia": "#c74375",
  "Burgundy/Gold": "#800020",
  "Burgundy/Nude": "#800020",
  "Burnt Orange": "#cc5500",
  "Burnt-Orange": "#cc5500",
  "Butter": "#f6e2b9",
  "Butter cream": "#fffdd0",
  "Butter Yellow": "#ffff00",
  "Butter-Cream": "#fffdd0",
  "Buttercream": "#fffdd0",
  "Buttercup": "#f6e2b9",
  "Buttercup-Multi": "#f6e2b9",
  "Butterfly": "#f6e2b9",
  "Butterfly-Print": "#f6e2b9",
  "Butterfly-Sky": "#87ceeb",
  "Buttermilk": "#f6e2b9",
  "Butterscotch": "#f6e2b9",
  "Cabernet": "#280008",
  "Cadbury": "#B9861F",
  "Cadet-Blue": "#5f9ea0",
  "Cafe": "#a18262",
  "CafÃ©": "#a18262",
  "Cafe-Nude": "#a18262",
  "Cafe/Black": "#000000",
  "Cafï¿½ï¿½": "#a18262",
  "Calypso": "#01b0bb",
  "Camel": "#c19a6b",
  "Cameo": "#efbbcc",
  "Cameo Pink": "#ffc0cb",
  "Cameo Rose": "#88474e",
  "Cameo-Pink": "#ffc0cb",
  "Cameo-Rose": "#88474e",
  "Camo": "#78866b",
  "Canary": "#ffff99",
  "Canary Yellow": "#ffff00",
  "Candlelight": "#e09d37",
  "Candlelight Noir": "#e09d37",
  "Candy": "#e4717a",
  "Candy Pink": "#ffc0cb",
  "Candy Pink/Ivory/Black": "#000000",
  "Candy Pink/Multi": "#ffc0cb",
  "Candy-Apple": "#e4717a",
  "Candy-Pink": "#ffc0cb",
  "Candy-Pink-Black-White": "#000000",
  "Candy-Pink-Bright-Pink": "#ffc0cb",
  "Candy-Pink-Candy-Pink": "#ffc0cb",
  "Candy-Pink-Ivory-Black": "#000000",
  "Candy-Pink-Ivory-Print": "#ffc0cb",
  "Candy-Pink-Silver": "#ffc0cb",
  "Candy-Pink-Yellow": "#ffc0cb",
  "Candy-Purple": "#6a0dad",
  "Candy-Purple-Dark-Purple": "#6a0dad",
  "Candy-Purple-Multi": "#6a0dad",
  "Candy-Red": "#ff0800",
  "Candyland": "#e4717a",
  "Cantaloupe": "#f4ae72",
  "Cape-Nude": "#eeece7",
  "Cape-White": "#ffffff",
  "Cappuccino": "#bcada3",
  "Cappuccino-Grey": "#808080",
  "Cappucino": "#bcada3",
  "Capri": "#44bbca",
  "Capri Blue": "#005e83",
  "Caramel": "#ffd59a",
  "Caramel-Black": "#ffd59a",
  "Cardinal": "#c41e3a",
  "Caribbean": "#00cc99",
  "Caribbean Blue": "#1ac1dd",
  "Caribbean Green": "#00cc99",
  "Caribbean-Blue": "#1ac1dd",
  "Carmel": "#ffd59a",
  "Carmine": "#960018",
  "Carnation": "#ffa6c9",
  "Carnival": "#eb882c",
  "Carnival Pink": "#ffc0cb",
  "Carnival-Pink": "#ffc0cb",
  "Carolina-Blue": "#56a0d3",
  "Cashmere": "#be9f8e",
  "Cashmere Rose": "#88474e",
  "Cashmere-Nude": "#eeece7",
  "Cashmere-Rose": "#88474e",
  "Cashmere-Rose-Ivory": "#88474e",
  "Cashmere-Rose-Silver": "#88474e",
  "Cashmere-Rose-White": "#88474e",
  "Cassis": "#583747",
  "Caviar": "#313031",
  "Cayenne": "#c04d35",
  "Cayman Blue": "#45bbf6",
  "Celadon": "#ace1af",
  "Celedon": "#ace1af",
  "Celery": "#d0c456",
  "Celeste-Blue": "#b2ffff",
  "Celestial Pink": "#ffc0cb",
  "Celestial-Blue": "#4997d0",
  "Cerise": "#de3163",
  "Cerise Multi": "#de3163",
  "Cerise/Multi": "#de3163",
  "Cerise/Pink": "#ffc0cb",
  "Cerulean": "#2a52be",
  "Cerulean Blue": "#2a52be",
  "Cerulean-Nude": "#eeece7",
  "Cha-Cha-Red": "#c7404b",
  "Chalk": "#e0dbd1",
  "Chalk-Black": "#000000",
  "Chalk-Gunmetal": "#2a3439",
  "Chalk-Pink": "#ffc0cb",
  "Chameleon": "#3c4458",
  "Champage-Nude": "#eeece7",
  "Champagne": "#f7e7ce",
  "ChampagneÂ ": "#f7e7ce",
  "Champagne Multi": "#f7e7ce",
  "Champagne Ombre": "#f7e7ce",
  "Champagne Rose": "#88474e",
  "Champagne-Ab": "#f7e7ce",
  "Champagne-Aqua": "#f7e7ce",
  "Champagne-Beige": "#f5f5dc",
  "Champagne-Blue": "#0000ff",
  "Champagne-Blue-Ombre": "#0000ff",
  "Champagne-Blush": "#f7e7ce",
  "Champagne-Bronze": "#f7e7ce",
  "Champagne-Champagne": "#f7e7ce",
  "Champagne-Cream": "#f7e7ce",
  "Champagne-Ivory": "#f7e7ce",
  "Champagne-Ivory-Palomino": "#f7e7ce",
  "Champagne-Multi": "#f7e7ce",
  "Champagne-Nude": "#f7e7ce",
  "Champagne-Ombre": "#f7e7ce",
  "Champagne-Orchid": "#f7e7ce",
  "Champagne-Pearl": "#426384",
  "Champagne-Pink": "#ffc0cb",
  "Champagne-Pink-Ombre": "#ffc0cb",
  "Champagne-Print": "#f7e7ce",
  "Champagne-Purple": "#f7e7ce",
  "Champagne-Rose": "#88474e",
  "Champagne-Rose-Gold": "#88474e",
  "Champagne-Swirl": "#f7e7ce",
  "Champagne-Taupe": "#f7e7ce",
  "Champagne-Turquoise": "#f7e7ce",
  "Champagne-Violet": "#f7e7ce",
  "Champagne-White": "#f7e7ce",
  "Champagne/Black": "#000000",
  "Champagne/Blush": "#f7e7ce",
  "Champagne/Gold": "#f7e7ce",
  "Champagne/Grey": "#f7e7ce",
  "Champagne/Lilac Ombre": "#c8a2c8",
  "Champagne/Nude": "#f7e7ce",
  "Champagne/Oyster": "#f7e7ce",
  "Champagne/Pink": "#ffc0cb",
  "Champagne/Rose": "#88474e",
  "Champagne/Silver": "#f7e7ce",
  "Champagne/Taupe": "#f7e7ce",
  "Champagne/Teal Ombre": "#f7e7ce",
  "Champagne/Turquoise": "#f7e7ce",
  "Champagne/White": "#f7e7ce",
  "Champagne/Wine": "#6c5857",
  "Champagne/Wine Ombre": "#6c5857",
  "Champange": "#f7e7ce",
  "Charchol": "#36454f",
  "Charcoal": "#36454f",
  "Charcoal Blush": "#36454f",
  "Charcoal Bronze": "#36454f",
  "Charcoal Charcoal": "#36454f",
  "Charcoal Grey": "#36454f",
  "Charcoal Multi": "#36454f",
  "Charcoal-Charcoal": "#36454f",
  "Charcoal-Gold": "#36454f",
  "Charcoal-Mauve": "#36454f",
  "Charcoal-Multi": "#36454f",
  "Charcoal-Ombre": "#36454f",
  "Charcoal-Rosewater": "#88474e",
  "Charcoal-Solid": "#36454f",
  "Charcoal-Stone": "#36454f",
  "Charcoal/Black": "#000000",
  "Charcoal/Blush": "#36454f",
  "Charcoal/Bronze": "#36454f",
  "Charcoal/Charcoal": "#36454f",
  "Charcoal/Dark White": "#36454f",
  "Charcoal/Gold": "#36454f",
  "Charcoal/Lilac Ombre": "#c8a2c8",
  "Charcoal/Multi": "#36454f",
  "Charcoal/Nude": "#36454f",
  "Charcoal/Rose Gold": "#88474e",
  "Charcoal/Rosewater": "#88474e",
  "Charcoal/Silver": "#36454f",
  "Chartreuse": "#7fff00",
  "Chateau Grey": "#808080",
  "Cheetah": "#cf9c76",
  "Cheetahlicious": "#cf9c76",
  "Cheetalicious": "#cf9c76",
  "Cherry": "#790604",
  "Cherry Pink": "#ffc0cb",
  "Cherry Red": "#D2042D",
  "Cherry Red & Nude": "#D2042D",
  "Cherry-Blossom": "#790604",
  "Cherry-Blush": "#790604",
  "Cherry-Nude": "#790604",
  "Cherry-Pink": "#ffc0cb",
  "cherry-red": "#D2042D",
  "Cherry/Nude": "#790604",
  "Chestnut": "#954535",
  "Chianti": "#6c1e20",
  "Chili": "#8f3d37",
  "Chili Pepper": "#9b1b30",
  "Chilli Pepper": "#9b1b30",
  "Chintz": "#d4c6b9",
  "Chocolate": "#7b3f00",
  "Chocolate Brown": "#964b00",
  "Chocolate-Brown": "#964b00",
  "Chrome": "#a8a9ad",
  "Cielo": "#aee4d7",
  "Cinammon": "#6b4139",
  "Cinderella Pink Multi": "#ffc0cb",
  "Cinderella-Blue": "#0000ff",
  "Cinderella-Pink": "#ffc0cb",
  "Cinnamon": "#6b4139",
  "Cinnamon Multi": "#6b4139",
  "Cinnamon-Shimmer": "#e3c9ab",
  "Citrine": "#e4d00a",
  "Citrine-Multi": "#e4d00a",
  "Citron": "#9fa91f",
  "Citronella": "#9fa91f",
  "Citronelle": "#9fa91f",
  "Citrus": "#ccc156",
  "Claret": "#7f1734",
  "Claret-Multi": "#7f1734",
  "Claret-Nude": "#eeece7",
  "Claret-Silver": "#c0c0c0",
  "Claret/Nude": "#eeece7",
  "Classic-Blue": "#0000ff",
  "Clay": "#7e4b26",
  "Clear": "#dcf0ef",
  "Clear Sky Tie Dye": "#87ceeb",
  "Clear-2-Tone": "#dcf0ef",
  "Clear-Brass": "#dcf0ef",
  "Clear-Bright": "#dcf0ef",
  "Clear-Crystal": "#a7d8de",
  "Clear-Gold": "#d4af37",
  "Clear-Nude": "#eeece7",
  "Clear-Rose-Gold": "#88474e",
  "Clear-Silver": "#c0c0c0",
  "Clear-Sky": "#87ceeb",
  "Clear/Brass": "#dcf0ef",
  "Clear/Gold": "#d4af37",
  "Clear/Rose Gold": "#88474e",
  "Clear/Silver": "#c0c0c0",
  "Clematis-Blue": "#0000ff",
  "Clementine": "#eb5e00",
  "Clementine-Gold": "#d4af37",
  "Cloud": "#d0cccc",
  "Cloud Blue": "#d0deec",
  "Cloud-Blue": "#d0deec",
  "Cloud-Blue-Gold": "#d0deec",
  "Cloudy-Blue": "#d0deec",
  "Coastal-Blue": "#d0deec",
  "Cobalt": "#0047ab",
  "Cobalt Print": "#0047ab",
  "Cobalt-AB": "#0047ab",
  "Cobalt-Black": "#000000",
  "Cobalt-Gold": "#0047ab",
  "Cobalt-Shimmer": "#e3c9ab",
  "Cobalt/Blue": "#0047ab",
  "Cobalt/Gold": "#d4af37",
  "Cobalt/Nude": "#eeece7",
  "Cobalt/Silver": "#c0c0c0",
  "Coblat": "#0047ab",
  "Cocoa": "#583318",
  "Cocoa Brown": "#964b00",
  "Cocoa-Black": "#000000",
  "Cocoa-Green": "#48291C",
  "Cocoa-Nude": "#eeece7",
  "Cocoa-Patina": "#583318",
  "Cocoa/Black": "#000000",
  "Cocoa/Champ": "#583318",
  "Cocoa/Champagne": "#f7e7ce",
  "Cocoa/Copper": "#b87333",
  "Cocoa/Nude": "#eeece7",
  "Coffee": "#6f4e37",
  "Coffee-Gold": "#d4af37",
  "Coffee-Nude": "#eeece7",
  "Coffee-Shimmer": "#e3c9ab",
  "Cognac": "#bb6144",
  "Colbalt": "#0047ab",
  "Colonial-Rose": "#88474e",
  "Confetti-Pink": "#ffc0cb",
  "Copper": "#b87333",
  "Copper Multi": "#b87333",
  "Copper-Black": "#000000",
  "Copper-Blue": "#0000ff",
  "Copper-Gold": "#b87333",
  "Copper-Nude": "#b87333",
  "Copper-Rose": "#88474e",
  "Copper-Shadow": "#b87333",
  "Copper/Multi": "#b87333",
  "Copper/Silver": "#b87333",
  "Coral": "#FF7F50",
  "Coral  Gold": "#d4af37",
  "Coral Iridescent": "#FF7F50",
  "Coral Ombre": "#FF7F50",
  "Coral Pink": "#ffc0cb",
  "Coral-Black": "#000000",
  "Coral-Blue-Print": "#0000ff",
  "Coral-Cloud": "#FF7F50",
  "Coral-Gold": "#d4af37",
  "Coral-Ivory": "#fffff0",
  "Coral-Ivory-Print": "#fffff0",
  "Coral-Mocha": "#bea493",
  "Coral-Multi": "#FF7F50",
  "Coral-nude": "#FF7F50",
  "Coral-Orange": "#ffa500",
  "Coral-Pink-Multi": "#ffc0cb",
  "Coral-Print": "#FF7F50",
  "Coral-Two-Tone": "#FF7F50",
  "Coral-White": "#FF7F50",
  "Coral-Yellow-Print": "#ffff00",
  "Coral/Gold": "#d4af37",
  "Coral/Lime": "#FF7F50",
  "Coral/Multi": "#FF7F50",
  "Coral/Nude": "#FF7F50",
  "Coral/Orange": "#ffa500",
  "Coral/Periwinkle": "#FF7F50",
  "Coral/Pink": "#ffc0cb",
  "Coral/Silver": "#c0c0c0",
  "Coral/White": "#FF7F50",
  "Corn-flower": "#6495ed",
  "Cornflower": "#6495ed",
  "Cosmic-Cobalt": "#0047ab",
  "Cosmopolitan Pink": "#ffc0cb",
  "Cosmopolitan-Pink": "#ffc0cb",
  "Cotton Candy": "#e4717a",
  "Cotton Candy Pink": "#ffc0cb",
  "Cotton Candy/Silver": "#c0c0c0",
  "Cotton-Candy-Aqua": "#e4717a",
  "Cotton-Candy-Pink": "#ffc0cb",
  "CottonCandy": "#e4717a",
  "County-Blue": "#0000ff",
  "Crain-Ecru": "#c2b280",
  "Cran/Black": "#000000",
  "Cranberry": "#8d4e85",
  "Cranberry-Black": "#000000",
  "Cranberry-Gold": "#8d4e85",
  "Cranberry-Nude": "#8d4e85",
  "Cream": "#fffdd0",
  "Cream Ivory": "#fffdd0",
  "Cream Nude": "#fffdd0",
  "Cream Pink": "#ffc0cb",
  "Cream-Black": "#000000",
  "Cream-Champagne": "#f7e7ce",
  "Cream-Denim-Gold": "#fffdd0",
  "Cream-Fuchsia": "#c74375",
  "Cream-Gold": "#fffdd0",
  "Cream-Indigo": "#fffdd0",
  "Cream-Ivory": "#fffdd0",
  "Cream-Mink": "#fffdd0",
  "Cream-Multi": "#fffdd0",
  "Cream-Nude": "#fffdd0",
  "Cream-Oil": "#fffdd0",
  "Cream-Orange": "#fffdd0",
  "Cream-Sax-Blue": "#6382b9",
  "Cream-Silver": "#fffdd0",
  "Cream/Antique": "#986335",
  "Cream/Black": "#000000",
  "Cream/Blue": "#6382b9",
  "Cream/Champagne": "#f7e7ce",
  "Cream/Gold": "#fffdd0",
  "Cream/Ivory": "#fffdd0",
  "Cream/Nude": "#fffdd0",
  "Cream/Silver": "#fffdd0",
  "Creamy": "#fffdd0",
  "Creamy-Blue": "#6382b9",
  "Creme": "#fffdd0",
  "Creme Menthe": "#fffdd0",
  "Creme-Brulee": "#a48465",
  "Creme-Nude": "#eeece7",
  "Crepe-Ivory": "#fffff0",
  "Crimson": "#dc143c",
  "Crimson-Gold": "#d4af37",
  "Crimson-Red": "#990000",
  "Crimson-Rose": "#88474e",
  "Crimson/Gold": "#d4af37",
  "Crimson/Nude": "#eeece7",
  "Cristal": "#a7d8de",
  "Crushed Berry": "#8d4e85",
  "Crushed-Berry": "#8d4e85",
  "Crystal": "#a7d8de",
  "Crystal Blue": "#68a0b0",
  "Crystal Champagne": "#f7e7ce",
  "Crystal Ice": "#a7d8de",
  "Crystal Nude": "#eeece7",
  "Crystal Pink": "#ffc0cb",
  "Crystal Royal": "#4169e1",
  "Crystal White": "#ffffff",
  "Crystal-Blush": "#de5d83",
  "Crystal-Fuchsia": "#c74375",
  "Crystal-Gold": "#d4af37",
  "Crystal-Ice": "#a7d8de",
  "Crystal-Ivory": "#fffff0",
  "Crystal-Ivory-Nude": "#fffff0",
  "Crystal-Multi": "#a7d8de",
  "Crystal-Nude": "#eeece7",
  "Crystal-Red": "#a7d8de",
  "Crystal-Silver": "#c0c0c0",
  "Crystal-Silver-Nude": "#c0c0c0",
  "Crystal-Taupe": "#baa68e",
  "Crystal-White": "#ffffff",
  "Crystal-White-Multi": "#ffffff",
  "Currant": "#670f0f",
  "Curry": "#a77f0e",
  "Custard": "#f8e8a6",
  "Cyan": "#00b7eb",
  "Cyan Blue": "#4682bf",
  "Cyber Orange": "#ffa500",
  "Cyclamen": "#f56fa1",
  "Cypress": "#b5b8a0",
  "Cyprus": "#d4dbb5",
  "Daffodil": "#ffff31",
  "Daffodil-Nude": "#eeece7",
  "Daffodil/Nude": "#eeece7",
  "Dahlia": "#ec9688",
  "Daiquiri-Ice": "#e5f1e2",
  "Daisy": "#f8dc75",
  "Dalmatian": "#d73b3e",
  "Dark": "#153c4e",
  "Dark Aqua": "#153c4e",
  "Dark Berry": "#8d4e85",
  "Dark Blue": "#00008b",
  "Dark Blush": "#de5d83",
  "Dark Blush/Nude": "#de5d83",
  "Dark Brown": "#964b00",
  "Dark Champagne": "#f7e7ce",
  "Dark Cocoa": "#583318",
  "Dark Coral": "#FF7F50",
  "Dark Emerald": "#50c878",
  "Dark Fuchsia": "#c74375",
  "Dark Gold": "#d4af37",
  "Dark Green": "#006400",
  "Dark Green Sage": "#006400",
  "Dark Grey": "#808080",
  "Dark Jade": "#09363c",
  "Dark Lavender": "#b57edc",
  "Dark Lead": "#6d6a65",
  "Dark Lilac": "#9955bb",
  "Dark Magenta": "#ff0090",
  "Dark Mauve": "#e0b0ff",
  "Dark Mink": "#d2b7a6",
  "Dark Multi": "#153c4e",
  "Dark Navy": "#000080",
  "Dark Nude": "#eeece7",
  "Dark Nude/Multi": "#eeece7",
  "Dark Olive": "#808000",
  "Dark Papaya": "#ffc281",
  "Dark Periwinkle": "#c3cde6",
  "Dark Pink": "#ffc0cb",
  "Dark Plum": "#3e3844",
  "Dark Purple": "#6a0dad",
  "Dark Purple/Multi": "#6a0dad",
  "Dark Raspberry": "#8d4e85",
  "Dark Red": "#8b0000",
  "Dark Rose": "#88474e",
  "Dark Royal": "#4169e1",
  "Dark Sage": "#6c765b",
  "Dark Silver": "#c0c0c0",
  "Dark Silver/Nude": "#c0c0c0",
  "Dark Silver/Pink": "#ffc0cb",
  "Dark Stone": "#6d5000",
  "Dark Taupe": "#baa68e",
  "Dark Taupe/Sand": "#3c3e40",
  "Dark Teal": "#008080",
  "Dark Teal/Black": "#000000",
  "Dark Turquoise": "#40e0d0",
  "Dark Wash": "#48505d",
  "Dark White": "#ffffff",
  "Dark White/Silver": "#c0c0c0",
  "Dark Wine": "#6c5857",
  "Dark-Amethyst": "#48505d",
  "Dark-Beige": "#f5f5dc",
  "Dark-Blush": "#de5d83",
  "Dark-Burgundy": "#800020",
  "Dark-Chocolate": "#7b3f00",
  "Dark-Cocoa": "#583318",
  "Dark-Coffee": "#6f4e37",
  "Dark-Denim": "#48505d",
  "Dark-Emerald": "#50c878",
  "Dark-Forest-Green": "#006400",
  "Dark-French-Blue": "#00008b",
  "Dark-Fuchsia": "#c74375",
  "Dark-Gold": "#d4af37",
  "Dark-Gold-Black": "#000000",
  "Dark-Green-Sage": "#006400",
  "Dark-Grey": "#808080",
  "Dark-Grey-Multi": "#808080",
  "Dark-Hunter-Green": "#355e3b",
  "Dark-Indigo": "#153c4e",
  "Dark-Ivory": "#fffff0",
  "Dark-Mauve": "#e0b0ff",
  "Dark-Mauve-Multi": "#e0b0ff",
  "Dark-Mauve-Rosewater": "#88474e",
  "Dark-Mink": "#153c4e",
  "Dark-Mint": "#98ff98",
  "Dark-Mocha": "#bea493",
  "Dark-Navy-Gunmetal": "#000080",
  "Dark-Nude": "#eeece7",
  "Dark-Nude-Multi": "#eeece7",
  "Dark-Olive": "#808000",
  "Dark-Orange": "#ffa500",
  "Dark-Orchid": "#da70d6",
  "Dark-Papaya": "#ffc281",
  "Dark-Peacock-Nude": "#008381",
  "Dark-Pearl": "#426384",
  "Dark-Platinum": "#e5e4e2",
  "Dark-Plum": "#3e3844",
  "Dark-Purple": "#6a0dad",
  "Dark-Purple-Gold": "#d4af37",
  "Dark-Purple-Light-Purple": "#6a0dad",
  "Dark-Purple-Rose-Gold": "#88474e",
  "Dark-Raspberry": "#8d4e85",
  "Dark-Red-Multi": "#8b0000",
  "Dark-Royal": "#4169e1",
  "Dark-Seafoam": "#9fe2bf",
  "Dark-Sienna": "#3c1414",
  "Dark-Silver": "#c0c0c0",
  "Dark-Slate": "#708090",
  "Dark-Smoke": "#738276",
  "Dark-Stone": "#6d5000",
  "Dark-Teal": "#008080",
  "Dark-Teal-Black": "#000000",
  "Dark-Topaz": "#ffc87c",
  "Dark-White": "#ffffff",
  "Dark-Wine": "#6c5857",
  "Deep Blue": "#00008b",
  "Deep Blush": "#de5d83",
  "Deep Claret": "#973443",
  "Deep Cobalt": "#0047ab",
  "Deep Coral": "#FF7F50",
  "Deep Emerald": "#50c878",
  "Deep Green": "#056608",
  "Deep Indigo White": "#ffffff",
  "Deep Lilac": "#9955bb",
  "Deep Magenta": "#ff0090",
  "Deep Marsala": "#975a59",
  "Deep Mauve": "#e0b0ff",
  "Deep Navy": "#000080",
  "Deep Orchid": "#da70d6",
  "Deep Pink": "#ffc0cb",
  "Deep Purple": "#6a0dad",
  "Deep Purple Multi": "#6a0dad",
  "Deep Raspberry": "#8d4e85",
  "Deep Red": "#850101",
  "Deep Royal": "#4169e1",
  "Deep Ruby": "#9b111e",
  "Deep Sea": "#167e65",
  "Deep Sea Blue": "#00008b",
  "Deep Teal": "#008080",
  "Deep Turquoise": "#40e0d0",
  "Deep Violet": "#9400d3",
  "Deep Water": "#266691",
  "Deep-Amethyst": "#9c8aa4",
  "Deep-Aqua": "#155553",
  "Deep-Blue": "#00008b",
  "Deep-Champagne": "#f7e7ce",
  "Deep-Claret": "#973443",
  "Deep-Cobalt": "#0047ab",
  "Deep-Coral": "#FF7F50",
  "Deep-French-Blue": "#00008b",
  "Deep-Fuchsia": "#c74375",
  "Deep-Gold": "#d4af37",
  "Deep-Indigo": "#475279",
  "Deep-Jade": "#09363c",
  "Deep-Mauve": "#e0b0ff",
  "Deep-Navy": "#000080",
  "Deep-Ocean": "#48bf91",
  "Deep-Orange": "#ffa500",
  "Deep-Periwinkle": "#c3cde6",
  "Deep-Pink": "#ffc0cb",
  "Deep-Plum-Blush": "#3e3844",
  "Deep-Red": "#850101",
  "Deep-Red-Nude": "#850101",
  "Deep-Rose": "#88474e",
  "Deep-Rose-Velvet": "#88474e",
  "Deep-Sage": "#bcb88a",
  "Deep-Sea": "#167e65",
  "Deep-Spruce": "#38544a",
  "Deep-Teal": "#008080",
  "Deep-Violet": "#9400d3",
  "Deep-Water": "#266691",
  "Deep-Wine": "#6c5857",
  "Deep/Dark Green": "#056608",
  "Delphi": "#d3b176",
  "Delphi-Blue": "#d3b176",
  "Delphinium": "#d3b176",
  "Demure": "#ddd3db",
  "Denim": "#2243b6",
  "Denim/Nude": "#eeece7",
  "Desert": "#edc9af",
  "Desert Peach": "#edc9af",
  "Desert Rose": "#88474e",
  "Desert-Blue": "#9acae7",
  "Desert-Rose": "#88474e",
  "Desert-Snake": "#edc9af",
  "Diamond": "#b9f2ff",
  "Diamond White": "#f8f4ec",
  "Diamond White Multi": "#f8f4ec",
  "Diamond White Solid": "#f8f4ec",
  "Diamond White-Black": "#f8f4ec",
  "Diamond White-Blue": "#f8f4ec",
  "Diamond White-Champagne": "#f8f4ec",
  "Diamond White-Gold": "#f8f4ec",
  "Diamond White-Multi": "#f8f4ec",
  "Diamond White-Nude": "#f8f4ec",
  "Diamond White-Red": "#f8f4ec",
  "Diamond White-Royal": "#f8f4ec",
  "Diamond White-Silver": "#f8f4ec",
  "Diamond White/Black": "#f8f4ec",
  "Diamond White/Charcoal": "#f8f4ec",
  "Diamond White/Coral": "#f8f4ec",
  "Diamond White/Diamond White": "#f8f4ec",
  "Diamond White/Fuchsia": "#f8f4ec",
  "Diamond White/Gold": "#f8f4ec",
  "Diamond White/Gold/Silver": "#f8f4ec",
  "Diamond White/Multi": "#f8f4ec",
  "Diamond White/Nude": "#f8f4ec",
  "Diamond White/Red": "#f8f4ec",
  "Diamond White/Rosewater": "#f8f4ec",
  "Diamond White/Silver": "#f8f4ec",
  "Diamond White/Turquoise": "#f8f4ec",
  "Diamond-White-Ab": "#f8f4ec",
  "Diamond-White-Azure": "#f8f4ec",
  "Diamond-White-Black": "#f8f4ec",
  "Diamond-White-Black-Silver": "#f8f4ec",
  "Diamond-White-Blue": "#f8f4ec",
  "Diamond-White-Blue-Iris-Lace": "#f8f4ec",
  "Diamond-White-Blush": "#f8f4ec",
  "Diamond-White-Cashmere-Rose": "#f8f4ec",
  "Diamond-White-Chalk-Pink": "#f8f4ec",
  "Diamond-White-French-Pink": "#f8f4ec",
  "Diamond-White-Glacier-Blue": "#f8f4ec",
  "Diamond-White-Gold": "#f8f4ec",
  "Diamond-White-Ice-Blue": "#f8f4ec",
  "Diamond-White-Icelandic-Blue": "#f8f4ec",
  "Diamond-White-Latte": "#f8f4ec",
  "Diamond-White-Lemon-Drop": "#f8f4ec",
  "Diamond-White-Light-Latte": "#f8f4ec",
  "Diamond-White-Light-Yellow": "#f8f4ec",
  "Diamond-White-Lilac": "#f8f4ec",
  "Diamond-White-Magenta": "#f8f4ec",
  "Diamond-White-Malibu": "#f8f4ec",
  "Diamond-White-Midnight": "#f8f4ec",
  "Diamond-White-Midnight-Lace": "#f8f4ec",
  "Diamond-White-Navy": "#f8f4ec",
  "Diamond-White-Nude": "#f8f4ec",
  "Diamond-White-Opal": "#f8f4ec",
  "Diamond-White-Pink": "#f8f4ec",
  "Diamond-White-Rosewater": "#f8f4ec",
  "Diamond-White-Rosewater-Lining": "#f8f4ec",
  "Diamond-White-Ruby": "#f8f4ec",
  "Diamond-White-Salmon": "#f8f4ec",
  "Diamond-White-Sand": "#f8f4ec",
  "Diamond-White-Sand-Lining": "#f8f4ec",
  "Diamond-White-Seaglass": "#f8f4ec",
  "Diamond-White-Silver": "#f8f4ec",
  "Diamond-White-Solid": "#f8f4ec",
  "Diamond-White-Tulle-Blue-Iris": "#f8f4ec",
  "Dijon": "#cbbd55",
  "Dirty Blue": "#9b7653",
  "Disco-Blue": "#0fc0fc",
  "Disco-Leopard": "#dfe2de",
  "Disco-Silver": "#c0c0c0",
  "Doll-Pink": "#ffc0cb",
  "Dolphin": "#4b6f91",
  "Dolphin-Blue": "#7c9caa",
  "Dolphin-Pearl": "#426384",
  "Dove": "#afb8bd",
  "Dove Grey": "#808080",
  "Dove Grey/Silver": "#808080",
  "Dove-Blue": "#9aafc4",
  "Dragon Scale": "#00a877",
  "Dragon-Scale": "#00a877",
  "Dragonfly": "#00a877",
  "Dragonfly-Blue": "#304a77",
  "Dragonscale": "#00a877",
  "Dream-Blue": "#a0bcd0",
  "Dreamcicle": "#fbd9bb",
  "Dreamsicle": "#fbd9bb",
  "Dreamsicle-Ivory": "#fffff0",
  "Dreamsicle-Lt-Orange": "#ffa500",
  "Dreamsicle-Multi": "#fbd9bb",
  "Dripping Diamonds": "#b9f2ff",
  "Dripping-Diamonds": "#b9f2ff",
  "Dripping-Diamonds-Silver": "#b9f2ff",
  "Duck Egg Blue": "#b4cdc7",
  "Dusk": "#a29996",
  "Dusk-Nude": "#eeece7",
  "Dusty Blue": "#8C9DAD",
  "Dusty Blue/Green": "#056608",
  "Dusty Lavender": "#b57edc",
  "Dusty Nude": "#eeece7",
  "Dusty Peach": "#a29996",
  "Dusty Pink": "#ffc0cb",
  "Dusty Pink/Smoke": "#ffc0cb",
  "Dusty Purple": "#6a0dad",
  "Dusty Rose": "#88474e",
  "Dusty-Blue": "#8C9DAD",
  "Dusty-Blue-Gold": "#8C9DAD",
  "Dusty-Blue-Mocha": "#8C9DAD",
  "Dusty-Blue-Nude": "#8C9DAD",
  "Dusty-Blush": "#de5d83",
  "Dusty-Champagne": "#f7e7ce",
  "Dusty-Coral": "#FF7F50",
  "Dusty-Green": "#a5a684",
  "Dusty-Lavender": "#b57edc",
  "Dusty-Lilac": "#9955bb",
  "Dusty-Lilac-Multi": "#9955bb",
  "Dusty-Mauve": "#e0b0ff",
  "Dusty-Mint": "#98ff98",
  "Dusty-Periwinkle": "#c3cde6",
  "Dusty-Pink": "#ffc0cb",
  "Dusty-Pink-Multi": "#ffc0cb",
  "Dusty-Pink-Ombre": "#ffc0cb",
  "Dusty-Pink-Smoke": "#ffc0cb",
  "Dusty-Plum": "#3e3844",
  "Dusty-Rose": "#88474e",
  "Dusty-Rose-Black": "#000000",
  "Dusty-rose-Gold": "#88474e",
  "Dusty-Rose-Pearl": "#426384",
  "Dusty-Rose-Shimmer": "#88474e",
  "Dusty-Rose-Silver": "#88474e",
  "Dusty-Rose-Solid": "#88474e",
  "Dusty-RoseBurgundy": "#800020",
  "Dusty-Sage": "#a29996",
  "Dusty-Teal": "#008080",
  "Dusty-Violet": "#9400d3",
  "Dusty/Teal": "#008080",
  "DustyRose": "#88474e",
  "Earth-Red": "#b86948",
  "Eau-De-Nil": "#a4b887",
  "Ecru": "#c2b280",
  "Ecru-Beige": "#f5f5dc",
  "Ecru-Gold": "#c2b280",
  "Ecru-Multi": "#c2b280",
  "Eggplant": "#a4b887",
  "Eggplant-Cashmere-Rose": "#88474e",
  "Eggplant-Gold": "#d4af37",
  "Eggplant-Gunmetal": "#2a3439",
  "Eggplant-Multi": "#a4b887",
  "Eggplant-Purple": "#6a0dad",
  "Eggplant/Silver": "#c0c0c0",
  "Eggplant/Smoke/Multi": "#738276",
  "Eggshell": "#f0ead6",
  "Eggshell-Pink": "#ffc0cb",
  "Electric Blue": "#7df9ff",
  "Electric Green": "#00ff00",
  "Electric Lime": "#00ff00",
  "Electric Pink": "#ffc0cb",
  "Electric Purple": "#6a0dad",
  "Electric Purple/Gold": "#d4af37",
  "Electric Red": "#e60000",
  "Electric-Aqua": "#00FFFF",
  "Electric-Berry": "#8d4e85",
  "Electric-Blue": "#7df9ff",
  "Electric-Blue-Multi": "#7df9ff",
  "Electric-Blue-Nude": "#7df9ff",
  "Electric-Bronze": "#b08d57",
  "Electric-Champagne": "#f7e7ce",
  "Electric-Cobalt": "#0047ab",
  "Electric-Coral": "#FF7F50",
  "Electric-Dark-Pink": "#ffc0cb",
  "Electric-Emerald": "#50c878",
  "Electric-Fuchsia": "#c74375",
  "Electric-Gold": "#d4af37",
  "Electric-Green": "#00ff00",
  "Electric-Gunmetal": "#2a3439",
  "Electric-Lilac": "#9955bb",
  "Electric-Mauve": "#e0b0ff",
  "Electric-Navy": "#000080",
  "Electric-Papaya": "#d23b05",
  "Electric-Pink": "#ffc0cb",
  "Electric-Purple": "#6a0dad",
  "Electric-Rose": "#fbcce7",
  "Electric-Royal": "#4169e1",
  "Electric-Silver": "#c0c0c0",
  "Electric-Sky-Blue": "#7df9ff",
  "Electric-Teal": "#008080",
  "Electric-Turquoise": "#40e0d0",
  "Electric-Wine": "#6c5857",
  "Emer Green/Sapphire": "#00ff00",
  "Emerald": "#50c878",
  "Emerald Green": "#046307",
  "Emerald Green/Sapphire": "#046307",
  "Emerald Nude": "#50c878",
  "Emerald Ombre": "#50c878",
  "Emerald Rose": "#fbcce7",
  "Emerald-Emerald": "#50c878",
  "Emerald-Gold": "#d4af37",
  "Emerald-Isle": "#50c878",
  "Emerald-Multi": "#50c878",
  "Emerald-Nude": "#50c878",
  "Emerald-Royal": "#50c878",
  "Emerald-Sage": "#50c878",
  "Emerald-Shimmer": "#e3c9ab",
  "Emerald-Silver": "#c0c0c0",
  "Emerald/Black": "#000000",
  "Emerald/Blue": "#0f5d5e",
  "Emerald/Gold": "#d4af37",
  "Emerald/Nude": "#50c878",
  "Emerald/White": "#50c878",
  "Emergency Kit": "#e36841",
  "Empire State Pink": "#ffc0cb",
  "Empress": "#0f5f5c",
  "English Rose": "#fbcce7",
  "English Violet": "#7f00ff",
  "English-Green": "#008000",
  "English-Manor": "#7181a4",
  "English-Rose": "#fbcce7",
  "English-Rose-Nude": "#fbcce7",
  "English-Rose-Silver": "#fbcce7",
  "English-Violet": "#7f00ff",
  "Envy": "#009440",
  "Envy Green": "#6da544",
  "Espresso": "#363031",
  "eucalyptus": "#44d7a8",
  "Evergreen": "#26453e",
  "Evergreen-Black": "#26453e",
  "Fandango-Purple": "#6a0dad",
  "Fantasia": "#c4b3d6",
  "Fawn": "#e5aa70",
  "Fern": "#4f7942",
  "Ferrari Red": "#ff2800",
  "Fiery-Red": "#d01c1f",
  "Fiery-Red-Jet-Black": "#000000",
  "Fiesta": "#dd4132",
  "Fig": "#848c7c",
  "Fil-Coupe": "#e80085",
  "Fire Red": "#d01c1f",
  "Fire Red/Nude": "#d01c1f",
  "Firecracker": "#f36944",
  "Firecracker-Red": "#d01c1f",
  "Firestone": "#ec1e2f",
  "Fizzy": "#b7c143",
  "Flame": "#e25822",
  "Flame Coral": "#FF7F50",
  "Flame Red": "#d01c1f",
  "Flamingo": "#fc8eac",
  "Flamingo Pink": "#ffc0cb",
  "Flamingo-Pink": "#ffc0cb",
  "Floral": "#b57edc",
  "Floral Multi": "#b57edc",
  "Floral Multi Print": "#b57edc",
  "Floral Patterns": "#b57edc",
  "Floral Print": "#b57edc",
  "Floral-Fantasy": "#b57edc",
  "Floral-Multi": "#b57edc",
  "Floral-Patterns": "#b57edc",
  "Floral-Pink": "#b57edc",
  "Floral-Print": "#b57edc",
  "Floral-Rain": "#b57edc",
  "Floral-Romance": "#b57edc",
  "Fluorescent-Sky": "#87ceeb",
  "Foam": "#adc3b4",
  "Foam-Green": "#9fe2bf",
  "Fog": "#abaeb0",
  "Forest": "#014421",
  "Forest Green": "#228B22",
  "Forest Green/Nude": "#228B22",
  "Forest Green/Silver": "#228B22",
  "Forest Moss": "#014421",
  "Forest-Black": "#000000",
  "Forest-Dragon-Scale": "#014421",
  "Forest-Gold": "#d4af37",
  "Forest-Nude": "#eeece7",
  "Forest/Nude": "#eeece7",
  "Forrest Green": "#228B22",
  "Forrest-Green": "#228B22",
  "Foundation": "#e8e2de",
  "Foundation Nude": "#eeece7",
  "Frappuccino": "#a99a8c",
  "Freeze Pink/Silver": "#ffc0cb",
  "Freeze-Pink": "#ffc0cb",
  "French Blue": "#0072bb",
  "French Navy": "#000080",
  "French Pink": "#ffc0cb",
  "French Rose": "#fbcce7",
  "French Taupe": "#baa68e",
  "French-Blue": "#0072bb",
  "French-Blue-Navy": "#000080",
  "French-Blue-Nude": "#0072bb",
  "French-Grey": "#808080",
  "French-Lilac": "#9955bb",
  "French-Mauve": "#e0b0ff",
  "French-Navy": "#000080",
  "French-Pink": "#ffc0cb",
  "French-Pink-Ivory": "#ffc0cb",
  "French-Pink-Silver-Lake": "#ffc0cb",
  "French-Pink-Solid": "#ffc0cb",
  "French-Plum": "#8e4585",
  "French-Vanilla": "#fdead9",
  "French-Violet": "#7f00ff",
  "French-White": "#ffffff",
  "Fresh Aubergine": "#5e4052",
  "Frost": "#f2edd5",
  "Frost blue": "#bfdfed",
  "Frost-Blue-Print": "#bfdfed",
  "Frost-Rose": "#fbcce7",
  "Frosted Mocha": "#bea493",
  "Frosted-Mocha": "#bea493",
  "Frosty-Blue": "#bfdfed",
  "Frosty-Green": "#a3b5a6",
  "Frosty-Meadow": "#a69780",
  "Frozen-Blue": "#bfdfed",
  "Fuchsia": "#c74375",
  "Fuchsia Multi": "#c74375",
  "Fuchsia Ombre": "#c74375",
  "Fuchsia Pink": "#c74375",
  "Fuchsia Print": "#c74375",
  "Fuchsia Red": "#c74375",
  "Fuchsia Yellow": "#c74375",
  "Fuchsia-Blue": "#c74375",
  "Fuchsia-Ecru": "#c74375",
  "Fuchsia-Floral": "#b57edc",
  "Fuchsia-Green": "#c74375",
  "Fuchsia-Hot Red": "#c74375",
  "Fuchsia-Ivory-Polka": "#c74375",
  "Fuchsia-Lilac": "#c74375",
  "Fuchsia-Lilac-Print": "#c74375",
  "Fuchsia-Lime": "#c74375",
  "Fuchsia-Navy": "#c74375",
  "Fuchsia-Orange": "#c74375",
  "Fuchsia-Red": "#c74375",
  "Fuchsia-Rose": "#c74375",
  "Fuchsia-Rose-Gold": "#c74375",
  "Fuchsia-Royal": "#c74375",
  "Fuchsia-Royal-Blue": "#c74375",
  "Fuchsia-Sky": "#c74375",
  "Fuchsia-Tangerine": "#c74375",
  "Fuchsia-Yellow": "#c74375",
  "Fuchsia-Yellow-Floral": "#b57edc",
  "Fuchsia/Aqua": "#c74375",
  "Fuchsia/Black": "#c74375",
  "Fuchsia/Coral": "#c74375",
  "Fuchsia/Gold": "#c74375",
  "Fuchsia/Ivory/Black": "#c74375",
  "Fuchsia/Lime Green": "#c74375",
  "Fuchsia/Navy": "#c74375",
  "Fuchsia/Nude": "#c74375",
  "Fuchsia/Orange": "#c74375",
  "Fuchsia/Pink": "#c74375",
  "Fuchsia/Purple": "#c74375",
  "Fuchsia/Red": "#c74375",
  "Fuchsia/Royal": "#c74375",
  "Fuchsia/Silver": "#c74375",
  "Fuchsia/Turquoise": "#c74375",
  "Fuchsia/White": "#c74375",
  "Fuchsia/Yellow": "#c74375",
  "Fuschia": "#c74375",
  "Fuschia-Nude": "#eeece7",
  "Fuschia-Pink": "#ffc0cb",
  "Fuschia-Solid": "#c74375",
  "Fushia/Black": "#000000",
  "Fusion Lilac": "#9955bb",
  "Fusion-Blue": "#53687c",
  "Galactic-Purple": "#6a0dad",
  "Galaxy": "#26457a",
  "Garnet": "#733635",
  "Gilded Blue": "#d0bc8d",
  "Gilded-Floral": "#b57edc",
  "Ginger": "#96665a",
  "Glacial-Green": "#d4e5d3",
  "Glacier": "#aad3e9",
  "Glacier Blue": "#aad3e9",
  "Glacier-Silver": "#c0c0c0",
  "Glossy-Blue": "#d0d9d8",
  "Glossy-Pink": "#ffc0cb",
  "Gold": "#d4af37",
  "Gold Bronze": "#d4af37",
  "Gold Green": "#d8bb78",
  "Gold Multi": "#d4af37",
  "Gold-AB": "#d4af37",
  "Gold-Amethyst": "#d4af37",
  "Gold-Aqua": "#d4af37",
  "Gold-Blue": "#0000ff",
  "Gold-Blush": "#d4af37",
  "Gold-Bronze": "#d4af37",
  "Gold-Champagne": "#f7e7ce",
  "Gold-Coral": "#d4af37",
  "Gold-Crystal": "#a7d8de",
  "Gold-Dust": "#d4af37",
  "Gold-Ecru": "#c2b280",
  "Gold-Electric-Pink": "#ffc0cb",
  "Gold-Fuchsia": "#c74375",
  "Gold-Fuschia": "#c74375",
  "Gold-Glitter": "#d4af37",
  "Gold-Green": "#d8bb78",
  "Gold-Grey": "#d4af37",
  "Gold-Hot-Pink": "#ffc0cb",
  "Gold-Indigo": "#d4af37",
  "Gold-Ivory-Antique": "#986335",
  "Gold-Ivory-Cafe": "#d4af37",
  "Gold-Leaf": "#d4af37",
  "Gold-Light-White": "#d4af37",
  "Gold-Lilac": "#9955bb",
  "Gold-Lt-Blue": "#d4af37",
  "Gold-Metallic": "#d4af37",
  "Gold-Mint": "#d4af37",
  "Gold-Mist": "#d4af37",
  "Gold-Mocha": "#d4af37",
  "Gold-Navy": "#000080",
  "Gold-Nude": "#d4af37",
  "Gold-Ombre": "#d4af37",
  "Gold-Pearl": "#426384",
  "Gold-Pewter": "#d4af37",
  "Gold-pink": "#ffc0cb",
  "Gold-Platinum": "#d4af37",
  "Gold-Purple": "#d4af37",
  "Gold-Red": "#ff0000",
  "Gold-Rose": "#fbcce7",
  "Gold-Royal": "#d4af37",
  "Gold-Sage": "#d4af37",
  "Gold-Sequin": "#d4af37",
  "Gold-Shimmer": "#d4af37",
  "Gold-Teal": "#d4af37",
  "Gold-Topaz": "#d4af37",
  "Gold-Turq": "#d4af37",
  "Gold-turquoise": "#d4af37",
  "Gold-Turquoise-Aqua": "#d4af37",
  "Gold-Violet": "#d4af37",
  "Gold-White": "#d4af37",
  "Gold-Wine": "#6c5857",
  "Gold-Yellow": "#d4af37",
  "Gold/Aqua": "#d4af37",
  "Gold/Black": "#000000",
  "Gold/Brown": "#d4af37",
  "Gold/Burgundy": "#800020",
  "Gold/Coral": "#d4af37",
  "Gold/Crystal": "#a7d8de",
  "Gold/Gold": "#d4af37",
  "Gold/Ivory": "#d4af37",
  "Gold/Nude": "#d4af37",
  "Gold/Peach": "#d4af37",
  "Gold/Pink": "#ffc0cb",
  "Gold/Print": "#d4af37",
  "Gold/Purple/Multi": "#d4af37",
  "Gold/Sapphire": "#0f52ba",
  "Gold/Silver": "#d4af37",
  "Gold/Watermelon": "#d4af37",
  "Gold/White": "#d4af37",
  "Golden": "#d4af37",
  "Golden Olive": "#d4af37",
  "Golden Yellow": "#d4af37",
  "Golden-Blue": "#0000ff",
  "Golden-Cheetah": "#cf9c76",
  "Golden-Mix": "#d4af37",
  "Granite": "#676767",
  "Grape": "#6f2da8",
  "Graphite": "#27292b",
  "Graphite-Black": "#000000",
  "Graphite-Multi": "#27292b",
  "Graphite-Rosewater": "#fbcce7",
  "Graphite-Rosewater-Pink": "#fbcce7",
  "Graphite-Sage": "#27292b",
  "Graphite-Silver": "#27292b",
  "Graphite-Solid": "#27292b",
  "Graphite/Blush": "#27292b",
  "Graphite/Coral": "#27292b",
  "Gray-Blue": "#0000ff",
  "Gray-Bronze": "#b08d57",
  "Green": "#008001",
  "Green Multi": "#008001",
  "Green Print": "#008001",
  "Green-Apple": "#008001",
  "Green-Aqua": "#008001",
  "Green-Black-Blue": "#008001",
  "Green-Blue": "#008001",
  "Green-Floral": "#b57edc",
  "Green-Galaxy": "#008001",
  "Green-Genie": "#008001",
  "Green-Gold": "#008001",
  "Green-Green": "#008001",
  "Green-Lava": "#008001",
  "Green-Mist": "#008001",
  "Green-Navy": "#1164b4",
  "Green-Pastures": "#008001",
  "Green-Pastures-Jet-Black": "#008001",
  "Green-Pink": "#008001",
  "Green-Purple": "#008001",
  "Green-Red": "#008001",
  "Green-Royal": "#008001",
  "Green-Shimmer": "#008001",
  "Green-Silver": "#008001",
  "Green-Surge": "#008001",
  "Green-Topaz": "#008001",
  "Green-Turquoise-Mix": "#008001",
  "Green-Water": "#008001",
  "Green-White": "#008001",
  "Green-Yellow": "#008001",
  "Green/Black": "#008001",
  "Green/Blue Print": "#008001",
  "Green/Nude": "#008001",
  "Green/Print": "#008001",
  "Green/Sky Ombre": "#008001",
  "Greenery": "#008001",
  "Greige": "#B0A999",
  "Greige-Bronze": "#b08d57",
  "Grey": "#808080",
  "Grey Multi": "#808080",
  "Grey Nude": "#808080",
  "Grey Ombre": "#808080",
  "Grey Pink": "#ffc0cb",
  "Grey stone": "#808080",
  "Grey-Black": "#000000",
  "Grey-French-Pink": "#ffc0cb",
  "Grey-Gold": "#d4af37",
  "Grey-Gold-Black": "#000000",
  "Grey-Green": "#75816b",
  "Grey-Gunmetal": "#808080",
  "Grey-Lavender": "#808080",
  "Grey-Mauve": "#808080",
  "Grey-Mist": "#808080",
  "Grey-Navy": "#000080",
  "Grey-Nude": "#808080",
  "Grey-Pearl": "#426384",
  "Grey-Pink": "#ffc0cb",
  "Grey-Pink-Alabaster": "#ffc0cb",
  "Grey-Powder": "#808080",
  "Grey-Purple": "#808080",
  "Grey-Red": "#ff0000",
  "Grey-Rose-Gold": "#fbcce7",
  "Grey-Rosegold": "#fbcce7",
  "Grey-Royal": "#808080",
  "Grey-White": "#808080",
  "Grey/Blue": "#0000ff",
  "Grey/Blush": "#808080",
  "Grey/Gold": "#d4af37",
  "Grey/Heather": "#808080",
  "Grey/Nude": "#808080",
  "Grey/Peach": "#808080",
  "Grey/Pink": "#ffc0cb",
  "Grey/Rose Gold": "#fbcce7",
  "Grey/Silver": "#808080",
  "Grey/White": "#808080",
  "Greystone": "#808080",
  "Guava": "#ec6a4b",
  "Gun-Metal": "#2a3439",
  "Gunmetal": "#2a3439",
  "Gunmetal Gunmetal": "#2a3439",
  "Gunmetal Midnight": "#2a3439",
  "Gunmetal Nude": "#2a3439",
  "Gunmetal Ombre": "#2a3439",
  "Gunmetal-Black": "#000000",
  "Gunmetal-Blue": "#0000ff",
  "Gunmetal-Blush": "#2a3439",
  "Gunmetal-Cream": "#fffdd0",
  "Gunmetal-Fuchsia": "#c74375",
  "Gunmetal-Gold": "#d4af37",
  "Gunmetal-Grey": "#808080",
  "Gunmetal-Gunmetal": "#2a3439",
  "Gunmetal-Hematite": "#2a3439",
  "Gunmetal-Ivory": "#2a3439",
  "Gunmetal-Multi": "#2a3439",
  "Gunmetal-Navy": "#000080",
  "Gunmetal-Nude": "#2a3439",
  "Gunmetal-Opal": "#91b660",
  "Gunmetal-Purple": "#2a3439",
  "Gunmetal-Rose-Gold": "#fbcce7",
  "Gunmetal-Royal": "#2a3439",
  "Gunmetal-Silver-Lake": "#2a3439",
  "Gunmetal-Teal": "#2a3439",
  "Gunmetal/Crystal": "#a7d8de",
  "Gunmetal/Gunmetal": "#2a3439",
  "Gunmetal/Nude": "#2a3439",
  "Gunmetal/Pink": "#ffc0cb",
  "Gunmetal/Silver": "#2a3439",
  "Gunmetal/Silver/Crystal": "#a7d8de",
  "Gunmteal-Nude": "#008080",
  "Harlequin": "#3fff00",
  "Haute-Pink": "#ffc0cb",
  "Haze": "#9f4576",
  "Haze Blue": "#0000ff",
  "Hazelnut": "#ae9f80",
  "Heart-Of-Gold": "#d4af37",
  "Heather": "#a6aac7",
  "Heather Purple": "#6a0dad",
  "Heather-Black": "#000000",
  "Heather-Grey": "#808080",
  "Heather-Multi": "#a6aac7",
  "Heather-Red": "#ae7a76",
  "Heather-Rose-Gold": "#fbcce7",
  "Heather-Silver": "#c0c0c0",
  "Hematite": "#574f50",
  "Hermes": "#f37021",
  "Hibiscus": "#f46b92",
  "High-Risk-Red": "#cc333d",
  "Hollywood-Pink": "#ffc0cb",
  "Hologram": "#c4b3d6",
  "Holographic-Gold-Black": "#000000",
  "Honey": "#E79A3F",
  "Honey Peach Solid": "#E79A3F",
  "Honey-Dew": "#E79A3F",
  "Honeycomb": "#E79A3F",
  "Honeydew": "#E79A3F",
  "Honeydew Multi": "#E79A3F",
  "Honeydew Nude": "#eeece7",
  "Honeydew Sky Blue": "#0000ff",
  "Honeydew-Nude": "#eeece7",
  "Hot Blue": "#0000ff",
  "Hot Coral": "#FF7F50",
  "Hot Coral/Nude": "#FF7F50",
  "Hot Fuchsia": "#c74375",
  "Hot Pink": "#ffc0cb",
  "Hot Pink Multi": "#ffc0cb",
  "Hot Pink Valentine": "#ffc0cb",
  "Hot Pink/Black": "#000000",
  "Hot Pink/Blue": "#0000ff",
  "Hot Pink/Gold": "#ffc0cb",
  "Hot Pink/Nude": "#ffc0cb",
  "Hot Pink/Silver": "#ffc0cb",
  "Hot Pink/Valentine": "#ffc0cb",
  "Hot Pink/White": "#ffc0cb",
  "Hot Red": "#bd1816",
  "Hot-Coral": "#FF7F50",
  "Hot-Coral-Black": "#000000",
  "Hot-Fuchsia": "#c74375",
  "Hot-Lime": "#00ff00",
  "Hot-Magenta": "#ff0090",
  "Hot-Orange": "#ffa500",
  "Hot-Pink": "#ffc0cb",
  "Hot-Pink-AB": "#ffc0cb",
  "Hot-Pink-Cherry": "#ffc0cb",
  "Hot-Pink-Gold": "#ffc0cb",
  "Hot-Pink-Navy": "#000080",
  "Hot-Pink-Ombre": "#ffc0cb",
  "Hot-Red": "#bd1816",
  "Hot-Red-Black-Polka": "#000000",
  "Hot-Red-Multi": "#bd1816",
  "Hot-Red-Nude": "#bd1816",
  "Hot-Yellow": "#ffff00",
  "HotPink": "#ffc0cb",
  "Hunter": "#355e3b",
  "Hunter Black": "#000000",
  "Hunter Green": "#355e3b",
  "Hunter Green/Black": "#355e3b",
  "Hunter-Black": "#000000",
  "Hunter-Green": "#355e3b",
  "Hunter-Green-Nude": "#355e3b",
  "Hunter-Nude": "#355e3b",
  "Hush": "#e5dad4",
  "Hush Multi": "#e5dad4",
  "Hush-Blush": "#de5d83",
  "Hyacinth": "#7a6c83",
  "Hyacinth-Blue": "#0000ff",
  "Hyacinth-Purple": "#6a0dad",
  "Hydrangea": "#849bcc",
  "Hydrangea Blue": "#90b0c5",
  "Hydrangea-(Blue)": "#90b0c5",
  "Hydrangea-Blue": "#90b0c5",
  "Hyper Pink": "#ffc0cb",
  "Hyper-Pink": "#ffc0cb",
  "Ice": "#e5e5e0",
  "Ice Blue": "#bddeec",
  "Ice Blue/Gold": "#bddeec",
  "Ice Blue/Nude": "#bddeec",
  "Ice Blue/Silver": "#bddeec",
  "Ice Grey": "#808080",
  "Ice Grey/Blue Willow": "#bddeec",
  "Ice Ice Baby": "#e5e5e0",
  "Ice Lilac": "#9955bb",
  "Ice Mint": "#98ff98",
  "Ice Mint/Coral": "#98ff98",
  "Ice Mint/Nude": "#98ff98",
  "Ice Pink": "#ffc0cb",
  "Ice Pink/Silver": "#ffc0cb",
  "Ice Purple": "#6a0dad",
  "Ice Water": "#e5e5e0",
  "Ice-Age": "#e5e5e0",
  "Ice-Blue": "#bddeec",
  "Ice-Blue-Blush": "#bddeec",
  "Ice-Blue-Multi": "#bddeec",
  "Ice-Blue-Nude": "#bddeec",
  "Ice-Blue-Silver": "#bddeec",
  "Ice-Blue-White": "#bddeec",
  "Ice-Blue-Yellow": "#bddeec",
  "Ice-Green": "#7fd6c1",
  "Ice-Grey": "#808080",
  "Ice-Ivory": "#fffff0",
  "Ice-Latte": "#e5e5e0",
  "Ice-Lilac": "#9955bb",
  "Ice-Lilac-Malibu": "#9955bb",
  "Ice-Multi": "#e5e5e0",
  "Ice-Nude": "#eeece7",
  "Ice-Pink": "#ffc0cb",
  "Ice-Pink-Coco": "#ffc0cb",
  "Ice-Pink-Silver": "#ffc0cb",
  "Ice-Silver": "#c0c0c0",
  "Ice-Smoke": "#738276",
  "Ice-Yellow": "#ffff00",
  "Iceberg": "#e5e5e0",
  "Iceberry": "#8d4e85",
  "Iced-Blue": "#bddeec",
  "Iced-Lilac": "#9955bb",
  "Iced-Mint": "#98ff98",
  "Iced-Pink": "#ffc0cb",
  "Icelandic Blue": "#bddeec",
  "Icelandic-Blue": "#bddeec",
  "Icelandic-Blue-Diamond-White": "#b9f2ff",
  "Icelandic-Blue-Diamond-White-Solid": "#b9f2ff",
  "Icelandic-Blue-Solid": "#bddeec",
  "Icy-Blue": "#bddeec",
  "Illusion-Blue": "#bddeec",
  "Imperial Violet": "#7f00ff",
  "Indigo": "#4b0082",
  "Indigo Blue": "#bddeec",
  "Indigo Blue Nude": "#bddeec",
  "Indigo Iridescent": "#18335e",
  "Indigo Silver": "#c0c0c0",
  "Indigo-Iridescent": "#18335e",
  "Indigo-Ombre": "#4b0082",
  "Indigo-Peacock": "#008381",
  "Indigo-Purple": "#6a0dad",
  "Indigo-Silver": "#c0c0c0",
  "Indigo/Blush": "#de5d83",
  "Indigo/Multi": "#4b0082",
  "Indigo/Nude": "#eeece7",
  "Ink": "#27221f",
  "Ink-Crocus-Print": "#27221f",
  "Intense Red": "#bd1816",
  "Iridescent": "#18335e",
  "Iridescent Aqua": "#18335e",
  "Iridescent Aqua Light Blue": "#86aba5",
  "Iridescent Berry": "#8d4e85",
  "Iridescent Black": "#000000",
  "Iridescent Black-Multi": "#000000",
  "Iridescent Blue": "#86aba5",
  "Iridescent Blush": "#18335e",
  "Iridescent Champagne": "#f7e7ce",
  "Iridescent Cobalt": "#18335e",
  "Iridescent Coral": "#18335e",
  "Iridescent Fuchsia": "#c74375",
  "Iridescent Green": "#253e35",
  "Iridescent Hot Pink": "#ffc0cb",
  "Iridescent Ivory": "#18335e",
  "Iridescent Jade": "#09363c",
  "Iridescent Light Blue": "#86aba5",
  "Iridescent Light Pink": "#ffc0cb",
  "Iridescent Lilac": "#9955bb",
  "Iridescent Lilac Periwinkle": "#9955bb",
  "Iridescent Mango": "#18335e",
  "Iridescent Nude": "#18335e",
  "Iridescent Ocean": "#18335e",
  "Iridescent Ocean Periwinkle": "#18335e",
  "Iridescent Orange": "#18335e",
  "Iridescent Orchid": "#18335e",
  "Iridescent Peach": "#18335e",
  "Iridescent Peacock": "#18335e",
  "Iridescent Periwinkle": "#18335e",
  "Iridescent pink": "#ffc0cb",
  "Iridescent Purple": "#18335e",
  "Iridescent Purple Ombre": "#18335e",
  "Iridescent Red": "#bd1816",
  "Iridescent Rose": "#fbcce7",
  "Iridescent Royal": "#18335e",
  "Iridescent Sage": "#18335e",
  "Iridescent Smoke": "#18335e",
  "Iridescent Taupe": "#18335e",
  "Iridescent Teal": "#18335e",
  "Iridescent Turquoise": "#18335e",
  "Iridescent Ultraviolet": "#18335e",
  "Iridescent Violet": "#18335e",
  "Iridescent White": "#18335e",
  "Iridescent Yellow": "#18335e",
  "Iridescent-Blue": "#86aba5",
  "Iridescent-Blush": "#18335e",
  "Iridescent-Cream": "#fffdd0",
  "Iridescent-Magenta": "#18335e",
  "Iridescent-Mint": "#98ff98",
  "Iridescent-Navy": "#000080",
  "Iridescent-Silver": "#18335e",
  "Iridescent-Turquoise": "#18335e",
  "Iridescent-Violet": "#18335e",
  "Iris": "#5a4fcf",
  "Iris-Multi": "#5a4fcf",
  "Iron": "#a19d94",
  "Irridescent Green": "#253e35",
  "Island Blue": "#86aba5",
  "Island-Blue": "#86aba5",
  "Ivory": "#fff8e7",
  "Ivory Aqua": "#fffff0",
  "Ivory Blush Pink": "#ffc0cb",
  "Ivory Cream": "#fffdd0",
  "Ivory Crystal": "#a7d8de",
  "Ivory Dark Champagne": "#f7e7ce",
  "Ivory Floral": "#b57edc",
  "Ivory Hot Pink": "#ffc0cb",
  "Ivory Iridescent": "#18335e",
  "Ivory Lemon": "#fffff0",
  "Ivory Multi": "#fffff0",
  "Ivory Orchid": "#fffff0",
  "Ivory Pink Pink": "#ffc0cb",
  "Ivory Print": "#fffff0",
  "Ivory Sand": "#3c3e40",
  "Ivory Sapphire": "#0f52ba",
  "Ivory Seafoam": "#fffff0",
  "Ivory Shell": "#fffff0",
  "Ivory Solid": "#fffff0",
  "Ivory White": "#fffff0",
  "Ivory Wine": "#6c5857",
  "Ivory-A-B": "#fffff0",
  "Ivory-AB": "#fffff0",
  "Ivory-Antique Blue": "#986335",
  "Ivory-Aqua": "#fffff0",
  "Ivory-Bisque": "#fffff0",
  "Ivory-Black-Blue": "#000000",
  "Ivory-Black-Ivory": "#000000",
  "Ivory-Black-Nude": "#000000",
  "Ivory-Blue": "#0000ff",
  "Ivory-Blue-Print": "#0000ff",
  "Ivory-Blush": "#fffff0",
  "Ivory-Cashmere-Rose": "#fbcce7",
  "Ivory-Champagne": "#f7e7ce",
  "Ivory-Champagne-Gold": "#f7e7ce",
  "Ivory-Chocolate": "#fffff0",
  "Ivory-Coral": "#fffff0",
  "Ivory-Cream": "#fffdd0",
  "Ivory-Crystal": "#a7d8de",
  "Ivory-Crystal-Nude": "#a7d8de",
  "Ivory-Eggshell": "#fffff0",
  "Ivory-Emerald": "#fffff0",
  "Ivory-Fuchsia": "#c74375",
  "Ivory-Fuchsia-Print": "#c74375",
  "Ivory-Gardenia": "#fffff0",
  "Ivory-Glacier-Blue": "#0000ff",
  "Ivory-Gold": "#d4af37",
  "Ivory-Gold-Blue": "#0000ff",
  "Ivory-Gold-Red": "#ff0000",
  "Ivory-Gold-Silver": "#d4af37",
  "Ivory-Green": "#008001",
  "Ivory-Grey": "#808080",
  "Ivory-Gunmetal": "#2a3439",
  "Ivory-Ice-Blue": "#0000ff",
  "Ivory-Ice-Pink": "#ffc0cb",
  "Ivory-Icelandic-Blue": "#0000ff",
  "Ivory-Kiwi": "#fffff0",
  "Ivory-Lace-Top-Multi-Printed-Skirt": "#fffff0",
  "Ivory-Latte": "#fffff0",
  "Ivory-Light-Latte": "#fffff0",
  "Ivory-Light-Nude": "#fffff0",
  "Ivory-Light-Orange": "#fffff0",
  "Ivory-Light-Turquoise": "#fffff0",
  "Ivory-Light-Yellow": "#fffff0",
  "Ivory-Lilac": "#9955bb",
  "Ivory-Lilac-Print": "#9955bb",
  "Ivory-Lime": "#fffff0",
  "Ivory-Mademoiselle": "#fffff0",
  "Ivory-Malibu": "#008cc1",
  "Ivory-Mauve": "#fffff0",
  "Ivory-Mint": "#98ff98",
  "Ivory-Mocha": "#fffff0",
  "Ivory-Navy": "#000080",
  "Ivory-Nude-Champagne": "#f7e7ce",
  "Ivory-Orange": "#fffff0",
  "Ivory-Pale-Pink": "#ffc0cb",
  "Ivory-Pearl": "#426384",
  "Ivory-Petal": "#fffff0",
  "Ivory-Pink-Champagne": "#ffc0cb",
  "Ivory-Pink-Print": "#ffc0cb",
  "Ivory-Platinum": "#fffff0",
  "Ivory-Powder-Blue": "#0000ff",
  "Ivory-Print-Green": "#008001",
  "Ivory-Purple": "#fffff0",
  "Ivory-Purple Floral": "#b57edc",
  "Ivory-Red-Print": "#ff0000",
  "Ivory-Romance": "#fffff0",
  "Ivory-Rose": "#fbcce7",
  "Ivory-Rose Gold": "#fbcce7",
  "Ivory-Rosewater": "#fbcce7",
  "Ivory-Royal-Blue": "#0000ff",
  "Ivory-Sage": "#fffff0",
  "Ivory-Sand": "#3c3e40",
  "Ivory-Shimmer": "#fffff0",
  "Ivory-Shiny": "#fffff0",
  "Ivory-Shiny-Silver": "#fffff0",
  "Ivory-Silver-Blue": "#0000ff",
  "Ivory-Silver-Blush": "#fffff0",
  "Ivory-Silver-Gold": "#d4af37",
  "Ivory-Silver-Gold-Nude": "#d4af37",
  "Ivory-Silver-Pink": "#ffc0cb",
  "Ivory-Sky-Blue": "#0000ff",
  "Ivory-Slate": "#fffff0",
  "Ivory-Solid": "#fffff0",
  "Ivory-Super-Pink": "#ffc0cb",
  "Ivory-Taupe": "#fffff0",
  "Ivory-Tea-Rose": "#fbcce7",
  "Ivory-Tiffany": "#fffff0",
  "Ivory-Wine": "#6c5857",
  "Ivory-Winter-Blue": "#0000ff",
  "Ivory-Xw": "#fffff0",
  "Ivory-Yellow": "#fffff0",
  "Ivory-Zink": "#fffff0",
  "Ivory/Antique Silver": "#986335",
  "Ivory/Aqua": "#fffff0",
  "Ivory/Black": "#000000",
  "Ivory/Black Multi": "#000000",
  "Ivory/Black/Nude": "#000000",
  "Ivory/Blue": "#0000ff",
  "Ivory/Blue Print": "#0000ff",
  "Ivory/Blue/Silver": "#0000ff",
  "Ivory/Blush": "#fffff0",
  "Ivory/Blush Pink": "#ffc0cb",
  "Ivory/Bronze": "#fffff0",
  "Ivory/Candy Pink": "#ffc0cb",
  "Ivory/Champagne": "#f7e7ce",
  "Ivory/Charcoal": "#36454f",
  "Ivory/Cream": "#fffdd0",
  "Ivory/Fuchsia": "#c74375",
  "Ivory/Gold": "#d4af37",
  "Ivory/Gold/Silver": "#d4af37",
  "Ivory/Green Multi": "#008001",
  "Ivory/Gunmetal": "#2a3439",
  "Ivory/Ivory": "#fffff0",
  "Ivory/Jade": "#00a86b",
  "Ivory/Lavender": "#fffff0",
  "Ivory/Light Blue": "#0000ff",
  "Ivory/Light Champagne": "#f7e7ce",
  "Ivory/Light Pewter": "#fffff0",
  "Ivory/Lilac": "#9955bb",
  "Ivory/Multi": "#fffff0",
  "Ivory/Navy": "#000080",
  "Ivory/Nude": "#fffff0",
  "Ivory/Peach/Rose Gold": "#d4af37",
  "Ivory/Pearl": "#426384",
  "Ivory/Periwinkle": "#fffff0",
  "Ivory/Pink": "#ffc0cb",
  "Ivory/Pink Print": "#ffc0cb",
  "Ivory/Print": "#fffff0",
  "Ivory/Red": "#ff0000",
  "Ivory/Red Print": "#ff0000",
  "Ivory/Rose": "#fbcce7",
  "Ivory/Rose Gold": "#fbcce7",
  "Ivory/Royal": "#fffff0",
  "Ivory/Sand": "#3c3e40",
  "Ivory/Shell": "#fffff0",
  "Ivory/Silver": "#fffff0",
  "Ivory/Silver/Gold": "#d4af37",
  "Ivory/Tangerine": "#fffff0",
  "Ivory/Taupe": "#fffff0",
  "Ivory/Turquoise": "#fffff0",
  "Ivory/Wedgewood Blue": "#0000ff",
  "Ivory/Yellow": "#fffff0",
  "Ivy": "#495845",
  "Ivy Green": "#495845",
  "Jacquard-Blue": "#0000ff",
  "Jade": "#00a86b",
  "Jade Green": "#819b8f",
  "Jade Iridescent": "#00a86b",
  "Jade Ombre": "#00a86b",
  "Jade print": "#00a86b",
  "Jade-Aqua": "#00a86b",
  "Jade-Berry": "#00a86b",
  "Jade-Gold": "#00a86b",
  "Jade-Green": "#819b8f",
  "Jade-Multi": "#00a86b",
  "Jade-Nude": "#00a86b",
  "Jade-Royal": "#00a86b",
  "Jade-Silver": "#00a86b",
  "Jade-Turquoise": "#00a86b",
  "Jade/Multi": "#00a86b",
  "Jade/Seafoam": "#00a86b",
  "Jet": "#343434",
  "Jet Black": "#000000",
  "Jet Hot Pink": "#ffc0cb",
  "Jet-Black": "#000000",
  "Jet-Black-Bright-White": "#000000",
  "Jet-Silver": "#c0c0c0",
  "Jewel Blue": "#0000ff",
  "Jewel Green": "#2d6764",
  "Jewel-Green": "#2d6764",
  "Jungle Green": "#29ab87",
  "Jungle-Green": "#29ab87",
  "Kaki": "#a19579",
  "Kaleidoscope": "#d37033",
  "Kashmir Garden": "#9797a1",
  "Kelly Green": "#4cbb17",
  "Key Lime": "#00ff00",
  "Khaki": "#a19579",
  "Khaki-Gold": "#d4af37",
  "Khaki-Light-Gold": "#d4af37",
  "Khaki-Pink": "#ffc0cb",
  "Kiwi": "#8ee53f",
  "L-Pink": "#ffc0cb",
  "Lace Black Top/Printed Skirt": "#000000",
  "Lagoon": "#4cb7a5",
  "Lagoon-Blue": "#4cb7a5",
  "Lagoon-Green": "#99dac4",
  "Lake Blue": "#4cb7a5",
  "Lake-Blue": "#4cb7a5",
  "Lapis": "#26619c",
  "Lapis-Blue": "#4cb7a5",
  "Latte": "#bdab98",
  "Latte-Chalk": "#e0dbd1",
  "Latte-Diamond-White": "#b9f2ff",
  "Latte-Silver": "#c0c0c0",
  "Lava": "#cf1020",
  "Lavander": "#b57edc",
  "Lavendar": "#b57edc",
  "Lavender": "#b57edc",
  "Lavender Multi": "#b57edc",
  "Lavender Twinkle": "#b57edc",
  "Lavender-Frost": "#b57edc",
  "Lavender-Gold": "#d4af37",
  "Lavender-Grey": "#808080",
  "Lavender-Haze": "#b57edc",
  "Lavender-Lilac": "#9955bb",
  "Lavender-Mist": "#b57edc",
  "Lavender-Pink": "#ffc0cb",
  "Lavender-Print": "#b57edc",
  "Lavender-Twinkle": "#b57edc",
  "Lavender-Violet": "#7f00ff",
  "Lavender/Multi": "#b57edc",
  "Lavender/Nude": "#b57edc",
  "Lavender/Purple": "#b57edc",
  "Lavender/Silver": "#c0c0c0",
  "Lead": "#6c6c6a",
  "Lead Grey": "#808080",
  "Lead Silver": "#c0c0c0",
  "Lead-Rose-Gold": "#fbcce7",
  "Lead-Silver": "#c0c0c0",
  "Lead/Gold": "#d4af37",
  "Lead/Port": "#6c6c6a",
  "Lead/Red": "#ff0000",
  "Lead/Silver": "#c0c0c0",
  "Lead/Silver/Gold": "#d4af37",
  "Lead/Teal": "#008080",
  "Led-Multi": "#6c6c6a",
  "Lemon": "#fff700",
  "Lemon Drop": "#fff700",
  "Lemon Gold": "#d4af37",
  "Lemon Lime": "#00ff00",
  "Lemon Multi": "#fff700",
  "Lemon Yellow": "#ffff00",
  "Lemon-Drop": "#fff700",
  "Lemon-Drop-Jet-Black": "#000000",
  "Lemon-Multi": "#fff700",
  "Lemonade": "#fff700",
  "Leopard": "#dfe2de",
  "Leopard-Floral": "#b57edc",
  "Leopard-Gold": "#d4af37",
  "Leopard-Grey": "#808080",
  "Leopard-Print": "#dfe2de",
  "Liberty Blue": "#cedfe5",
  "Light": "#ffffe0",
  "Light Almond": "#efdecd",
  "Light Aqua": "#ffffe0",
  "Light Blue": "#cedfe5",
  "Light Blue Iridescent": "#cedfe5",
  "Light Blue Multi": "#cedfe5",
  "Light Blue Nude Print": "#cedfe5",
  "Light Blue-Ivory": "#cedfe5",
  "Light Blue/Gold": "#cedfe5",
  "Light Blue/Grey": "#cedfe5",
  "Light Blue/Ivory": "#cedfe5",
  "Light Blue/Light Gold": "#cedfe5",
  "Light Blue/Multi Print": "#cedfe5",
  "Light Blue/Nude": "#cedfe5",
  "Light Blue/Royal": "#cedfe5",
  "Light Blue/Silver": "#cedfe5",
  "Light Blush": "#de5d83",
  "Light Brown": "#964b00",
  "Light Cafe": "#a18262",
  "Light Champagne": "#f7e7ce",
  "Light Coral": "#FF7F50",
  "Light Coral/Coral": "#FF7F50",
  "Light Coral/Ivory": "#fffff0",
  "Light Coral/Nude": "#FF7F50",
  "Light Cultural Pearl": "#426384",
  "Light Fuchsia": "#c74375",
  "Light Fuchsia/Multi": "#c74375",
  "Light Gold": "#d4af37",
  "Light Gold/Black": "#000000",
  "Light Green": "#90ee90",
  "Light Green Print": "#90ee90",
  "Light Grey": "#808080",
  "Light Ivory": "#fffff0",
  "Light Jade": "#00a86b",
  "Light Lilac": "#9955bb",
  "Light Lime": "#00ff00",
  "Light Mink": "#ffffe0",
  "Light Mint": "#98ff98",
  "Light Mint-Multi": "#98ff98",
  "Light Mocha": "#bea493",
  "Light Olive": "#808000",
  "Light Orchid": "#da70d6",
  "Light Peach": "#ffe5b4",
  "Light Peach/Ivory": "#fffff0",
  "Light Periwinkle": "#c3cde6",
  "Light Pink": "#ffc0cb",
  "Light Pink Gold": "#ffc0cb",
  "Light Pink Multi": "#ffc0cb",
  "Light Pink Silver": "#ffc0cb",
  "Light Pink/Gold": "#ffc0cb",
  "Light Pink/Nude": "#ffc0cb",
  "Light Plum": "#8e4585",
  "Light Purple": "#6a0dad",
  "Light Red": "#ffcccb",
  "Light Rose": "#fbcce7",
  "Light Silver": "#c0c0c0",
  "Light Taupe": "#baa68e",
  "Light Taupe/Nude": "#baa68e",
  "Light Teal": "#008080",
  "Light Turquoise": "#40e0d0",
  "Light Yellow": "#ffff00",
  "Light Yellow Multi": "#ffff00",
  "Light Yellow/White": "#ffff00",
  "Light-Amethyst": "#ffc197",
  "Light-Beige": "#f5f5dc",
  "Light-Blue": "#cedfe5",
  "Light-Blue-AB": "#cedfe5",
  "Light-Blue-Black": "#000000",
  "Light-Blue-Dark-Blue": "#cedfe5",
  "Light-Blue-Diamond-White": "#b9f2ff",
  "Light-Blue-Emerald": "#cedfe5",
  "Light-Blue-Gold": "#cedfe5",
  "Light-Blue-Ivory": "#cedfe5",
  "Light-Blue-Ivory-Print": "#cedfe5",
  "Light-Blue-Light-Blue": "#cedfe5",
  "Light-Blue-Light-Yellow-Print": "#cedfe5",
  "Light-Blue-Mocha": "#cedfe5",
  "Light-Blue-Navy": "#000080",
  "Light-Blue-Ombre": "#cedfe5",
  "Light-Blue-Pink": "#cedfe5",
  "Light-Blue-Print": "#cedfe5",
  "Light-Blue-Skyblue": "#cedfe5",
  "Light-Blue-Violet": "#cedfe5",
  "Light-Blue-White": "#cedfe5",
  "Light-Blush": "#de5d83",
  "Light-Bronze-Lame": "#b08d57",
  "Light-Brown": "#964b00",
  "Light-Brown-Brown": "#964b00",
  "Light-Champagne": "#f7e7ce",
  "Light-Cocoa": "#583318",
  "Light-Copper": "#b87333",
  "Light-Coral": "#FF7F50",
  "Light-Coral-Topaz": "#ffc87c",
  "Light-Cream": "#fffdd0",
  "Light-Denim": "#2243b6",
  "Light-Gold-Icelandic-Blue": "#cedfe5",
  "Light-Gold-Ivory": "#d4af37",
  "Light-Gold-Light-Blue": "#cedfe5",
  "Light-Gold-Mint": "#d4af37",
  "Light-Gold-Multi": "#d4af37",
  "Light-Green-Ombre": "#90ee90",
  "Light-Green-Pink": "#90ee90",
  "Light-Grey-Pearl": "#426384",
  "Light-Ice-Blue": "#cedfe5",
  "Light-Ivory-Champagne": "#f7e7ce",
  "Light-Ivy": "#a8a077",
  "Light-Latte": "#c0b299",
  "Light-Lavender": "#b57edc",
  "Light-Lavender-Silver": "#c0c0c0",
  "Light-Maroon": "#3d0f07",
  "Light-Mauve": "#e0b0ff",
  "Light-Mocha": "#bea493",
  "Light-Nude": "#eeece7",
  "Light-Olive": "#808000",
  "Light-Orange": "#ffa500",
  "Light-Peach-Nude": "#eeece7",
  "Light-Pearl-Natural": "#426384",
  "Light-Periwinkle": "#c3cde6",
  "Light-Periwinkle-Gold": "#d4af37",
  "Light-Pink": "#ffc0cb",
  "Light-Pink-Blush": "#ffc0cb",
  "Light-Pink-Ivory": "#ffc0cb",
  "Light-Pink-Nude": "#ffc0cb",
  "Light-Pink-Ombre": "#ffc0cb",
  "Light-Pink-Print": "#ffc0cb",
  "Light-Pink-Silver": "#ffc0cb",
  "Light-Plum": "#8e4585",
  "Light-Pnk": "#ffc0cb",
  "Light-Powder": "#d0d9c8",
  "Light-Purple": "#6a0dad",
  "Light-Purple-Black": "#000000",
  "Light-Purple-Multi": "#6a0dad",
  "Light-Rosewater-Gold": "#fbcce7",
  "Light-Rust": "#b7410e",
  "Light-Sage": "#e3e1cd",
  "Light-Salmon": "#ffa07a",
  "Light-Sienna": "#a0522d",
  "Light-Spring-Green": "#90ee90",
  "Light-Taupe": "#baa68e",
  "Light-Teal": "#008080",
  "Light-Turquoise-Multi": "#40e0d0",
  "Light-Turquoise-Nude": "#40e0d0",
  "Light-Violet": "#7f00ff",
  "Light-Wash": "#add8e6",
  "Light-Watermelon": "#cc4358",
  "Light-Yellow": "#ffff00",
  "Light-Yellow-Diamond-White": "#b9f2ff",
  "Light-Yellow-Ivory": "#fffff0",
  "Light-Yellow-Orange": "#ffa500",
  "Light-Yellow-Print": "#ffff00",
  "Light-Yellow-White": "#ffff00",
  "Light-Yellow.": "#ffff00",
  "Light/Mauve": "#e0b0ff",
  "Lila": "#c8a2c8",
  "Lilac": "#9955bb",
  "Lilac & Ivory": "#9955bb",
  "Lilac Grey": "#9955bb",
  "Lilac Haze": "#9955bb",
  "Lilac Iridescent": "#9955bb",
  "Lilac Multi": "#9955bb",
  "Lilac Ombre": "#9955bb",
  "Lilac Print": "#9955bb",
  "Lilac Purple": "#9955bb",
  "Lilac Smoke": "#9955bb",
  "Lilac-AB": "#9955bb",
  "Lilac-Black": "#9955bb",
  "Lilac-Blue": "#9955bb",
  "Lilac-Blue-Gold": "#9955bb",
  "Lilac-Blue-Silver": "#9955bb",
  "Lilac-Blue-Woodrose": "#9955bb",
  "Lilac-Blush": "#9955bb",
  "Lilac-Champagne": "#9955bb",
  "Lilac-Floral": "#b57edc",
  "Lilac-Gold": "#9955bb",
  "Lilac-Grey": "#9955bb",
  "Lilac-Grey-Silver": "#9955bb",
  "Lilac-Ivory-Print": "#9955bb",
  "Lilac-Light-Blue-Print": "#9955bb",
  "Lilac-Lt-Blue": "#9955bb",
  "Lilac-Marble": "#9955bb",
  "Lilac-Mauve": "#9955bb",
  "Lilac-Mist": "#9955bb",
  "Lilac-Navy": "#9955bb",
  "Lilac-Off-White": "#9955bb",
  "Lilac-Powder-Blue": "#9955bb",
  "Lilac-Print": "#9955bb",
  "Lilac-Purple-Multi": "#9955bb",
  "Lilac-Salmon": "#9955bb",
  "Lilac-Sea-Shell": "#9955bb",
  "Lilac-Silver": "#9955bb",
  "Lilac/Aqua": "#9955bb",
  "Lilac/Gold": "#9955bb",
  "Lilac/Ivory": "#9955bb",
  "Lilac/Nude": "#9955bb",
  "Lilac/Pink": "#9955bb",
  "Lilac/Purple": "#9955bb",
  "Lilac/Silver": "#9955bb",
  "Lilac/White": "#9955bb",
  "Lime": "#00ff00",
  "Lime Gold": "#d4af37",
  "Lime Green": "#32cd32",
  "Lime Ombre": "#00ff00",
  "Lime Turquoise": "#00ff00",
  "Lime-Green-Blue": "#32cd32",
  "Lime-Hunter": "#355e3b",
  "Lime-Light-Yellow": "#ffff00",
  "Lime-Punch": "#00ff00",
  "Lime-Sorbet": "#00ff00",
  "Lime-Yellow": "#ffff00",
  "Lime/Turquoise": "#00ff00",
  "Limeade": "#00ff00",
  "Limelight": "#00ff00",
  "Limoncello": "#ffff83",
  "Lip-Stick": "#9f1f19",
  "Lips": "#c16873",
  "Lipstic-Red": "#8e1e1d",
  "Lipstick": "#9f1f19",
  "Lipstick-Pink": "#ffc0cb",
  "Lipstick-Red": "#8e1e1d",
  "Liquid Chrome": "#3e4147",
  "Liquid-Metal": "#3e4147",
  "Loden Green": "#415236",
  "Lotus-Green": "#174222",
  "Lt-Blue": "#cedfe5",
  "Lt-Mauve": "#e0b0ff",
  "Lt-Silver": "#c0c0c0",
  "Macaw": "#2e4b91",
  "Mademoiselle": "#ffd6e1",
  "Mademoiselle-Light-Silver": "#c0c0c0",
  "Mademoiselle-Silver": "#c0c0c0",
  "Magenta": "#ff0090",
  "Magenta Multi": "#ff0090",
  "Magenta Paradise": "#ff0090",
  "Magenta-Animal": "#ff0090",
  "Magenta-Black": "#000000",
  "Magenta-Fuchsia": "#c74375",
  "Magenta-Ombre": "#ff0090",
  "Magenta-Pink": "#ffc0cb",
  "Magenta-Silver": "#c0c0c0",
  "Magenta-White": "#ff0090",
  "Magenta/Black": "#000000",
  "Magenta/Green/Multi": "#008001",
  "Magenta/Gunmetal": "#2a3439",
  "Magenta/Ivory": "#fffff0",
  "Magenta/Multi": "#ff0090",
  "Magenta/Navy": "#000080",
  "Magenta/Nude": "#ff0090",
  "Magenta/White": "#ff0090",
  "Magic-Opal": "#91b660",
  "Mahogany": "#c04000",
  "Maitres-Print": "#e80085",
  "Maize": "#eccb57",
  "Majesti-Red": "#82b1d5",
  "Majesti/Red": "#82b1d5",
  "Majestic Purple": "#6a0dad",
  "Majestic Red": "#82b1d5",
  "Majestic-Purple": "#6a0dad",
  "Majestic-Red": "#82b1d5",
  "Malachite-Blue": "#cedfe5",
  "Mandarin": "#f37a48",
  "Mango": "#F4BB44",
  "Mango-Tango": "#F4BB44",
  "Marble": "#e3e0cd",
  "Mardi Gras Green": "#9fc551",
  "Marie-Antoinette": "#3d3832",
  "Marigold": "#d4af37",
  "Marigold Yellow": "#d4af37",
  "Marigold-Yellow": "#d4af37",
  "Marina": "#74b5df",
  "Marine": "#26567d",
  "Marine Blue": "#1d3e59",
  "Marine-Blue": "#1d3e59",
  "Marine/Silver": "#c0c0c0",
  "Marlin-Blue": "#1d3e59",
  "Marmalade": "#c16512",
  "maroon": "#800000",
  "Maroon-Charcoal": "#36454f",
  "Marsala": "#975a59",
  "Marsala Black": "#975a59",
  "Marsala-Gunmetal": "#975a59",
  "Marsala-Nude": "#975a59",
  "Marsala/Multi": "#975a59",
  "Matte-Black": "#000000",
  "Matte-Black-Shiny-Black": "#000000",
  "Matte-Gold": "#d4af37",
  "Matte-Gold-Bronze": "#d4af37",
  "Matte-Silver": "#c0c0c0",
  "Matte-Silver-Bronze": "#c0c0c0",
  "Matte-Silver-Gold": "#d4af37",
  "Maui": "#52a2b4",
  "Mauve": "#e0b0ff",
  "Mauve Blush": "#e0b0ff",
  "Mauve Pink": "#ffc0cb",
  "Mauve-Amethyst": "#e0b0ff",
  "Mauve-Black": "#000000",
  "Mauve-Black-Cherry": "#000000",
  "Mauve-Chalk": "#e0b0ff",
  "Mauve-Champagne": "#f7e7ce",
  "Mauve-Floral": "#b57edc",
  "Mauve-Fuchsia": "#c74375",
  "Mauve-Ivory": "#fffff0",
  "Mauve-Multi": "#e0b0ff",
  "Mauve-Nude": "#e0b0ff",
  "Mauve-Ombre": "#e0b0ff",
  "Mauve-Pink": "#ffc0cb",
  "Mauve-Rose": "#fbcce7",
  "Mauve-Rose-Gold": "#fbcce7",
  "Mauve-Silver": "#e0b0ff",
  "Mauve-Wine": "#6c5857",
  "Mauve/Gold": "#d4af37",
  "Mauve/Nude": "#e0b0ff",
  "Mauvellous": "#e0b0ff",
  "Meadow": "#8dbb96",
  "Meadow Green": "#2d4039",
  "Mediterranean Blue": "#1d3e59",
  "Medium Blue": "#1d3e59",
  "Melon": "#febaad",
  "Mercury": "#747b81",
  "Merigold-Multi": "#d4af37",
  "Merlot": "#865f5f",
  "Merlot-Black": "#000000",
  "Merlot/Gold": "#d4af37",
  "Merlot/Multi": "#865f5f",
  "Mermaid": "#817a65",
  "Mermaid-Black": "#000000",
  "Mermaid-Green": "#a4ad8f",
  "Mermaid-Multi": "#817a65",
  "Metalic-Burgundy": "#800020",
  "Metalic-Navy": "#000080",
  "Metalic-Pink": "#ffc0cb",
  "Metalic-Rosegold": "#fbcce7",
  "Metallic": "#323334",
  "Metallic-Black": "#000000",
  "Metallic-Blue": "#1d3e59",
  "Metallic-Blush": "#323334",
  "Metallic-Champagne": "#f7e7ce",
  "Metallic-Chartreuse": "#323334",
  "Metallic-Cotton-Candy": "#323334",
  "Metallic-Emerald": "#323334",
  "Metallic-Fuchsia": "#c74375",
  "Metallic-Gold": "#d4af37",
  "Metallic-Green": "#296e01",
  "Metallic-Navy": "#000080",
  "Metallic-Pink": "#ffc0cb",
  "Metallic-Printed-Jacquard": "#323334",
  "Metallic-Purple": "#323334",
  "Metallic-Rose": "#fbcce7",
  "Metallic-Sage": "#323334",
  "Metallic-Violet": "#323334",
  "Metallic/Blue": "#1d3e59",
  "Metallic/Rose": "#fbcce7",
  "Metallic/Silver": "#323334",
  "Metallica-Green": "#296e01",
  "Mid-Grey": "#808080",
  "Mid-Night": "#702670",
  "Midnight": "#702670",
  "Midnight Black": "#000000",
  "Midnight Blue": "#191970",
  "Midnight Floral": "#b57edc",
  "Midnight Gold": "#d4af37",
  "Midnight Grey": "#808080",
  "Midnight Multi": "#702670",
  "Midnight Navy": "#000080",
  "Midnight Nude": "#702670",
  "Midnight Rose": "#fbcce7",
  "MIDNIGHT TEAL": "#702670",
  "Midnight Teal & Nude": "#702670",
  "Midnight-Black": "#000000",
  "Midnight-Diamond-White": "#b9f2ff",
  "Midnight-Floral": "#b57edc",
  "Midnight-Gold": "#d4af37",
  "Midnight-Green": "#004953",
  "Midnight-Grey": "#808080",
  "Midnight-Ivory": "#fffff0",
  "Midnight-Meadow": "#702670",
  "Midnight-Multi": "#702670",
  "Midnight-Purple": "#702670",
  "Midnight-Rose-Gold": "#fbcce7",
  "Midnight-Royal": "#702670",
  "Midnight-Sequin": "#702670",
  "Midnight-Shimmer": "#702670",
  "Midnight-Silver": "#702670",
  "Midnight-Solid": "#702670",
  "Midnight-Violet": "#702670",
  "Midnight-White": "#702670",
  "Midnight-With-Shawl": "#702670",
  "Midnight/Gold": "#d4af37",
  "Midnight/Nude": "#702670",
  "Midnight/Rose": "#fbcce7",
  "Midnight/Turquoise": "#702670",
  "Millenial-Pink": "#ffc0cb",
  "Millennial-Pink": "#ffc0cb",
  "Millennial-Pink-Silver": "#ffc0cb",
  "Mink": "#d2b7a6",
  "Mink-Gold": "#d4af37",
  "Mink-Grey": "#808080",
  "Mink-Multi": "#d2b7a6",
  "Mink-Silver": "#c0c0c0",
  "Mink/Gold": "#d4af37",
  "Mink/Multi": "#d2b7a6",
  "Mint": "#98ff98",
  "Mint Blue Iridescent": "#bee0e5",
  "Mint Green": "#98ff98",
  "Mint Iridescent": "#98ff98",
  "Mint Jade": "#00a86b",
  "Mint Leaf": "#98ff98",
  "Mint-Black": "#000000",
  "Mint-Blue": "#bee0e5",
  "Mint-Gold": "#d4af37",
  "Mint-Green": "#98ff98",
  "Mint-Green-Pink": "#98ff98",
  "Mint-Green-White": "#98ff98",
  "Mint-Grey": "#808080",
  "Mint-Ice": "#98ff98",
  "Mint-Ivory": "#98ff98",
  "Mint-Jade": "#00a86b",
  "Mint-Leaf": "#98ff98",
  "Mint-Lime": "#98ff98",
  "Mint-Mint": "#98ff98",
  "Mint-Multi": "#98ff98",
  "Mint-Nude": "#98ff98",
  "Mint-Ombre": "#98ff98",
  "Mint-Opal": "#91b660",
  "Mint-Pink": "#ffc0cb",
  "Mint-Silver": "#98ff98",
  "Mint-Sky-Blue": "#bee0e5",
  "Mint-White": "#98ff98",
  "Mint/Gunmetal": "#2a3439",
  "Mint/Multi": "#98ff98",
  "Mint/Nude": "#98ff98",
  "Mint/Silver": "#98ff98",
  "Mint/White": "#98ff98",
  "Mist": "#fff9de",
  "Mist Sage": "#fff9de",
  "Mist-Green": "#b7d6af",
  "Mist-Nude": "#eeece7",
  "Mist-White": "#ffffff",
  "Misty Green": "#b7d6af",
  "Misty-Blue": "#bee0e5",
  "Misty-Blue-White": "#bee0e5",
  "Misty-Fuchsia": "#c74375",
  "Misty-Green": "#b7d6af",
  "Misty-Grey": "#808080",
  "Misty-Hyacinth": "#fff9de",
  "Misty-Jade": "#00a86b",
  "Misty-Peach": "#fff9de",
  "Misty-Rose": "#fbcce7",
  "Mocah": "#bea493",
  "Mocha": "#bea493",
  "Mocha Brown": "#bea493",
  "Mocha Silver": "#bea493",
  "Mocha-Gold": "#d4af37",
  "Mocha-Gold-Nude": "#d4af37",
  "Mocha-Mocha": "#bea493",
  "Mocha-Multi": "#bea493",
  "Mocha-Nude": "#bea493",
  "Mocha-Rose": "#fbcce7",
  "Mocha-Silver": "#bea493",
  "Mocha-Victor": "#bea493",
  "Mocha/Nude": "#bea493",
  "Mold-Green": "#8a9a5b",
  "Money-Bags-Silver": "#c0c0c0",
  "Montana-Sapphire": "#0f52ba",
  "Moon-Gold": "#d4af37",
  "Moonlight": "#000a40",
  "Moonlight-Blue": "#bee0e5",
  "Moonlight-Grey": "#808080",
  "Moonlight-Grey-Nude": "#808080",
  "Moonlight-Silver": "#c0c0c0",
  "Morcivert": "#bee0e5",
  "Morcivert-(Blue)": "#bee0e5",
  "Morganite": "#e6d2c9",
  "Morganite Pink": "#ffc0cb",
  "Morganite-Coraly-Pink": "#ffc0cb",
  "Morganite-Pink": "#ffc0cb",
  "Moss": "#8A9A5B",
  "Moss Green": "#8A9A5B",
  "Moss-Green": "#8A9A5B",
  "Mulberry": "#8d4e85",
  "Mulberry-Black": "#000000",
  "Mulberry-Multi": "#8d4e85",
  "Mulberry-Purple": "#8d4e85",
  "Multi Black": "#000000",
  "Multi-Blue": "#bee0e5",
  "Multi-Colored-Blue": "#bee0e5",
  "Multi-Colored-Purple": "#6a0dad",
  "Multi-Floral": "#b57edc",
  "Multi-Green": "#008001",
  "Multi-Magenta": "#ff0090",
  "Multi-Nude": "#eeece7",
  "Multi-Silver": "#c0c0c0",
  "Multi-Yellow": "#ffff00",
  "Multi/Black": "#000000",
  "Multi/Nude": "#eeece7",
  "Mushroom": "#d8ccc0",
  "Musk": "#f2ebe5",
  "Mustard": "#e1ad01",
  "Mustard-Black": "#000000",
  "Mystic Blue": "#bee0e5",
  "Naples-Yellow": "#ffff00",
  "Natural": "#4b8b3b",
  "Natural-Tan": "#dcd2c3",
  "Navy": "#000080",
  "Navy & Gold": "#000080",
  "Navy & Nude": "#000080",
  "Navy Aqua": "#000080",
  "Navy Aquia": "#000080",
  "Navy Blue": "#000080",
  "Navy Blue/Nude": "#000080",
  "Navy Blue/Wine": "#000080",
  "Navy Frost": "#000080",
  "Navy Gold": "#d4af37",
  "Navy Ivory": "#fffff0",
  "Navy Magenta": "#ff0090",
  "Navy Metallic": "#323334",
  "Navy Multi": "#000080",
  "Navy Ombre": "#000080",
  "Navy Powder Blue": "#000080",
  "Navy Print": "#000080",
  "Navy Solid": "#000080",
  "Navy-Ab": "#000080",
  "Navy-Aqua": "#000080",
  "Navy-As": "#000080",
  "Navy-Beige": "#f5f5dc",
  "Navy-Blue": "#000080",
  "Navy-Blue-Gold": "#000080",
  "Navy-Blue-Gunmetal": "#000080",
  "Navy-Blue-Multi": "#000080",
  "Navy-Blue-Nude": "#000080",
  "Navy-Blue-Periwinkle": "#000080",
  "Navy-Blue-Rosegold": "#000080",
  "Navy-Blue-Silver": "#000080",
  "Navy-Blush": "#de5d83",
  "Navy-Br-Pink-Ivory": "#ffc0cb",
  "Navy-Bright-Pink-Ivory": "#ffc0cb",
  "Navy-Bronze": "#b08d57",
  "Navy-Champagne": "#f7e7ce",
  "Navy-Ecru": "#c2b280",
  "Navy-Emerald": "#50c878",
  "Navy-Floral": "#b57edc",
  "Navy-Fuchsia": "#c74375",
  "Navy-Fuschsia": "#FF00FF",
  "Navy-Galaxy": "#26457a",
  "Navy-Gold-Multi": "#d4af37",
  "Navy-Grey": "#808080",
  "Navy-Hot-Pink": "#ffc0cb",
  "Navy-Ice-Blue": "#bee0e5",
  "Navy-Iridescent": "#18335e",
  "navy-ivory": "#fffff0",
  "Navy-Latte": "#bdab98",
  "Navy-Light-Blue": "#bee0e5",
  "Navy-Lilac": "#9955bb",
  "Navy-Lime": "#00ff00",
  "Navy-Magenta": "#ff0090",
  "Navy-Mint": "#98ff98",
  "Navy-Navy-lining": "#000080",
  "Navy-Navy-Multi": "#000080",
  "Navy-Nude-Gold": "#d4af37",
  "Navy-Nude-Iridescent": "#18335e",
  "Navy-Olive": "#808000",
  "Navy-Orange": "#ffa500",
  "Navy-Peacock": "#008381",
  "Navy-Periwinkle": "#c3cde6",
  "Navy-Petal": "#000080",
  "Navy-Pewter": "#8e9294",
  "Navy-Pink": "#ffc0cb",
  "Navy-Print": "#000080",
  "Navy-Print-As": "#000080",
  "Navy-Purple": "#6a0dad",
  "Navy-Red": "#ff0000",
  "Navy-Red-Print": "#ff0000",
  "Navy-Rose-Gold": "#fbcce7",
  "Navy-Rosewater": "#fbcce7",
  "Navy-Royal-Silver": "#c0c0c0",
  "Navy-Sky-Blue": "#000080",
  "Navy-Special-Pink": "#ffc0cb",
  "Navy-Stone": "#000080",
  "Navy-Storm-Grey": "#808080",
  "Navy-Teal-Gunmetal": "#2a3439",
  "Navy-Topaz": "#ffc87c",
  "Navy-Violet": "#7f00ff",
  "Navy-White-Black": "#000000",
  "Navy-White-lining": "#ffffff",
  "Navy-Wine": "#6c5857",
  "Navy-yellow": "#ffff00",
  "Navy/Aqua": "#000080",
  "Navy/Beige": "#f5f5dc",
  "Navy/Black": "#000000",
  "Navy/Bronze": "#b08d57",
  "Navy/Chartreuse": "#7fff00",
  "Navy/Fuchsia": "#c74375",
  "Navy/Gold": "#d4af37",
  "Navy/Green": "#000080",
  "Navy/Gunmetal": "#2a3439",
  "Navy/Hot Violet": "#7f00ff",
  "Navy/Ivory": "#fffff0",
  "Navy/Light Blue/Multi": "#000080",
  "Navy/Lilac": "#9955bb",
  "Navy/Magenta": "#ff0090",
  "Navy/Navy": "#000080",
  "Navy/Navy/Gold": "#000080",
  "Navy/Neon Yellow": "#ffff00",
  "Navy/Nude": "#eeece7",
  "Navy/Periwinkle Ombre": "#c3cde6",
  "Navy/Pewter": "#8e9294",
  "Navy/Red": "#ff0000",
  "Navy/Rose Gold": "#fbcce7",
  "Navy/Royal": "#4169e1",
  "Navy/Silver": "#c0c0c0",
  "Navy/Teal": "#008080",
  "Navy/Turquoise": "#40e0d0",
  "Navy/White": "#ffffff",
  "Nebula-Green": "#afbeb1",
  "Neo-Mint": "#98ff98",
  "Neon": "#e1dd7f",
  "Neon Blue": "#1F51FF",
  "Neon Coral": "#FF7F50",
  "Neon Fuchsia": "#c74375",
  "Neon Grapefruit": "#e0707c",
  "Neon Green": "#39ff14",
  "Neon Hot Pink": "#ffc0cb",
  "Neon Lilac": "#9955bb",
  "Neon Lime": "#00ff00",
  "Neon Ocean Blue": "#1F51FF",
  "Neon Orange": "#ffa500",
  "Neon Pink": "#ffc0cb",
  "Neon Pink/Coral": "#ffc0cb",
  "Neon Pink/White": "#ffc0cb",
  "Neon Purple": "#6a0dad",
  "Neon Red": "#FF3131",
  "Neon Royal": "#4169e1",
  "Neon Sage": "#bcb88a",
  "Neon Tangerine": "#ffcc00",
  "Neon Turquoise": "#40e0d0",
  "Neon Yellow": "#ffff00",
  "Neon-Fire": "#e25822",
  "Neon-Fuchsia": "#c74375",
  "Neon-Green": "#39ff14",
  "Neon-Lime": "#00ff00",
  "Neon-Magenta": "#ff0090",
  "Neon-Ocean": "#48bf91",
  "Neon-Pink": "#ffc0cb",
  "Neon-Pink-Silver": "#ffc0cb",
  "Neon-Royal": "#4169e1",
  "Neon-Yellow-Nude": "#ffff00",
  "Neutral Grey": "#808080",
  "New Champagne": "#f7e7ce",
  "New Coral": "#FF7F50",
  "New Coral-Gold": "#d4af37",
  "New Rose": "#fbcce7",
  "New Teal": "#008080",
  "New-Champagne": "#f7e7ce",
  "New-Coral": "#FF7F50",
  "New-Coral-Gold": "#d4af37",
  "New-Hyacinth": "#c4aec3",
  "New-Indigo": "#4b0082",
  "New-Mint": "#98ff98",
  "New-Oil": "#5c5859",
  "New-Pink": "#ffc0cb",
  "New-Purple": "#6a0dad",
  "New-Rose": "#fbcce7",
  "New-Silver": "#c0c0c0",
  "Newspaper": "#5b5758",
  "Niagara-Blue": "#1F51FF",
  "Nickel": "#727472",
  "Night Sky Black": "#000000",
  "Night-Blue": "#222d5a",
  "Night-Sky-Black": "#000000",
  "NIGHTSHADE": "#433748",
  "Nil-Green": "#c8d295",
  "Nil-Sunset": "#6f456e",
  "Nile-Blue": "#4e719a",
  "Nile-Green": "#c8d295",
  "Nile-Green-Nude": "#c8d295",
  "Noir": "#000000",
  "Noir Sequin": "#000000",
  "Noir-Sequin": "#000000",
  "Nova-Purple": "#6a0dad",
  "Nude": "#eeece7",
  "Nude & Ivory": "#fffff0",
  "Nude Lavender": "#b57edc",
  "Nude Multi": "#eeece7",
  "Nude Ombre": "#eeece7",
  "Nude Pale Gold": "#d4af37",
  "Nude Platinum": "#e5e4e2",
  "Nude Print": "#eeece7",
  "Nude Purple Print": "#6a0dad",
  "Nude--Gold": "#d4af37",
  "Nude-AB": "#eeece7",
  "Nude-Aqua-Rose": "#fbcce7",
  "Nude-Black": "#000000",
  "Nude-Black-Fuchsia-Purple": "#c74375",
  "Nude-Black-Gold": "#000000",
  "Nude-Black-White": "#000000",
  "Nude-Blue": "#0000ff",
  "Nude-Blush": "#de5d83",
  "Nude-Bright-Pink": "#ffc0cb",
  "Nude-Bright-Pink-Blue": "#0000ff",
  "Nude-Bright-Pink-Ivory": "#ffc0cb",
  "Nude-Charcoal": "#36454f",
  "Nude-Coral": "#FF7F50",
  "Nude-Crystal": "#a7d8de",
  "Nude-Emerald": "#50c878",
  "Nude-Floral": "#b57edc",
  "Nude-Gold": "#d4af37",
  "Nude-Gold-Ivory": "#d4af37",
  "Nude-Gold-Ombre": "#d4af37",
  "Nude-Gold-Silver": "#d4af37",
  "Nude-Green": "#008001",
  "Nude-Grey": "#808080",
  "Nude-Iridescent": "#18335e",
  "Nude-Ivory-Blush": "#fffff0",
  "Nude-Ivory-Silver": "#fffff0",
  "Nude-Light-Blue": "#0000ff",
  "Nude-Lilac": "#9955bb",
  "Nude-Lt-Blue": "#0000ff",
  "Nude-Magenta": "#ff0090",
  "Nude-Mauve": "#e0b0ff",
  "Nude-Multi-Ombre": "#eeece7",
  "Nude-Neon-Orange": "#ffa500",
  "Nude-Neon-Pink": "#ffc0cb",
  "Nude-Neon-Yellow": "#ffff00",
  "Nude-Nude": "#eeece7",
  "Nude-Nude-Ivory": "#fffff0",
  "Nude-Off-White": "#ffffff",
  "Nude-Orange": "#ffa500",
  "Nude-Pale-Gold": "#d4af37",
  "Nude-Peach": "#eeece7",
  "Nude-Peacock": "#008381",
  "Nude-Periwinkle": "#c3cde6",
  "Nude-Pewter": "#8e9294",
  "Nude-Pink": "#ffc0cb",
  "Nude-Pink-Blue": "#0000ff",
  "Nude-Platinum": "#e5e4e2",
  "Nude-Plum": "#8e4585",
  "Nude-Raspberry": "#8d4e85",
  "Nude-Rose": "#fbcce7",
  "Nude-Rose-Gold": "#fbcce7",
  "Nude-Sequins": "#e1c28d",
  "Nude-Shiny-Silver": "#c0c0c0",
  "Nude-Silver-Black": "#000000",
  "Nude-Silver-Gold": "#d4af37",
  "Nude-Silver-Ivory": "#fffff0",
  "Nude-Silver-Light-Gold": "#d4af37",
  "Nude-Silver-Mauve": "#e0b0ff",
  "Nude-Silver-White": "#c0c0c0",
  "Nude-Sky-Blue": "#0000ff",
  "Nude-Slate": "#708090",
  "Nude-Tangerine": "#eeece7",
  "Nude-Teal": "#008080",
  "Nude-Turquoise": "#40e0d0",
  "Nude-Turquoise-Ivory": "#fffff0",
  "Nude-White": "#ffffff",
  "Nude-White-Charcoal": "#36454f",
  "Nude-Wine": "#6c5857",
  "Nude-Yellow": "#ffff00",
  "Nude/ AB": "#eeece7",
  "Nude/Aqua": "#eeece7",
  "Nude/Black": "#000000",
  "Nude/Black Ombre": "#000000",
  "Nude/Blue": "#0000ff",
  "Nude/Brown Print": "#964b00",
  "Nude/Candy Pink": "#ffc0cb",
  "Nude/Champagne": "#f7e7ce",
  "Nude/Charcoal": "#36454f",
  "Nude/Fuchsia": "#c74375",
  "Nude/Gold": "#d4af37",
  "Nude/Green": "#008001",
  "Nude/Grey": "#808080",
  "Nude/Gunmetal": "#2a3439",
  "Nude/Hot Pink": "#ffc0cb",
  "Nude/Ivory": "#fffff0",
  "Nude/Light Blue": "#0000ff",
  "Nude/Mint": "#98ff98",
  "Nude/Multi Stones": "#eeece7",
  "Nude/Navy": "#000080",
  "Nude/Nude": "#eeece7",
  "Nude/Orange": "#ffa500",
  "Nude/Pink": "#ffc0cb",
  "Nude/Purple": "#6a0dad",
  "Nude/Purple Ombre": "#6a0dad",
  "Nude/Red": "#ff0000",
  "Nude/Rose Gold": "#fbcce7",
  "Nude/Sax": "#eeece7",
  "Nude/Silver": "#c0c0c0",
  "Nude/Turquoise": "#40e0d0",
  "Nude/Water": "#eeece7",
  "Nude/White": "#ffffff",
  "Nude/Yellow": "#ffff00",
  "Nutmeg": "#7A4327",
  "Nutmeg Brown": "#964b00",
  "Oat": "#d8c29d",
  "Ocean": "#48bf91",
  "Ocean Blue": "#0000ff",
  "Ocean Gold": "#d4af37",
  "Ocean Ombre": "#48bf91",
  "Ocean-Blue": "#0000ff",
  "Ocean-Blue-Multi": "#0000ff",
  "Ocean-Green": "#48bf91",
  "Ocean-Indigo": "#48bf91",
  "Ocean-Lilac": "#9955bb",
  "Ocean-Multi": "#48bf91",
  "Ocean-Nude": "#48bf91",
  "Ocean-Royal": "#48bf91",
  "Ocean-Shimmer": "#e3c9ab",
  "Ocean-Turquoise": "#48bf91",
  "Ocean/Nude": "#48bf91",
  "Ocean/Royal": "#48bf91",
  "Ochre": "#cc7722",
  "Off White": "#ffffff",
  "Off White Light Blue": "#0000ff",
  "Off White Lilac": "#9955bb",
  "Off White Pink Multi": "#ffc0cb",
  "Off White Silver": "#c0c0c0",
  "Off White Yellow": "#ffff00",
  "Off White-Off White": "#ffffff",
  "Off White/Black": "#000000",
  "Off White/Blush": "#de5d83",
  "Off White/Gold": "#d4af37",
  "Off White/Multi": "#ffffff",
  "Off White/Nude": "#ffffff",
  "Off White/Nude/Gold": "#d4af37",
  "Off White/Pearl": "#426384",
  "Off White/Silver": "#c0c0c0",
  "Off-White-Aqua": "#ffffff",
  "Off-White-Black": "#000000",
  "Off-White-Gold": "#d4af37",
  "Off-White-Grey": "#808080",
  "Off-White-Gunmetal": "#2a3439",
  "Off-White-Light-Blue": "#0000ff",
  "Off-White-Light-Pink": "#ffc0cb",
  "Off-White-Multi": "#ffffff",
  "Off-White-Navy": "#000080",
  "Off-White-Pink": "#ffc0cb",
  "Off-White-Red": "#ff0000",
  "Off-White-Sapphire": "#0f52ba",
  "Off-White-Silver": "#c0c0c0",
  "Off-White-Turquoise": "#40e0d0",
  "Off-White-Yellow": "#ffff00",
  "Off-White/Gold": "#d4af37",
  "Off-White/Rose Gold": "#fbcce7",
  "Oil": "#dbcf5c",
  "Oil-Green": "#80856d",
  "Old Pink": "#ffc0cb",
  "Old-Lavender": "#b57edc",
  "Old-Pink": "#ffc0cb",
  "Old-Rose": "#fbcce7",
  "Old-Rose-Gold": "#fbcce7",
  "Olive": "#808000",
  "Olive Green": "#808000",
  "Olive Lime": "#808000",
  "Olive Multi": "#808000",
  "Olive Off White": "#808000",
  "Olive-Multi": "#808000",
  "Olive-Nude": "#808000",
  "Olive-Ombre": "#808000",
  "Olive/Bronze": "#808000",
  "Olive/Gold": "#d4af37",
  "Ombre-Blush": "#de5d83",
  "Ombre-Sky": "#87ceeb",
  "Onyx": "#353839",
  "Onyx-Multi": "#353839",
  "Opal": "#91b660",
  "Opal Grey": "#808080",
  "Opal-Aqua": "#5f99a6",
  "Opal-Black": "#000000",
  "Opal-Blue": "#0000ff",
  "Opal-Blush": "#de5d83",
  "Opal-Champagne": "#f7e7ce",
  "Opal-Diamond-White": "#b9f2ff",
  "Opal-Gold": "#d4af37",
  "Opal-Grey": "#808080",
  "Opal-Lilac": "#9955bb",
  "Opal-Lite-Blue": "#0000ff",
  "Opal-Mauve": "#e0b0ff",
  "Opal-Pink": "#ffc0cb",
  "Opal-Rose": "#fbcce7",
  "Opal-Royal": "#4169e1",
  "Opal-Silver": "#c0c0c0",
  "Opal-Violet": "#7f00ff",
  "Optic-White": "#ffffff",
  "Orange": "#ffa500",
  "Orange Multi": "#ffa500",
  "Orange Nude": "#ffa500",
  "Orange Sherbet": "#ffa500",
  "Orange-Black": "#000000",
  "Orange-Blue": "#0000ff",
  "Orange-Crush": "#ffa500",
  "Orange-Gold": "#d4af37",
  "Orange-Green": "#008001",
  "Orange-Opal": "#91b660",
  "Orange-Peach": "#ffa500",
  "Orange-Pink": "#ffc0cb",
  "Orange-Pop": "#ffa500",
  "Orange-Purple": "#ffa500",
  "Orange-Sequin": "#ffa500",
  "Orange-Silver": "#ffa500",
  "Orange/Blue": "#0000ff",
  "Orange/Fuchsia": "#c74375",
  "Orange/Neon Orange": "#ffa500",
  "Orange/Red": "#ff0000",
  "Orange/Silver": "#ffa500",
  "Orangeade": "#ffa500",
  "Orchid": "#da70d6",
  "Orchid Navy": "#000080",
  "Orchid-Flower": "#da70d6",
  "Orchid-Lavender": "#da70d6",
  "Orchid-Multi": "#da70d6",
  "Orchid-Orchid": "#da70d6",
  "Orchid-Pink": "#ffc0cb",
  "Orchid-Silver": "#da70d6",
  "Orchid-Taupe": "#da70d6",
  "Orchid/Lavender": "#da70d6",
  "Orchid/Nude": "#da70d6",
  "Oxblood": "#342127",
  "Oxford-Blue": "#0000ff",
  "Oxy-Fire": "#e25822",
  "Oyster": "#e3d9c6",
  "Oyster Pink": "#ffc0cb",
  "Oyster-Gold": "#d4af37",
  "Oyster-Pewter": "#8e9294",
  "Oyster/Silver": "#c0c0c0",
  "Pacific Blue": "#0000ff",
  "Pacific Blue/Gold": "#0000ff",
  "Pageant-Pink": "#ffc0cb",
  "Pale Blue": "#0000ff",
  "Pale Blue/Silver": "#0000ff",
  "Pale Flesh": "#ffe9d1",
  "Pale Pink": "#ffc0cb",
  "Pale Purple": "#6a0dad",
  "Pale Rose": "#fbcce7",
  "Pale Yellow": "#ffff00",
  "Pale Yellow/Nude": "#ffff00",
  "Pale Yellow/Silver": "#c0c0c0",
  "Pale-Aqua": "#bcd4e6",
  "Pale-Blue-Multi": "#0000ff",
  "Pale-Blue-Navy": "#000080",
  "Pale-Blue-Pink": "#0000ff",
  "Pale-Blush": "#de5d83",
  "Pale-Gold": "#d4af37",
  "Pale-Green": "#98fb98",
  "Pale-Lilac": "#9955bb",
  "Pale-Mauve": "#e0b0ff",
  "Pale-Moss": "#D3DAC2",
  "Pale-Pale-Blue": "#0000ff",
  "Pale-Purple": "#6a0dad",
  "Pale-Turquoise": "#40e0d0",
  "Pale-Yellow": "#ffff00",
  "Pale-Yellow-Multi": "#ffff00",
  "Papaya": "#ffc281",
  "Papaya-Orange": "#ffa500",
  "Paprika": "#91504d",
  "Parchment": "#ebd5b3",
  "Paris Blue": "#0000ff",
  "Paris Pink": "#ffc0cb",
  "Paris-Blue": "#0000ff",
  "Party Pink": "#ffc0cb",
  "Party-Pink": "#ffc0cb",
  "Passion Pink": "#ffc0cb",
  "Passion-Pink": "#ffc0cb",
  "Pastel": "#aec6cf",
  "Pastel Green": "#77dd77",
  "Pastel Lilac": "#9955bb",
  "Pastel Multi": "#aec6cf",
  "Pastel Ombre": "#aec6cf",
  "Pastel-Aqua": "#aec6cf",
  "Pastel-Dream": "#aec6cf",
  "Pastel-Pink": "#ffc0cb",
  "Patina": "#c9a483",
  "Patina-Multi": "#c9a483",
  "Patinum-Nude": "#eeece7",
  "Patriot-Blue": "#0000ff",
  "Peach": "#ffcba4",
  "Peach Nectar": "#ffcba4",
  "Peach Pink": "#ffc0cb",
  "Peach-AB": "#ffcba4",
  "Peach-Black": "#000000",
  "Peach-Blush": "#de5d83",
  "Peach-Champagne": "#f7e7ce",
  "Peach-Cloud-Blue": "#0000ff",
  "Peach-Cream": "#fffdd0",
  "Peach-Dazzle": "#ffcba4",
  "Peach-Fizz": "#ffcba4",
  "Peach-Gold": "#d4af37",
  "Peach-Meringue": "#ffcba4",
  "Peach-Multi": "#ffcba4",
  "Peach-Nectar": "#ffcba4",
  "Peach-Off White": "#ffffff",
  "Peach-Ombre": "#ffcba4",
  "Peach-Pink": "#ffc0cb",
  "Peach-Rainbow": "#ffcba4",
  "Peach-Raspberry": "#8d4e85",
  "Peach-Romance": "#ffcba4",
  "Peach-Rose-Gold": "#fbcce7",
  "Peach-Sorbet": "#ffcba4",
  "Peach/Aqua": "#ffcba4",
  "Peach/Black": "#000000",
  "Peach/Cream": "#fffdd0",
  "Peach/Pink": "#ffc0cb",
  "Peach/Red": "#ff0000",
  "Peaches-and-Cream": "#fffdd0",
  "Peachy-Pink": "#ffc0cb",
  "Peacock": "#008381",
  "Peacock Ombre": "#008381",
  "Peacock Print": "#008381",
  "Peacock-Black": "#000000",
  "Peacock-Blue": "#0000ff",
  "Peacock-Multi": "#008381",
  "Peacock-Navy-Blue": "#000080",
  "Peacock-Nude": "#008381",
  "Peacock-Peacock": "#008381",
  "Peacock-Royal": "#008381",
  "Peacock-Silver": "#c0c0c0",
  "Peacock/Blue": "#0000ff",
  "Peacock/Gold": "#d4af37",
  "Peacock/Silver": "#c0c0c0",
  "Peacock/Turquoise": "#008381",
  "Pearl": "#426384",
  "Pearl Grey": "#426384",
  "Pearl Pink": "#426384",
  "Pearl White": "#426384",
  "Pearl-Blue": "#426384",
  "Pearl-Blush": "#426384",
  "Pearl-Gold": "#426384",
  "Pearl-Grey": "#426384",
  "Pearl-Nude": "#426384",
  "Pearl-Pink": "#426384",
  "Pearl-Silver": "#426384",
  "Pearl/Gold": "#426384",
  "Pearlescent": "#426384",
  "Pearly-Pink": "#426384",
  "Pebble": "#c3bca8",
  "Penny": "#ad6f69",
  "Peony": "#ad6f69",
  "PEONY PINK": "#ffc0cb",
  "Peppermint": "#98ff98",
  "Performance-Blue": "#0000ff",
  "Peri": "#6667ab",
  "Peri-Br-Pink-Ivory": "#ffc0cb",
  "Peridot/Green": "#008001",
  "Periwinkle": "#c3cde6",
  "Periwinkle Gold": "#d4af37",
  "Periwinkle Iridescent": "#18335e",
  "Periwinkle Ombre": "#c3cde6",
  "Periwinkle-Blue": "#0000ff",
  "Periwinkle-Bright-Pink-Ivory": "#ffc0cb",
  "Periwinkle-Coral": "#FF7F50",
  "Periwinkle-Gold": "#d4af37",
  "Periwinkle-Ivory": "#fffff0",
  "Periwinkle-Lemon": "#c3cde6",
  "Periwinkle-Light-Blue": "#0000ff",
  "Periwinkle-Lilac": "#9955bb",
  "Periwinkle-Multi": "#c3cde6",
  "Periwinkle-Nude": "#c3cde6",
  "Periwinkle-Opal": "#91b660",
  "Periwinkle-Pink": "#ffc0cb",
  "Periwinkle-Print": "#c3cde6",
  "Periwinkle-Sprinkle": "#c3cde6",
  "Periwinkle-White": "#c3cde6",
  "Periwinkle/Blue": "#0000ff",
  "Periwinkle/Nude": "#c3cde6",
  "Periwinkle/Silver": "#c0c0c0",
  "Perri": "#6667ab",
  "Perri Ombre": "#6667ab",
  "Perriwinkle": "#c3cde6",
  "Perry Blue": "#0000ff",
  "Perry-Blue": "#0000ff",
  "Persian Blue": "#0000ff",
  "Persimmon": "#EC5800",
  "Perwinkle": "#c3cde6",
  "Perwinkle-Silver": "#c0c0c0",
  "Petal": "#f3c4cf",
  "Petal Pink/Nude": "#ffc0cb",
  "Petal-Black": "#000000",
  "Petal-Blush": "#de5d83",
  "Petal-Multi": "#f3c4cf",
  "Petal-Peach": "#ffcba4",
  "Petal-Pearl": "#426384",
  "Petal-Pink": "#ffc0cb",
  "Petal-Pink-Rose-Pink": "#fbcce7",
  "Petal-Silver": "#c0c0c0",
  "Petal/Black": "#000000",
  "Petal/Grey": "#808080",
  "Petal/Pink": "#ffc0cb",
  "Petal/Silver": "#c0c0c0",
  "Petrol": "#005F6A",
  "Petrol-Black": "#000000",
  "Petrol-Blue": "#0000ff",
  "Petrol-Green": "#005F6A",
  "Petrol-Nude": "#eeece7",
  "Petrolic": "#005F6A",
  "Petunia": "#4f3466",
  "Pewter": "#8e9294",
  "PewterÂ ": "#8e9294",
  "Pewter-Black": "#000000",
  "Pewter-Blue": "#0000ff",
  "Pewter-Bronze": "#8e9294",
  "Pewter-Grey": "#808080",
  "Pewter-Petal": "#8e9294",
  "Pewter/Black": "#000000",
  "Pewter/Gold": "#d4af37",
  "Pewter/Grey": "#808080",
  "Pewter/Nude": "#8e9294",
  "Pewter/Silver": "#8e9294",
  "Phoenix": "#d86c37",
  "Pine": "#5da493",
  "Pine-Solid": "#5da493",
  "Pineapple": "#563c0d",
  "Pinehurst": "#0e322e",
  "Pink": "#ffc0cb",
  "Pink Alabaster": "#ffc0cb",
  "Pink Coral-Silver": "#ffc0cb",
  "Pink Coral/Multi": "#ffc0cb",
  "Pink Coral/Nude": "#ffc0cb",
  "Pink Floral": "#b57edc",
  "Pink Grapefruit": "#ffc0cb",
  "Pink Iridescent": "#ffc0cb",
  "Pink Lemonade": "#ffc0cb",
  "Pink Mist": "#ffc0cb",
  "Pink Multi": "#ffc0cb",
  "Pink Ombre": "#ffc0cb",
  "Pink Print": "#ffc0cb",
  "Pink Sparkle": "#ffc0cb",
  "Pink Topaz": "#ffc0cb",
  "Pink-AB": "#ffc0cb",
  "Pink-Alabaster": "#ffc0cb",
  "Pink-Antique Blue": "#986335",
  "Pink-Aqua-Print": "#ffc0cb",
  "Pink-Beige": "#f5f5dc",
  "Pink-Berry": "#8d4e85",
  "Pink-Black-White": "#000000",
  "Pink-Blue": "#0000ff",
  "Pink-Blush": "#ffc0cb",
  "Pink-Brick": "#ffc0cb",
  "Pink-Butterfly": "#ffc0cb",
  "Pink-Champagne": "#ffc0cb",
  "Pink-Champange": "#ffc0cb",
  "Pink-Charcoal": "#ffc0cb",
  "Pink-Chocolate": "#ffc0cb",
  "Pink-Clay": "#ffc0cb",
  "Pink-Coral": "#ffc0cb",
  "Pink-Coral-Silver": "#ffc0cb",
  "Pink-Creme": "#ffc0cb",
  "Pink-Diamond-White": "#b9f2ff",
  "Pink-Floral": "#b57edc",
  "Pink-Fuchsia": "#c74375",
  "Pink-Gold-Lame": "#ffc0cb",
  "Pink-Green": "#008001",
  "Pink-Grey": "#ffc0cb",
  "Pink-Ivory-Print": "#ffc0cb",
  "Pink-Lagoon": "#ffc0cb",
  "Pink-Light-Green": "#008001",
  "Pink-Mauve": "#ffc0cb",
  "Pink-Metallic": "#ffc0cb",
  "Pink-Mint": "#ffc0cb",
  "Pink-Mist": "#ffc0cb",
  "Pink-Multi": "#ffc0cb",
  "Pink-Multi.": "#ffc0cb",
  "Pink-Nile-Green": "#008001",
  "Pink-Ocean-Blue": "#0000ff",
  "Pink-Opal": "#91b660",
  "Pink-Orange": "#ffc0cb",
  "Pink-Quartz": "#ffc0cb",
  "Pink-Rose": "#fbcce7",
  "Pink-Royal-Blue": "#0000ff",
  "Pink-Sand": "#3c3e40",
  "Pink-Sand-Nude": "#3c3e40",
  "Pink-Sapphire": "#0f52ba",
  "Pink-Shimmer": "#ffc0cb",
  "Pink-Silver-Ivory": "#ffc0cb",
  "Pink-Silver-Raspberry": "#8d4e85",
  "Pink-Sorbet": "#ffc0cb",
  "Pink-Sparkle": "#ffc0cb",
  "Pink-Storm-Cloud": "#ffc0cb",
  "Pink-Teal": "#ffc0cb",
  "Pink-Topaz": "#ffc0cb",
  "Pink-Two-Tone": "#ffc0cb",
  "Pink-White": "#ffc0cb",
  "Pink-Wine": "#6c5857",
  "Pink-Yellow": "#ffc0cb",
  "Pink-Yellow-Black": "#000000",
  "Pink/ Hot Pink": "#ffc0cb",
  "Pink/Antique Blue": "#986335",
  "Pink/Aqua": "#ffc0cb",
  "Pink/Black": "#000000",
  "Pink/Black/White": "#000000",
  "Pink/Champagne": "#ffc0cb",
  "Pink/Charcoal": "#ffc0cb",
  "Pink/Coral": "#ffc0cb",
  "Pink/Fuchsia": "#c74375",
  "Pink/Gold": "#ffc0cb",
  "Pink/Grey": "#ffc0cb",
  "Pink/Hot Pink": "#ffc0cb",
  "Pink/Ivory": "#ffc0cb",
  "Pink/Lilac": "#9955bb",
  "Pink/Nude": "#ffc0cb",
  "Pink/Pink": "#ffc0cb",
  "Pink/Royal": "#ffc0cb",
  "Pink/Silver": "#ffc0cb",
  "Pink/Violet": "#ffc0cb",
  "Pink/White": "#ffc0cb",
  "Pink/Yellow Print": "#ffc0cb",
  "Pinkberry": "#8d4e85",
  "Pistachio": "#93c572",
  "Pistachio Green": "#93c572",
  "Pistachio-Green": "#93c572",
  "Pistachio-Hyper-Pink": "#ffc0cb",
  "Pistachio-Purple": "#6a0dad",
  "Platinum": "#e5e4e2",
  "Platinum Blush": "#de5d83",
  "Platinum Multi": "#e5e4e2",
  "Platinum Nude": "#e5e4e2",
  "Platinum Ombre": "#e5e4e2",
  "Platinum Rose": "#fbcce7",
  "Platinum-Black": "#000000",
  "Platinum-Blue": "#0000ff",
  "Platinum-Gunmetal": "#2a3439",
  "Platinum-Multi": "#e5e4e2",
  "Platinum-Navy": "#000080",
  "Platinum-Nude": "#e5e4e2",
  "Platinum-Pink": "#ffc0cb",
  "Platinum-Red-Royal": "#ff0000",
  "Platinum-Rose": "#fbcce7",
  "Platinum-Rose-Gold": "#fbcce7",
  "Platinum-Seafoam": "#e5e4e2",
  "Platinum-Shimmer": "#e3c9ab",
  "Platinum-Silver": "#c0c0c0",
  "Platinum-White": "#e5e4e2",
  "Platinum/Gold": "#d4af37",
  "Platinum/Multi": "#e5e4e2",
  "Plum": "#8e4585",
  "Plum & Nude": "#8e4585",
  "Plum Multi": "#8e4585",
  "Plum Print": "#8e4585",
  "Plum-Bashful": "#8e4585",
  "Plum-Black": "#000000",
  "Plum-Champagne": "#f7e7ce",
  "Plum-Floral": "#b57edc",
  "Plum-Multi": "#8e4585",
  "Plum-Nude": "#8e4585",
  "Plum-Rose-Multi": "#fbcce7",
  "Plum/Black": "#000000",
  "Poder Blue Gold": "#0000ff",
  "Polar-Purple": "#6a0dad",
  "Polka-Dot": "#739dad",
  "Pomegranate": "#660c21",
  "Pomegranate-Flower": "#660c21",
  "Pool": "#b8e9ee",
  "Pool-Navy": "#000080",
  "Poppy": "#c73d32",
  "Poppy Red": "#c73d32",
  "Poppy-Red": "#c73d32",
  "Porcelain": "#d4af37",
  "Porcelain Gold": "#ffd700",
  "Porcelain-Blue": "#0000ff",
  "Porcelain-Gold": "#d4af37",
  "Porcelain-Silver": "#c0c0c0",
  "Port": "#6b3b44",
  "Powder": "#b0e0e6",
  "Powder Blue": "#0000ff",
  "Powder Blue Iridescent": "#0000ff",
  "Powder Blue Multi": "#0000ff",
  "Powder Blue/Ivory": "#0000ff",
  "Powder Blue/Jade": "#00a86b",
  "Powder Blue/Nude": "#0000ff",
  "Powder Pink": "#ffc0cb",
  "Powder-Black": "#000000",
  "Powder-Blue-Gold": "#0000ff",
  "Powder-Blue-Lilac": "#9955bb",
  "Powder-Blue-Ocean": "#0000ff",
  "Powder-Blue-Silver": "#0000ff",
  "Powder-Blue-Teal-Blue": "#0000ff",
  "Powder-Blue-White": "#0000ff",
  "Powder-Degrade": "#b0e0e6",
  "Powder-Powder": "#b0e0e6",
  "Powder-Silver": "#c0c0c0",
  "Premier-Blue": "#0000ff",
  "Pretty In Pink": "#ffc0cb",
  "Pretty-In-Pink": "#ffc0cb",
  "Pretty-Pink": "#ffc0cb",
  "Princess Purple": "#6a0dad",
  "Print-Black": "#000000",
  "Print/Ivory": "#fffff0",
  "Print/Orange": "#ffa500",
  "Prism": "#e7eee7",
  "Prussian Blue": "#0000ff",
  "Pudra": "#eec4c9",
  "Pure White": "#ffffff",
  "Purple": "#6a0dad",
  "Purple Iridescent": "#18335e",
  "Purple Lilac": "#9955bb",
  "Purple Mint": "#98ff98",
  "Purple Mist": "#6a0dad",
  "Purple Multi": "#6a0dad",
  "Purple Ombre": "#6a0dad",
  "Purple Print": "#6a0dad",
  "Purple White": "#6a0dad",
  "Purple-AB": "#6a0dad",
  "Purple-Black": "#000000",
  "Purple-Bliss": "#6a0dad",
  "Purple-Blue": "#0000ff",
  "Purple-Cobalt": "#6a0dad",
  "Purple-Floral": "#b57edc",
  "Purple-Galaxy": "#26457a",
  "Purple-Green": "#008001",
  "Purple-Grey": "#808080",
  "Purple-Mauve": "#e0b0ff",
  "Purple-Mint": "#98ff98",
  "Purple-Navy": "#000080",
  "Purple-Navy-Navy": "#000080",
  "Purple-Opal": "#91b660",
  "Purple-Pink": "#ffc0cb",
  "Purple-Rain": "#6a0dad",
  "Purple-Red": "#e40078",
  "Purple-Reign": "#6a0dad",
  "Purple-Rose": "#fbcce7",
  "Purple-Shimmer": "#e3c9ab",
  "Purple-Teal": "#6a0dad",
  "Purple-White": "#6a0dad",
  "Purple/Black": "#000000",
  "Purple/Blue": "#0000ff",
  "Purple/Fuchsia": "#c74375",
  "Purple/Gold": "#d4af37",
  "Purple/Haze": "#6a0dad",
  "Purple/Lilac": "#9955bb",
  "Purple/Nude": "#6a0dad",
  "Purple/Passion": "#6a0dad",
  "Purple/Silver": "#c0c0c0",
  "Purple/Yellow": "#ffff00",
  "Purplicious": "#d1b8d3",
  "Putty": "#efead7",
  "Putty-Nude": "#eeece7",
  "Quartz": "#e9dfe0",
  "Quartz-Multi": "#e9dfe0",
  "Quartz-White": "#ffffff",
  "Quartz-Wood": "#e9dfe0",
  "Queen-of-Hearts": "#98333a",
  "Radiant Orchid": "#da70d6",
  "Rain-Green": "#3b4d3d",
  "Rainbow": "#233067",
  "Rainbow Gold": "#d4af37",
  "Raisin": "#242124",
  "Raisin/Shell Pink": "#ffc0cb",
  "Rasberry": "#E30B5C",
  "Raspberry": "#8d4e85",
  "Raspberry Red": "#ab273c",
  "Raspberry-Multi": "#8d4e85",
  "Raspberry-Navy": "#000080",
  "Raspberry-Nude": "#8d4e85",
  "Raspberry-Rosewater": "#fbcce7",
  "Raspberry-Shimmer": "#8d4e85",
  "Raspberry/Black": "#000000",
  "Raven": "#141a16",
  "Raven-Black": "#000000",
  "Rebrode-Aqua": "#00ffff",
  "Red": "#ff0000",
  "Red Black Ivory": "#000000",
  "Red Black Print": "#000000",
  "Red Chili": "#ff0000",
  "Red Hot": "#ff0000",
  "Red Multi": "#ff0000",
  "Red Ombre": "#ff0000",
  "Red Print": "#ff0000",
  "Red Solid": "#ff0000",
  "Red-Almond": "#ff0000",
  "Red-Beige": "#ff0000",
  "Red-Black-Black": "#000000",
  "Red-Black-Ivory": "#000000",
  "Red-Black-Print": "#000000",
  "Red-Blue": "#ff0000",
  "Red-Bright-Fuchsia": "#c74375",
  "Red-Burgundy": "#800020",
  "Red-Champagne": "#ff0000",
  "Red-Cherry": "#ff0000",
  "Red-Cream": "#ff0000",
  "Red-Ecru": "#ff0000",
  "Red-Green": "#008001",
  "Red-Gunmetal": "#ff0000",
  "Red-Hot": "#ff0000",
  "Red-Ivory-Print": "#ff0000",
  "Red-Lame": "#ff0000",
  "Red-Light-Pink": "#ff0000",
  "Red-Mint": "#ff0000",
  "Red-Multi-Black": "#000000",
  "Red-Navy": "#000080",
  "Red-Nude": "#ff0000",
  "Red-Nude-Iridescent": "#ff0000",
  "Red-Ombre": "#ff0000",
  "Red-Orange": "#ff0000",
  "Red-Pink": "#ff0000",
  "Red-Plum": "#ff0000",
  "Red-Purple": "#ff0000",
  "Red-Rose": "#ff0000",
  "Red-Shimmer": "#ff0000",
  "Red-Silver-Black": "#000000",
  "Red-Solid": "#ff0000",
  "Red-Tangerine": "#ff0000",
  "Red-Violet": "#ff0000",
  "Red-White": "#ff0000",
  "Red-Wine": "#ff0000",
  "Red/Black": "#000000",
  "Red/Blue Print": "#ff0000",
  "Red/Blush": "#ff0000",
  "Red/Fuchsia": "#c74375",
  "Red/Fuschia": "#ff0000",
  "Red/Gold": "#ff0000",
  "Red/Ivory": "#ff0000",
  "Red/Latte": "#ff0000",
  "Red/Magenta": "#ff0000",
  "Red/Neon Pink": "#ff0000",
  "Red/Nude": "#ff0000",
  "Red/Orange": "#ff0000",
  "Red/Plum": "#ff0000",
  "Red/Red": "#ff0000",
  "Red/Silver": "#ff0000",
  "Red/Turquoise": "#ff0000",
  "Red/Velvet": "#ff0000",
  "Red/Violet": "#ff0000",
  "Red/White": "#ff0000",
  "Redbud": "#ff0000",
  "Redwood": "#ff0000",
  "Regency": "#eee5d6",
  "Regent": "#364042",
  "Res": "#364042",
  "Reseda-Green": "#008001",
  "Rhodium": "#E2E7E1",
  "Rhodium-Crystal": "#a7d8de",
  "Rhodium/Light Amethyst": "#V",
  "Rhodium/White": "#ffffff",
  "Rich-Gold": "#d4af37",
  "Rio-Red": "#ff0000",
  "Rio-Tangerine": "#f28500",
  "Robin Blue": "#0000ff",
  "Robin-Blue": "#0000ff",
  "Robins Egg Blue": "#0000ff",
  "Rockstar": "#3d3a3c",
  "Romantic-Pink": "#ffc0cb",
  "Root-Rose": "#fbcce7",
  "Rose": "#fbcce7",
  "Rose Frost": "#fbcce7",
  "Rose Gold": "#fbcce7",
  "Rose Gold Ombre": "#fbcce7",
  "Rose Gold Sequin": "#fbcce7",
  "Rose Gold/Gold": "#fbcce7",
  "Rose Gold/Nude": "#fbcce7",
  "Rose Gunmetal": "#fbcce7",
  "Rose Multi": "#fbcce7",
  "Rose Nude": "#fbcce7",
  "Rose Pink": "#fbcce7",
  "Rose Taupe": "#fbcce7",
  "Rose Taupe-Silver": "#fbcce7",
  "Rose-Beige": "#fbcce7",
  "Rose-Black": "#000000",
  "Rose-Blue": "#fbcce7",
  "Rose-Blush": "#fbcce7",
  "Rose-BonBon": "#fbcce7",
  "Rose-Bud": "#fbcce7",
  "Rose-Champagne": "#fbcce7",
  "Rose-Cloud": "#fbcce7",
  "Rose-Floral": "#b57edc",
  "Rose-Frost": "#fbcce7",
  "Rose-Gold": "#fbcce7",
  "Rose-Gold--Grey": "#fbcce7",
  "Rose-Gold-Ab": "#fbcce7",
  "Rose-Gold-Black": "#000000",
  "Rose-Gold-Ivory": "#fbcce7",
  "Rose-Gold-Multi": "#fbcce7",
  "Rose-Gold-Pink": "#fbcce7",
  "Rose-Gold-Sequin": "#fbcce7",
  "Rose-Gold-Silver": "#fbcce7",
  "Rose-Grey": "#fbcce7",
  "Rose-Lilac": "#9955bb",
  "Rose-Mauve": "#fbcce7",
  "Rose-Nude": "#fbcce7",
  "Rose-Ombre": "#fbcce7",
  "Rose-Opal": "#91b660",
  "Rose-Pewter": "#fbcce7",
  "Rose-Pink": "#fbcce7",
  "Rose-Print": "#fbcce7",
  "Rose-Quartz": "#fbcce7",
  "Rose-Quartz-Nude": "#fbcce7",
  "Rose-Red": "#ff0000",
  "Rose-Shimmer": "#fbcce7",
  "Rose-Silver": "#fbcce7",
  "Rose-Silver-Ombre": "#fbcce7",
  "Rose-Tan": "#fbcce7",
  "Rose-Taupe": "#fbcce7",
  "Rose-Water": "#fbcce7",
  "Rose-Wood": "#fbcce7",
  "Rose/Ivory": "#fbcce7",
  "Rose/Mocha": "#fbcce7",
  "Rose/Multi": "#fbcce7",
  "Rose/Nude": "#fbcce7",
  "Rose/Pink": "#fbcce7",
  "Rose/Quartz": "#fbcce7",
  "Rose/Silver": "#fbcce7",
  "Rosegold": "#fbcce7",
  "Rosegold-Black": "#000000",
  "Rosemary": "#fbcce7",
  "Rosewater Multi": "#fbcce7",
  "Rosewater Solid": "#fbcce7",
  "Rosewater-Gold": "#fbcce7",
  "Rosewater-Multi": "#fbcce7",
  "Rosewater-Nude-Gold": "#fbcce7",
  "Rosewater-Opal": "#91b660",
  "Rosewater-Silver": "#fbcce7",
  "Rosewater-Solid": "#fbcce7",
  "Rosewood": "#fbcce7",
  "Rosewood-Silver": "#fbcce7",
  "Rosewood/Silver": "#fbcce7",
  "Rouge": "#b3575c",
  "Royal": "#4169e1",
  "Royal & Gold": "#d4af37",
  "Royal Aqua": "#4169e1",
  "Royal Blue": "#0000ff",
  "Royal Blue Multi": "#0000ff",
  "ROYAL BLUE/BLACK": "#000000",
  "Royal Blue/Orange": "#0000ff",
  "Royal Blue/Rose Gold": "#fbcce7",
  "Royal Blue/Silver": "#0000ff",
  "Royal Blue/White": "#0000ff",
  "Royal Lilac": "#9955bb",
  "Royal Multi": "#4169e1",
  "Royal Navy": "#000080",
  "Royal Ocean": "#48bf91",
  "Royal Ombre": "#4169e1",
  "Royal Print": "#4169e1",
  "Royal Rose Gold": "#fbcce7",
  "Royal-AB": "#4169e1",
  "Royal-Aqua": "#4169e1",
  "Royal-Blue-Champagne": "#0000ff",
  "Royal-Blue-Gold": "#0000ff",
  "Royal-Blue-Multi": "#0000ff",
  "Royal-Blue-Nude": "#0000ff",
  "Royal-Blue-Silver": "#0000ff",
  "Royal-Crystal": "#a7d8de",
  "Royal-Emerald": "#50c878",
  "Royal-Emerald-Irides": "#50c878",
  "Royal-Fuchsia": "#c74375",
  "Royal-Green": "#136207",
  "Royal-Iridescent": "#18335e",
  "Royal-Light-Blue": "#0000ff",
  "Royal-Lilac": "#9955bb",
  "Royal-Mauve": "#e0b0ff",
  "Royal-Metal": "#4169e1",
  "Royal-Ombre": "#4169e1",
  "Royal-Plum": "#8e4585",
  "Royal-Purple": "#6a0dad",
  "Royal-Royal": "#4169e1",
  "Royal-Shimmer": "#e3c9ab",
  "Royal-Silver-Multi": "#4169e1",
  "Royal-Two-Tone": "#4169e1",
  "Royal-Violet": "#7f00ff",
  "Royal-White": "#4169e1",
  "Royal-Yellow": "#ffff00",
  "Royal/Black": "#000000",
  "Royal/Gold": "#d4af37",
  "Royal/Gunmetal": "#2a3439",
  "Royal/Nude": "#4169e1",
  "Royal/Ocean": "#48bf91",
  "Royal/Peacock": "#008381",
  "Royal/Pearl": "#426384",
  "Royal/Purple": "#6a0dad",
  "Royal/Sea Blue": "#0000ff",
  "Royal/Silver": "#4169e1",
  "Royal/Turquoise": "#4169e1",
  "Royal/Wine": "#6c5857",
  "Ruby": "#9b111e",
  "Ruby Black": "#000000",
  "Ruby Emerald": "#9b111e",
  "Ruby Red": "#9b111e",
  "Ruby-Nude": "#9b111e",
  "Ruby-Onyx": "#9b111e",
  "Ruby-Red": "#9b111e",
  "Ruby/Nude": "#9b111e",
  "Rum-Pink": "#ffc0cb",
  "Rust": "#b7410e",
  "Rust Copper": "#b87333",
  "Rust-Turquoise": "#40e0d0",
  "Rust-Wine": "#6c5857",
  "Rustic": "#b7410e",
  "Rusty-Rose": "#fbcce7",
  "Sable": "#3e3526",
  "Safari-Green": "#a0a56e",
  "Saffron": "#f4c430",
  "Saffron Yellow": "#ffff00",
  "Sage": "#bcb88a",
  "Sage Green": "#77815c",
  "Sage Multi": "#bcb88a",
  "Sage Silver": "#c0c0c0",
  "Sage-Champagne": "#f7e7ce",
  "Sage-Mercury": "#bcb88a",
  "Sage-Multi": "#bcb88a",
  "Sage-Nude": "#eeece7",
  "Sage-Silver": "#c0c0c0",
  "Salmon": "#fa8072",
  "Salsa": "#fd3a4a",
  "Sand": "#3c3e40",
  "Sand Sage": "#3c3e40",
  "Sand-Dollar": "#3c3e40",
  "Sand-Multi": "#3c3e40",
  "Sand-Sage": "#3c3e40",
  "Sandstone": "#3c3e40",
  "Sandstone-Silver": "#3c3e40",
  "Sangria": "#92000a",
  "Sangria Multi": "#92000a",
  "Sangria-Multi": "#92000a",
  "Sangria-Nude": "#eeece7",
  "Sangria-Silver": "#c0c0c0",
  "Sangria/Gold": "#d4af37",
  "Santorini": "#416d83",
  "Santorini Blue": "#0000ff",
  "Santorini-Blue": "#0000ff",
  "Saphire-Blue": "#0000ff",
  "Sapphire": "#0f52ba",
  "Sapphire Blue": "#0f52ba",
  "Sapphire Multi": "#0f52ba",
  "Sapphire-Almond": "#0f52ba",
  "Sapphire-Black": "#000000",
  "Sapphire-Multi": "#0f52ba",
  "Sapphire-Nude": "#0f52ba",
  "Sapphire-Silver": "#0f52ba",
  "Sapphire/Multi": "#0f52ba",
  "Sapphire/Nude": "#0f52ba",
  "Sapphire/Silver": "#0f52ba",
  "Sassy-Magenta": "#ff0090",
  "Sax": "#657f84",
  "Sax Blue": "#0000ff",
  "Sax-Blue-White": "#0000ff",
  "Sax/Black": "#000000",
  "Saxe-Blue": "#0000ff",
  "Saxon-Blue": "#0000ff",
  "Scarlet": "#ff2400",
  "Scarlet-Multi": "#ff2400",
  "Scarlet-Nude": "#eeece7",
  "Scarlet-Red": "#FF2400",
  "Scarlett": "#ff2400",
  "Screamin-Green": "#66ff66",
  "Scuba-Print": "#00abc0",
  "Sea Blue": "#0000ff",
  "Sea Breeze": "#006994",
  "Sea Breeze/Gold": "#d4af37",
  "Sea Foam Green": "#9fe2bf",
  "Sea Foam-Blue": "#0000ff",
  "Sea Foam-Gold": "#d4af37",
  "Sea Foam-Multi": "#006994",
  "Sea Foam-Nude": "#eeece7",
  "Sea Foam/Nude": "#eeece7",
  "Sea Glass": "#006994",
  "Sea Green": "#9fe2bf",
  "Sea Lavender": "#b57edc",
  "Sea Mist": "#006994",
  "Sea Mist/Silver": "#c0c0c0",
  "Sea Turquoise": "#40e0d0",
  "Sea-Foam": "#006994",
  "Sea-Green": "#9fe2bf",
  "Seabreeze": "#006994",
  "Seabreeze-Gold": "#d4af37",
  "Seabreeze-Multi": "#006994",
  "Seabreeze-Nude": "#eeece7",
  "Seabreeze-Silver": "#c0c0c0",
  "Seafoam": "#006994",
  "Seafoam Multi": "#006994",
  "Seafoam Solid": "#006994",
  "Seafoam-Blue": "#0000ff",
  "Seafoam-Green": "#9fe2bf",
  "Seafoam/Gold": "#d4af37",
  "Seafoam/Silver": "#c0c0c0",
  "Seafom": "#006994",
  "Seaglass": "#006994",
  "Seaglass-Malibu": "#008cc1",
  "Seashell": "#006994",
  "Seattle Grey": "#808080",
  "Sepia-Gold": "#d4af37",
  "Serenity": "#93a9d1",
  "Serenity-Silver": "#c0c0c0",
  "Shadow": "#8a795d",
  "Shadow Grey": "#808080",
  "Shale-Grey": "#808080",
  "Shamrock": "#009e60",
  "Shell": "#f4ebdb",
  "Shell Pink": "#ffc0cb",
  "Shell-Pink": "#ffc0cb",
  "Sherbert": "#dc7474",
  "Sherbet": "#dc7474",
  "Sherbet-Multi": "#dc7474",
  "Shimmer": "#e3c9ab",
  "Shimmer Blue": "#0000ff",
  "Shimmer-Black": "#000000",
  "Shimmer-Blush": "#de5d83",
  "Shimmer-Fuchsia": "#c74375",
  "Shimmer-Lilac": "#9955bb",
  "Shimmer-Periwinkle": "#e3c9ab",
  "Shimmer-Pink": "#ffc0cb",
  "Shimmer-Purple": "#e3c9ab",
  "Shimmer-Sage": "#e3c9ab",
  "Shimmer-White": "#e3c9ab",
  "Shimmering Gold": "#d4af37",
  "Shimmering-Gold": "#d4af37",
  "Shimmering-Ice": "#e3c9ab",
  "Shimmery Blush": "#de5d83",
  "Shiny-Ivory": "#fffff0",
  "Shocking Pink": "#ffc0cb",
  "Sienna": "#a0522d",
  "Sienna Brown": "#964b00",
  "Sienna-Orange": "#ffa500",
  "Sienna-Rose": "#fbcce7",
  "Silver": "#c0c0c0",
  "Silver Crystal": "#a7d8de",
  "Silver Floral": "#b57edc",
  "Silver Foil": "#c0c0c0",
  "Silver Gold Nude": "#d4af37",
  "Silver Gold Ombre": "#d4af37",
  "Silver Multi": "#c0c0c0",
  "Silver Ombre": "#c0c0c0",
  "Silver Pearl": "#426384",
  "Silver Taupe": "#c0c0c0",
  "Silver-AB": "#c0c0c0",
  "Silver-Black": "#000000",
  "Silver-BlackÂ ": "#000000",
  "Silver-Blue": "#0000ff",
  "Silver-Bronze": "#c0c0c0",
  "Silver-Cafe": "#c0c0c0",
  "Silver-Champagne": "#f7e7ce",
  "Silver-Charcoal": "#36454f",
  "Silver-Cloud": "#c0c0c0",
  "Silver-Crystal": "#a7d8de",
  "Silver-Crystal-Nude": "#a7d8de",
  "Silver-Emerald": "#c0c0c0",
  "Silver-Floral": "#b57edc",
  "Silver-Floral-Embroidered": "#b57edc",
  "Silver-French-Blue": "#0000ff",
  "Silver-Galaxy": "#26457a",
  "Silver-Gold-AB": "#d4af37",
  "Silver-Gold-Black": "#000000",
  "Silver-Gold-Nude": "#d4af37",
  "Silver-Green": "#c0d5c2",
  "Silver-Gunmetal": "#2a3439",
  "Silver-Heather": "#c0c0c0",
  "Silver-Ivory": "#fffff0",
  "Silver-Lake": "#c0c0c0",
  "Silver-Lake-French-Pink": "#ffc0cb",
  "Silver-Lake-Tulle-Mademoiselle-Lace": "#c0c0c0",
  "Silver-Leaf": "#c0c0c0",
  "Silver-Light-Blue": "#0000ff",
  "Silver-Light-White": "#c0c0c0",
  "Silver-Lime": "#c0c0c0",
  "Silver-Mauve": "#e0b0ff",
  "Silver-Md-White": "#c0c0c0",
  "Silver-Mink-Gold": "#d4af37",
  "Silver-Mint": "#98ff98",
  "Silver-Mist": "#c0c0c0",
  "Silver-Navy": "#000080",
  "Silver-Nude": "#c0c0c0",
  "Silver-Nude-AB": "#c0c0c0",
  "Silver-Nude-Crystal": "#a7d8de",
  "Silver-Nude-Taupe": "#c0c0c0",
  "Silver-Ombre": "#c0c0c0",
  "Silver-Opal": "#91b660",
  "Silver-Orchid-Nude": "#da70d6",
  "Silver-Pearl": "#426384",
  "Silver-Peony": "#c0c0c0",
  "Silver-Pink": "#ffc0cb",
  "Silver-Pink-Black": "#000000",
  "Silver-Print": "#c0c0c0",
  "Silver-Purple": "#c0c0c0",
  "Silver-Red": "#ff0000",
  "Silver-Rose": "#fbcce7",
  "Silver-Rosewater": "#fbcce7",
  "Silver-Royal": "#c0c0c0",
  "Silver-Sage": "#c0c0c0",
  "Silver-Sage-Blush": "#de5d83",
  "Silver-Salmon": "#c0c0c0",
  "Silver-Sand": "#3c3e40",
  "Silver-Seafoam": "#c0c0c0",
  "Silver-Solid": "#c0c0c0",
  "Silver-Stardust": "#c0c0c0",
  "Silver-Stone": "#c0c0c0",
  "Silver-Turquoise": "#c0c0c0",
  "Silver/ AB": "#c0c0c0",
  "Silver/Aqua": "#c0c0c0",
  "Silver/Black": "#000000",
  "Silver/Blue": "#0000ff",
  "Silver/Blush": "#de5d83",
  "Silver/Champagne": "#f7e7ce",
  "Silver/Charcoal": "#36454f",
  "Silver/Crystal": "#a7d8de",
  "Silver/Floral": "#b57edc",
  "Silver/Gold": "#d4af37",
  "Silver/Grey": "#808080",
  "Silver/Gunmetal": "#2a3439",
  "Silver/Ice Blue": "#0000ff",
  "Silver/Ivory": "#fffff0",
  "Silver/Lilac": "#9955bb",
  "Silver/Mint": "#98ff98",
  "Silver/Multi": "#c0c0c0",
  "Silver/Navy": "#000080",
  "Silver/Nude": "#c0c0c0",
  "Silver/Pewter": "#8e9294",
  "Silver/Pink": "#ffc0cb",
  "Silver/Platinum": "#c0c0c0",
  "Silver/Purple": "#979991",
  "Silver/Rainbow": "#c0c0c0",
  "Silver/Rose": "#fbcce7",
  "Silver/Rose Gold": "#fbcce7",
  "Silver/Royal": "#c0c0c0",
  "Silver/Silver": "#c0c0c0",
  "Silver/Turquoise": "#40e0d0",
  "Silver/White": "#c0c0c0",
  "Silvery": "#c0c0c0",
  "Silvery-Blue": "#c4d4e0",
  "Skin": "#ffdfc4",
  "Skin-Multi-Colored": "#ffdfc4",
  "Sky": "#87ceeb",
  "Sky Black": "#000000",
  "Sky Blue": "#0000ff",
  "Sky Blue Rose Gold": "#fbcce7",
  "Sky Blue-Nude": "#0000ff",
  "Sky Blue/Gold": "#0000ff",
  "Sky Blue/Nude": "#0000ff",
  "Sky Blue/White": "#0000ff",
  "Sky Nude": "#87ceeb",
  "Sky Pearl": "#426384",
  "Sky-Black": "#000000",
  "Sky-Blue": "#0000ff",
  "Sky-Blue-Floral": "#b57edc",
  "Sky-Blue-Navy": "#000080",
  "Sky-Blue-Nude": "#0000ff",
  "Sky-Blue-Soft-Coral": "#0000ff",
  "Sky-Multi": "#87ceeb",
  "Sky-Navy": "#000080",
  "Sky-Royal": "#4169e1",
  "Sky-Silver": "#c0c0c0",
  "Sky-Sky": "#87ceeb",
  "Skyway Blue": "#0000ff",
  "Skyway-Blue": "#0000ff",
  "Slate": "#708090",
  "Slate Blue": "#0000ff",
  "Slate Grey": "#808080",
  "Slate-Blue": "#0000ff",
  "Slate-Blue-Multi": "#0000ff",
  "Slate-Gold": "#d4af37",
  "Slate-Lilac": "#9955bb",
  "Slate-Multi": "#708090",
  "Slate-Purple": "#6a0dad",
  "Slate-Rose-Gold": "#fbcce7",
  "Slate/Navy": "#000080",
  "Sliver-Nude": "#eeece7",
  "Smoke": "#738276",
  "Smoke Blue": "#0000ff",
  "Smoke Grey": "#808080",
  "Smoke Nude": "#738276",
  "Smoke Purple": "#6a0dad",
  "Smoke Smoke": "#738276",
  "Smoke-Green": "#a8bba2",
  "Smoke-Grey": "#808080",
  "Smoke-Light-Gold": "#d4af37",
  "Smoke-Multi": "#738276",
  "Smoke-Pearl": "#426384",
  "Smoke-Pink": "#ffc0cb",
  "Smoke-Purple": "#6a0dad",
  "Smoke-Rosewater": "#fbcce7",
  "Smoke-Sand": "#3c3e40",
  "Smoke-Silver": "#c0c0c0",
  "Smoke-Smoke": "#738276",
  "Smoke/Nude": "#738276",
  "Smoke/Oyster": "#738276",
  "Smoke/Rosewater": "#fbcce7",
  "Smoke/Silver": "#c0c0c0",
  "Smoked": "#738276",
  "Smokey Blue": "#0000ff",
  "Smokey-Blue": "#0000ff",
  "Smoky Blue": "#0000ff",
  "Smoky Mink": "#d2b7a6",
  "Smoky Taupe": "#baa68e",
  "Smoky-Blue": "#0000ff",
  "Smoky-Mink": "#d2b7a6",
  "Smoky-Quartz": "#d2b7a6",
  "Snakeskin": "#9c6b08",
  "Snakeskin-Black": "#000000",
  "Snow Leopard": "#dfe2de",
  "Snow-White": "#ffffff",
  "Soft Blue": "#0000ff",
  "Soft Blue Silver": "#0000ff",
  "Soft Coral": "#FF7F50",
  "Soft Coral Iridescent": "#18335e",
  "Soft Coral/Mint": "#98ff98",
  "Soft Crystal": "#a7d8de",
  "Soft Jade": "#00a86b",
  "Soft Lilac": "#9955bb",
  "Soft Midnight": "#702670",
  "Soft Navy": "#000080",
  "Soft Peach": "#ffcba4",
  "Soft Pink": "#ffc0cb",
  "Soft Pink Off White": "#ffc0cb",
  "Soft White": "#ffffff",
  "Soft White/Black": "#000000",
  "Soft-Blue": "#0000ff",
  "Soft-Blue-Silver": "#0000ff",
  "Soft-Blush": "#de5d83",
  "Soft-Gold": "#d4af37",
  "Soft-Heather": "#b6a5a6",
  "Soft-Lilac": "#9955bb",
  "Soft-Lime": "#00ff00",
  "Soft-Mauve": "#e0b0ff",
  "Soft-Natural": "#b3cbc2",
  "Soft-Navy": "#000080",
  "Soft-Peach": "#ffcba4",
  "Soft-Sage": "#c8cdba",
  "Soft-Yellow": "#ffff00",
  "Solid-Diamond-White": "#b9f2ff",
  "Solid-Ivory": "#fffff0",
  "Solid-White": "#ffffff",
  "Sonic-Silver": "#c0c0c0",
  "Sorbet": "#f2d7d7",
  "Space": "#414a4c",
  "Space-Purple": "#6a0dad",
  "Spanish Red": "#e60026",
  "Spanish-Villa": "#dfbaa9",
  "Sparkle-Pink": "#ffc0cb",
  "Sparkle-Rose": "#fbcce7",
  "Sparkling Grape": "#763374",
  "Spearmint": "#98ff98",
  "Special-Pink": "#ffc0cb",
  "Special-Pink-Ice-Pink": "#ffc0cb",
  "Special-Pink-Silver": "#ffc0cb",
  "Spice": "#ead3c0",
  "Spice Red": "#ad1930",
  "Spring": "#a7fc00",
  "Spring Blush": "#de5d83",
  "Spring Green": "#add1a7",
  "Spring-Bud": "#a7fc00",
  "Spring-Green": "#add1a7",
  "Spring-Pink": "#ffc0cb",
  "Spruce": "#9caeae",
  "Spun-Gold": "#d4af37",
  "Star-Shine": "#d9e1e4",
  "Stardust": "#c8aa7f",
  "Stargazer": "#4d6a8f",
  "Starlight": "#96999f",
  "Starry Blue": "#0000ff",
  "Steel": "#7a7f80",
  "Steel Blue": "#0000ff",
  "Steel Grey": "#808080",
  "Steel Nude": "#eeece7",
  "Steel-Blue-Silver": "#0000ff",
  "Steel-Grey": "#808080",
  "Steel/Silver": "#c0c0c0",
  "Sterling": "#bec2cb",
  "Sterling Gold": "#d4af37",
  "Sterling Rose": "#fbcce7",
  "Sterling-Rose": "#fbcce7",
  "Stone": "#68926d",
  "Stone Blue": "#0000ff",
  "Stone Grey": "#808080",
  "Stone-Ab": "#68926d",
  "Stone-Black": "#000000",
  "Stone-Blue": "#0000ff",
  "Stone-Coal": "#68926d",
  "Stone-Cold": "#68926d",
  "Stone-Grey": "#808080",
  "Stone-Ivory": "#fffff0",
  "Stone-Multi": "#68926d",
  "Stone-Pink": "#ffc0cb",
  "Stone-Rosewater": "#fbcce7",
  "Stone-Wash": "#68926d",
  "Stone/Ivory": "#fffff0",
  "Stone/Nude": "#eeece7",
  "Stone/Rosewater": "#fbcce7",
  "Storm": "#7e8796",
  "Storm-Cloud": "#d0cccc",
  "Storm-Cloud-Pink": "#ffc0cb",
  "Storm-Cloud-Pink-Lace": "#ffc0cb",
  "Storm-Cloud-Pink-Pink": "#ffc0cb",
  "Storm-Grey": "#808080",
  "Stormy Blue": "#0000ff",
  "Stormy-Blue": "#0000ff",
  "Strawberry": "#8d4e85",
  "Strawberry-Champagne": "#8d4e85",
  "Strawberry-Silver": "#8d4e85",
  "Sultry-Blush": "#de5d83",
  "Summer-Rose": "#fbcce7",
  "Sun-Drenched-Yellow": "#ffff00",
  "Sunburst-Orange": "#ffa500",
  "Sunflower": "#f6a90f",
  "Sunkiss-Orange": "#ffa500",
  "Sunkissed": "#ddbca0",
  "Sunkist-Peach": "#ffcba4",
  "Sunlight": "#fdfbd3",
  "Sunset": "#ffc922",
  "Sunset-Ginger": "#ffc922",
  "Sunset-Orange": "#ffa500",
  "Sunset-Print": "#ffc922",
  "Sunshine": "#fade85",
  "Suntan": "#dbb19f",
  "Super Pink": "#ffc0cb",
  "Supernova": "#f9ac00",
  "Sweet-Sugar": "#d99e6e",
  "Syrah": "#6a282c",
  "Taffy-Pink": "#ffc0cb",
  "Tan": "#Tan",
  "Tan-Multi": "#Tan",
  "Tan-Royal": "#4169e1",
  "Tan-White": "#ffffff",
  "Tangelo": "#f94d00",
  "Tangerine": "#f28500",
  "Tangerine Ombre": "#f28500",
  "Tangerine-Barbie-Pink": "#ffc0cb",
  "Tangerine-Black": "#000000",
  "Tangerine-Fuchsia": "#c74375",
  "Tangerine-Lime": "#00ff00",
  "Tangerine-Magenta": "#ff0090",
  "Tangerine-Multi": "#f28500",
  "Tangerine-Tango": "#f28500",
  "Tangerine-Yellow": "#ffff00",
  "Tangerine/Fuchsia": "#c74375",
  "Tangerine/Ivory": "#fffff0",
  "Tango Red": "#bb221b",
  "Tango-Red": "#bb221b",
  "Taro": "#5b435d",
  "Taupe": "#baa68e",
  "Taupe Gold": "#d4af37",
  "Taupe Ivory": "#fffff0",
  "Taupe Lavender": "#b57edc",
  "Taupe Ombre": "#baa68e",
  "Taupe-Bronze": "#b08d57",
  "Taupe-Cocoa": "#baa68e",
  "Taupe-Gold": "#d4af37",
  "Taupe-Gunmetal": "#2a3439",
  "Taupe-Ivory": "#fffff0",
  "Taupe-Lavender": "#b57edc",
  "Taupe-Mauve": "#e0b0ff",
  "Taupe-Mocha": "#bea493",
  "Taupe-Multi": "#baa68e",
  "Taupe-Navy": "#000080",
  "Taupe-Nude": "#baa68e",
  "Taupe-Orchid": "#da70d6",
  "Taupe-Rose": "#fbcce7",
  "Taupe-Silver": "#c0c0c0",
  "Taupe-Silver-Bronze": "#c0c0c0",
  "Taupe-Taupe": "#baa68e",
  "Taupe/Black": "#000000",
  "Taupe/Dark Green": "#006400",
  "Taupe/Multi": "#baa68e",
  "Taupe/Nude": "#baa68e",
  "Taupe/Pink": "#ffc0cb",
  "Taupe/Silver": "#c0c0c0",
  "Tea": "#d0f0c0",
  "Tea Rose": "#fbcce7",
  "Tea-Rose": "#fbcce7",
  "Teal": "#008080",
  "Teal & Ivory": "#fffff0",
  "Teal Blue": "#0000ff",
  "Teal Blue/Multi": "#0000ff",
  "Teal Mist": "#008080",
  "Teal Multi": "#008080",
  "Teal-Black": "#000000",
  "Teal-Black Floral": "#b57edc",
  "Teal-Blue-Charcoal": "#0000ff",
  "Teal-Champagne": "#f7e7ce",
  "Teal-Fawn": "#008080",
  "Teal-Green": "#00827f",
  "Teal-Gunmetal": "#2a3439",
  "Teal-Iridescent": "#18335e",
  "Teal-Mint": "#98ff98",
  "Teal-Multi": "#008080",
  "Teal-Ombre": "#008080",
  "Teal-Print": "#008080",
  "Teal-Purple": "#6a0dad",
  "Teal-Silver": "#c0c0c0",
  "Teal-Steel": "#008080",
  "Teal/Black": "#000000",
  "Teal/Gold": "#d4af37",
  "Teal/Gunmetal": "#2a3439",
  "Teal/Jade": "#00a86b",
  "Teal/Navy Blue": "#000080",
  "Teal/Nude": "#008080",
  "Teal/Purple": "#6a0dad",
  "Teal/Silver": "#c0c0c0",
  "Teal/White": "#008080",
  "Tearose-Vintage-White": "#fbcce7",
  "Terra Cotta": "#e2725b",
  "Terracotta": "#e2725b",
  "Terracotta-Powder": "#e2725b",
  "Thistle": "#D8BFD8",
  "Tie-Dye": "#091f92",
  "Tiedye": "#091f92",
  "Tiffany": "#0abab5",
  "Tiffany Blue": "#0000ff",
  "Tiffany Blue/Nude": "#0000ff",
  "Tiffany Silver": "#c0c0c0",
  "Tiffany-Blue-Ivory": "#0000ff",
  "Tiffany-Nude": "#0abab5",
  "Tiffany-Print": "#0abab5",
  "Tiffany-Silver-Nude": "#c0c0c0",
  "Tiffany-Silver-Ombre": "#c0c0c0",
  "Tiger": "#cb7119",
  "Tiger Print": "#cb7119",
  "Tiger-Print": "#cb7119",
  "Tigerlily": "#cb7119",
  "Tile": "#008491",
  "Titanium-Shimmer": "#e3c9ab",
  "Toast": "#9a6e61",
  "Tobbacco-Brown": "#964b00",
  "Toffee": "#9e815d",
  "Tomato": "#ff6347",
  "Topaz": "#ffc87c",
  "Treasure-Island": "#009362",
  "Tropical-Green": "#346c6f",
  "Tropical-Orange": "#ffa500",
  "True-Silver": "#c0c0c0",
  "Truffle": "#978076",
  "Tulip Pink": "#ffc0cb",
  "Tulip-Pink": "#ffc0cb",
  "Tulle-Rebrode": "#e80085",
  "Turf": "#6f8c69",
  "Turkish-Blue": "#0000ff",
  "Turkish-Sea": "#1a5190",
  "Turq-Silver": "#c0c0c0",
  "Turquoise": "#40e0d0",
  "Turquoise Iridescent": "#18335e",
  "Turquoise Multi": "#40e0d0",
  "Turquoise Ombre": "#40e0d0",
  "Turquoise Stone": "#40e0d0",
  "Turquoise-Clear-Silver": "#c0c0c0",
  "Turquoise-Ivory": "#fffff0",
  "Turquoise-Jade": "#00a86b",
  "Turquoise-Lilac": "#9955bb",
  "Turquoise-Peacock": "#008381",
  "Turquoise-Royal-Blue": "#0000ff",
  "Turquoise-Shimmer": "#e3c9ab",
  "Turquoise-Stone": "#40e0d0",
  "Turquoise-Yellow": "#ffff00",
  "Turquoise/ Purple": "#6a0dad",
  "Turquoise/Black": "#000000",
  "Turquoise/Gold": "#d4af37",
  "Turquoise/Nude": "#40e0d0",
  "Turquoise/Orange": "#ffa500",
  "Turquoise/Purple": "#6a0dad",
  "Turquoise/Royal": "#4169e1",
  "Turquoise/Silver": "#c0c0c0",
  "Turquoise/Violet": "#7f00ff",
  "Turquoisese": "#40e0d0",
  "Tuscany": "#c09999",
  "Tusk": "#d8d1c7",
  "Twilight": "#8a496b",
  "Twilight-Blue": "#0000ff",
  "Twilight-Teal": "#008080",
  "Ultra Marin": "#4166f5",
  "Ultra Violet": "#7f00ff",
  "Ultramarine": "#4166f5",
  "Ultraviolet": "#7f00ff",
  "Under-the-Sea": "#39555c",
  "Unicorn": "#9f90d0",
  "Unicorn Violet": "#7f00ff",
  "Unicorn-Blue": "#0000ff",
  "Unicorn-Ombre": "#9f90d0",
  "Unicorn-Pink": "#ffc0cb",
  "Unicorn-Purple": "#6a0dad",
  "Unicorn-Violet": "#7f00ff",
  "Unicorn(violet)": "#7f00ff",
  "Valentine": "#c72b50",
  "Valentine Heart": "#c72b50",
  "Valentine-Hot-Pink": "#ffc0cb",
  "Valentine-Multi": "#c72b50",
  "Valentine-Nude": "#eeece7",
  "Valentine-Silver": "#c0c0c0",
  "Valentine/Multi": "#c72b50",
  "Valentine/Pearl": "#426384",
  "Vamp Red": "#ff0000",
  "Vanilla": "#fdead9",
  "Vanilla-Black": "#000000",
  "Vanilla-Silver": "#fdead9",
  "Venice-Blue": "#0000ff",
  "Veri-Peri": "#6667AB",
  "Vermilion": "#d9381e",
  "Vermillion": "#d9381e",
  "Vermillion Red": "#E34234",
  "Versailles": "#627c56",
  "Vert-Aqua": "#006d95",
  "Vert-Gold": "#d4af37",
  "Very-Peri": "#6667AB",
  "Victoria": "#3263a4",
  "Victoria-Lilac": "#9955bb",
  "Victorian Lilac": "#9955bb",
  "Vintage": "#e7cf8a",
  "Vintage Gold": "#d4af37",
  "Vintage Lilac": "#9955bb",
  "Vintage Pink": "#ffc0cb",
  "Vintage Purple": "#6a0dad",
  "Vintage Rose": "#fbcce7",
  "Vintage Taupe": "#baa68e",
  "Vintage-Blue": "#0000ff",
  "Vintage-Blush": "#de5d83",
  "Vintage-Coral": "#FF7F50",
  "Vintage-Grape": "#e7cf8a",
  "Vintage-Lavender": "#b57edc",
  "Vintage-Lilac": "#9955bb",
  "Vintage-Opal": "#91b660",
  "Vintage-Rose": "#fbcce7",
  "Vintage-Taupe": "#baa68e",
  "Vintage-White": "#ffffff",
  "Violet": "#7f00ff",
  "Violet Gunmetal": "#7f00ff",
  "Violet Iridescent": "#18335e",
  "Violet-Lavender": "#7f00ff",
  "Violet-Purple": "#7f00ff",
  "Violet-Silver": "#c0c0c0",
  "Violet/Fuchsia": "#c74375",
  "Violets-Are-Blue": "#0000ff",
  "Vision": "#1a5a7c",
  "Vison": "#1a5a7c",
  "Vivid-Coral": "#FF7F50",
  "Vivid-Green": "#00a386",
  "Vivid-Viola": "#993c7c",
  "Vizion": "#1a5a7c",
  "Vizon": "#1a5a7c",
  "Warm-Grey": "#808080",
  "Warm-Taupe": "#baa68e",
  "Water": "#d4f1f9",
  "Water-Lily": "#dde3d5",
  "Water-Melon": "#d23b68",
  "Watermelon": "#d23b68",
  "Watermelon Gold": "#d4af37",
  "Watermelon-Nude": "#eeece7",
  "Watermelon/Nude": "#eeece7",
  "Watermelon/Silver": "#c0c0c0",
  "Wdegewood": "#83a3b2",
  "Wedgewood": "#83a3b2",
  "Wedgewood Blue": "#0000ff",
  "Wedgwood": "#83a3b2",
  "Wheat": "#f5deb3",
  "Whisper": "#eae8dd",
  "Whisper Pink": "#ffc0cb",
  "Whispering-Green": "#e2e6d9",
  "White": "#ffffff",
  "White A-B": "#ffffff",
  "White Hot": "#ffffff",
  "White Hot Coral": "#FF7F50",
  "White Ice": "#ffffff",
  "White Iridescent": "#18335e",
  "White Iridescent Blue": "#0000ff",
  "White Iridescent Pink": "#ffc0cb",
  "White Light Blue": "#0000ff",
  "White Light Mint": "#98ff98",
  "White Multi": "#ffffff",
  "White Peri": "#ffffff",
  "White Print": "#ffffff",
  "White Red": "#ff0000",
  "White Rose": "#fbcce7",
  "White Wisteria": "#ffffff",
  "White-AB": "#ffffff",
  "White-Aqua": "#ffffff",
  "White-Beige": "#f5f5dc",
  "White-Black-Emerald": "#000000",
  "White-Black-Red": "#000000",
  "White-Black-Silver": "#000000",
  "White-Blue-Pink": "#0000ff",
  "White-Blush": "#de5d83",
  "White-Coral": "#FF7F50",
  "White-Crystal": "#a7d8de",
  "White-Deep-Periwinkle": "#c3cde6",
  "White-Denim-Silver": "#c0c0c0",
  "White-Floral": "#b57edc",
  "White-Fuschia": "#ffffff",
  "White-Green": "#008001",
  "White-Hot": "#ffffff",
  "White-Ice": "#ffffff",
  "White-Ice-Blue": "#0000ff",
  "White-Ivory": "#fffff0",
  "White-Lame": "#ffffff",
  "White-Light-Blue": "#0000ff",
  "White-Lime": "#00ff00",
  "White-Mauve": "#e0b0ff",
  "White-Melon": "#ffffff",
  "White-Mink-Emerald": "#50c878",
  "White-Multi-Red": "#ff0000",
  "White-Multi-Royal": "#4169e1",
  "White-Navy": "#000080",
  "White-Neon-Pink": "#ffc0cb",
  "White-Neon-Yellow": "#ffff00",
  "White-Nude-Ombre": "#ffffff",
  "White-Orange": "#ffa500",
  "White-Peach": "#ffffff",
  "White-Periwinkle": "#c3cde6",
  "White-Pink": "#ffc0cb",
  "White-Pink-Orchid": "#ffc0cb",
  "White-Powder-Blue": "#0000ff",
  "White-Print": "#ffffff",
  "White-Purple-Black": "#000000",
  "White-Red": "#ff0000",
  "White-Rose": "#fbcce7",
  "White-Rose Gold": "#fbcce7",
  "White-Rose-Gold-Silver": "#fbcce7",
  "White-Royal": "#4169e1",
  "White-Silver": "#c0c0c0",
  "White-Silver-Nude": "#c0c0c0",
  "White-Sky-Blue": "#0000ff",
  "White-Soft-Jade": "#00a86b",
  "White-Turquoise": "#40e0d0",
  "White-White": "#ffffff",
  "White/Aqua": "#ffffff",
  "White/Aqua/Silver": "#c0c0c0",
  "White/Baby Blue": "#0000ff",
  "White/Black": "#000000",
  "White/Black Ombre": "#000000",
  "White/Black/Red": "#000000",
  "White/Blue": "#0000ff",
  "White/Blush": "#de5d83",
  "White/Champagne": "#f7e7ce",
  "White/Coral": "#FF7F50",
  "White/Coral/Silver": "#c0c0c0",
  "White/Fuchsia": "#c74375",
  "White/Fuschia": "#ffffff",
  "White/Gold": "#d4af37",
  "White/Gold/Silver": "#d4af37",
  "White/Grey": "#808080",
  "White/Hot Pink": "#ffc0cb",
  "White/Lavender": "#b57edc",
  "White/Lemon": "#ffffff",
  "White/Lilac": "#9955bb",
  "White/Lilac/Silver": "#9955bb",
  "White/Lipstick": "#ffffff",
  "White/Magenta": "#ff0090",
  "White/Mint": "#98ff98",
  "White/Navy": "#000080",
  "White/Nude": "#ffffff",
  "White/Olive": "#808000",
  "White/Pearl": "#426384",
  "White/Periwinkle": "#c3cde6",
  "White/Pink": "#ffc0cb",
  "White/Pink/Silver": "#ffc0cb",
  "White/Print": "#ffffff",
  "White/Purple": "#6a0dad",
  "White/Purple Ombre": "#6a0dad",
  "White/Red": "#ff0000",
  "White/Rose Gold": "#fbcce7",
  "White/Royal": "#4169e1",
  "White/Silver": "#c0c0c0",
  "White/Turquoise": "#40e0d0",
  "White/White": "#ffffff",
  "White/Wildberry": "#8d4e85",
  "White/Wisteria": "#ffffff",
  "White/Yellow": "#ffff00",
  "Wild Orchid": "#da70d6",
  "Wild Purple": "#6a0dad",
  "Wild-Honey": "#fcebbd",
  "Wild-Orchid": "#da70d6",
  "Wildberry": "#8d4e85",
  "Wine": "#6c5857",
  "Wine Crystal": "#a7d8de",
  "Wine Gold": "#6c5857",
  "Wine Multi": "#6c5857",
  "Wine Ombre": "#6c5857",
  "Wine-Berry": "#6c5857",
  "Wine-Black": "#000000",
  "Wine-Gold": "#6c5857",
  "Wine-Multi": "#6c5857",
  "Wine-Navy": "#000080",
  "Wine-Red": "#ff0000",
  "Wine-Rose": "#fbcce7",
  "Wine-Rose-Gold": "#fbcce7",
  "Wine-Silver": "#6c5857",
  "Wine-Turquoise": "#6c5857",
  "Wine/Black": "#000000",
  "Wine/Gold": "#d4af37",
  "Wine/Green": "#008001",
  "Wine/Nude": "#6c5857",
  "Wine/Turquoise": "#6c5857",
  "Winter Green": "#4F9E81",
  "Winter Mint": "#C8D68C",
  "Winter-Blue": "#9AAFC5",
  "Winter-Green": "#4F9E81",
  "Winter-Mint": "#C8D68C",
  "Winter-Pink": "#EBD0DE",
  "Winter-White": "#ece8d7",
  "Wisteria": "#BDB5D5",
  "Wisteria Nude": "#eeece7",
  "Wood Rose-Lavender": "#fbcce7",
  "Wood-Rose": "#987370",
  "Wow Pink": "#ffc0cb",
  "Wow-Pink": "#ffc0cb",
  "Yellow": "#FFFF00",
  "Yellow Aqua Print": "#ffff00",
  "Yellow Gold": "#FFC000",
  "Yellow Iridescent": "#18335e",
  "Yellow Lilac": "#9955bb",
  "Yellow Multi": "#ffff00",
  "Yellow Ombre": "#ffff00",
  "Yellow Orange": "#ffa500",
  "Yellow Print": "#ffff00",
  "Yellow-Black": "#000000",
  "Yellow-Blue": "#0000ff",
  "Yellow-Gold": "#d4af37",
  "Yellow-Green": "#9acd32",
  "Yellow-Ivory": "#fffff0",
  "Yellow-Ivory-Silver": "#fffff0",
  "Yellow-Ivory-Yellow": "#fffff0",
  "Yellow-Lame": "#ffff00",
  "Yellow-Lilac": "#9955bb",
  "Yellow-Mauve": "#e0b0ff",
  "Yellow-Nude": "#ffff00",
  "Yellow-Pink": "#ffc0cb",
  "Yellow-Print": "#ffff00",
  "Yellow-Purple": "#ffff00",
  "Yellow-Red": "#ff0000",
  "Yellow-Royal": "#ffff00",
  "Yellow-Silver": "#c0c0c0",
  "Yellow-Silver-Print": "#c0c0c0",
  "Yellow-Yellow": "#ffff00",
  "Yellow/Black": "#000000",
  "Yellow/Lilac": "#9955bb",
  "Yellow/Multi Print": "#ffff00",
  "Yellow/Nude": "#ffff00",
  "Yellow/Pink": "#ffc0cb",
  "Yellow/Purple": "#ffff00",
  "Yellow/Silver": "#c0c0c0",
  "Yellow/White": "#ffff00",
  "Zen-Blue": "#0000ff",
  "Zesty-Jade": "#00a86b",
  "Zinfandel Peach": "#ffcba4",
  "Zink": "#bac4c8",
  "Zink-Light-Pink": "#ffc0cb",
  "Zircon": "#a3928f"
}